// Long-tail landing pages (/stay/<slug>) in 7 languages. EN written by hand in scripts/topics_en.json,
// other languages generated once with GPT-5.4 (backend/scripts/translate_topics.py). Edit freely.
export const topics = {
 "en": {
  "nav": "Popular stays",
  "intro": "Find the stay that fits you — every page shows the matching rooms with live direct prices.",
  "roomsHeading": "Rooms that fit this stay",
  "faqHeading": "Good to know",
  "otherHeading": "Other popular searches",
  "from": "from",
  "perNight": "per night",
  "book": "Check availability",
  "topics": [
   {
    "slug": "family-hotel-velika-plaza",
    "filter": "family",
    "title": "Family hotel on Velika Plaža, Ulcinj",
    "metaTitle": "Family Hotel on Velika Plaža, Ulcinj — La Rosa Negra",
    "metaDescription": "Family rooms for 3–5, kids' pool, shallow sandy beach steps away, half board and free parking. Family hotel on Velika Plaža, Ulcinj — best price direct.",
    "intro": [
     "Velika Plaža is 13 km of fine, shallow sand — the safest beach in Montenegro for small children, and Hotel La Rosa Negra stands right beside it. Our family rooms and two-bedroom apartment sleep 3 to 5, with sofa beds, kitchenettes and terraces where the kids can play while you have your coffee.",
     "Half board is included (buffet breakfast and dinner), the pool has a shallow children's section with loungers, and the 60-space private garage means no hunting for parking after a day out at Ada Bojana or the Old Town."
    ],
    "facts": [
     {
      "label": "Family rooms",
      "value": "3–5 guests, sofa beds & kitchenettes"
     },
     {
      "label": "Beach",
      "value": "Shallow sand, 2 minutes on foot"
     },
     {
      "label": "Meals",
      "value": "Half board included"
     },
     {
      "label": "Extras",
      "value": "Baby cot & extra bed on request"
     }
    ],
    "faq": [
     {
      "q": "Do children stay free?",
      "a": "Children up to 2 years stay free in a cot. For older children we recommend a family room or the two-bedroom apartment — the price shown already covers the stated number of guests."
     },
     {
      "q": "Is the beach safe for toddlers?",
      "a": "Yes — Velika Plaža slopes very gently, so the water stays shallow for tens of metres. Lifeguards are on duty in July and August."
     },
     {
      "q": "Can we get a baby cot or high chair?",
      "a": "Both are available free of charge — ask when booking or at reception."
     }
    ]
   },
   {
    "slug": "hotel-with-pool-ulcinj",
    "filter": "pool",
    "title": "Hotel with pool in Ulcinj",
    "metaTitle": "Hotel with Pool in Ulcinj, by the Beach — La Rosa Negra",
    "metaDescription": "Outdoor pool with sun loungers, children's section and poolside rooms, 2 minutes from Velika Plaža. Hotel with pool in Ulcinj — half board and parking included.",
    "intro": [
     "Sea in the morning, pool in the afternoon: Hotel La Rosa Negra has an outdoor pool with free sun loungers and a shallow children's section, surrounded by palms and the hotel terrace. Pool access is included for every guest.",
     "Choose a Double Room by the Pool to step from your door onto the pool deck, or a sea-view room upstairs and watch both the pool and the Adriatic from your balcony."
    ],
    "facts": [
     {
      "label": "Pool",
      "value": "Outdoor, free loungers, kids' section"
     },
     {
      "label": "Season",
      "value": "May – October"
     },
     {
      "label": "Poolside rooms",
      "value": "Double Room by the Pool"
     },
     {
      "label": "Also",
      "value": "Beach 2 min, half board included"
     }
    ],
    "faq": [
     {
      "q": "Is the pool heated?",
      "a": "No — it is an outdoor pool filled with fresh water, comfortable from late May to early October thanks to 2 500 hours of sunshine a year."
     },
     {
      "q": "Are towels and loungers free?",
      "a": "Loungers are free for hotel guests; pool towels are provided at reception."
     },
     {
      "q": "Can children use the pool?",
      "a": "Yes, there is a shallow children's section. Children must be accompanied by an adult."
     }
    ]
   },
   {
    "slug": "half-board-hotel-ulcinj",
    "filter": "all",
    "title": "Half-board hotel in Ulcinj",
    "metaTitle": "Half-Board Hotel in Ulcinj — Breakfast & Dinner Included | La Rosa Negra",
    "metaDescription": "Buffet breakfast and dinner included in every rate. Half-board hotel on Velika Plaža, Ulcinj with pool, parking and sea-view rooms — from €40 per night direct.",
    "intro": [
     "Every room rate at Hotel La Rosa Negra includes half board: a buffet breakfast and a three-course dinner in our restaurant, with Montenegrin and Mediterranean dishes, fresh fish from Ulcinj and vegetarian options every day.",
     "Half board takes the planning out of a beach holiday — come back from the sand, shower, and dinner is ready. Lunch you can take at the beach bars right in front of the hotel."
    ],
    "facts": [
     {
      "label": "Included",
      "value": "Buffet breakfast + 3-course dinner"
     },
     {
      "label": "Cuisine",
      "value": "Montenegrin & Mediterranean, fresh fish"
     },
     {
      "label": "Dietary",
      "value": "Vegetarian daily, allergies on request"
     },
     {
      "label": "Prices",
      "value": "Rooms from €40 per night"
     }
    ],
    "faq": [
     {
      "q": "What time is dinner?",
      "a": "Dinner is served from 19:00 to 21:30; breakfast from 07:30 to 10:00 (hours may shift slightly by season)."
     },
     {
      "q": "Can I book room only?",
      "a": "All our direct rates include half board — it is the best value. Contact reception if you have special requirements."
     },
     {
      "q": "Are drinks included?",
      "a": "Water is included at dinner; other drinks are available at the restaurant bar."
     }
    ]
   },
   {
    "slug": "hotel-near-podgorica-airport",
    "filter": "all",
    "title": "Beach hotel near Podgorica & Tivat airports",
    "metaTitle": "Beach Hotel 90 min from Podgorica & Tivat Airports — La Rosa Negra, Ulcinj",
    "metaDescription": "Fly to Podgorica (TGD) or Tivat (TIV) and be on Velika Plaža in about 90 minutes. Airport transfer €80 per way, free parking, half board. Book direct.",
    "intro": [
     "Ulcinj is served by two Montenegrin airports — Podgorica (TGD, about 85 km) and Tivat (TIV, about 95 km) — both roughly 90 minutes by car from Hotel La Rosa Negra. Tirana airport (TIA) in Albania is a third option at around 2 hours via the Muriqan border.",
     "We arrange private transfers for €80 per way (up to 4 guests) that meet you in the arrivals hall; if you rent a car, our 60-space private garage is free for guests."
    ],
    "facts": [
     {
      "label": "Podgorica (TGD)",
      "value": "≈ 85 km · 1 h 30"
     },
     {
      "label": "Tivat (TIV)",
      "value": "≈ 95 km · 1 h 35"
     },
     {
      "label": "Tirana (TIA)",
      "value": "≈ 130 km · 2 h"
     },
     {
      "label": "Transfer",
      "value": "€80 per way, up to 4 guests"
     }
    ],
    "faq": [
     {
      "q": "How do I book the airport transfer?",
      "a": "Add it in the online check-in or e-mail us your flight number — the driver waits in arrivals with a name board."
     },
     {
      "q": "Is there a bus from the airport?",
      "a": "No direct bus. Take a taxi or bus to Podgorica or Bar bus station and a coach to Ulcinj (hourly in summer), then a taxi to the hotel."
     },
     {
      "q": "Which airport is better?",
      "a": "Podgorica usually has more flights and lower fares; Tivat is more scenic. Driving time to the hotel is almost the same."
     }
    ]
   },
   {
    "slug": "romantic-hotel-ulcinj",
    "filter": "couples",
    "title": "Romantic sea-view hotel in Ulcinj for couples",
    "metaTitle": "Romantic Sea-View Hotel in Ulcinj for Couples — La Rosa Negra",
    "metaDescription": "Sea-view balcony rooms, sunsets over Velika Plaža, dinner included and a romantic set-up on request. Couples' hotel in Ulcinj, Montenegro — book direct.",
    "intro": [
     "The sun sets straight into the Adriatic in front of Hotel La Rosa Negra — watch it from your own sea-view balcony with a glass of Montenegrin Vranac. Our double rooms with sea-view balcony and the twin rooms with shared sea terrace are made for two.",
     "Add the romantic set-up (flowers, fruit and sweets in the room) during online check-in, dine on the terrace with half board included, and take the 20-minute drive to Ada Bojana for a riverside fish dinner."
    ],
    "facts": [
     {
      "label": "Rooms",
      "value": "Sea-view balcony doubles"
     },
     {
      "label": "Sunset",
      "value": "Directly over the sea, west-facing"
     },
     {
      "label": "Romantic set-up",
      "value": "€35 — wine, fruit, flowers"
     },
     {
      "label": "Day trips",
      "value": "Ada Bojana, Old Town, Valdanos bay"
     }
    ],
    "faq": [
     {
      "q": "Can you prepare a surprise for an anniversary?",
      "a": "Yes — choose the romantic set-up in online check-in or write to us; we decorate the room before you arrive."
     },
     {
      "q": "Is the hotel quiet?",
      "a": "The hotel is on the beach road at Velika Plaža, away from the Old Town nightlife; upper-floor sea-view rooms are the quietest."
     },
     {
      "q": "Can we have a late check-out?",
      "a": "Late check-out until 14:00 is €20, subject to availability — bookable in online check-in."
     }
    ]
   },
   {
    "slug": "long-stay-workation-ulcinj",
    "filter": "longstay",
    "title": "Long stay & workation in Ulcinj",
    "metaTitle": "Long Stay & Workation Hotel in Ulcinj, Montenegro — La Rosa Negra",
    "metaDescription": "Stay a week or a month on Velika Plaža: apartments with kitchenette, free WiFi, half board, parking. Long-stay and workation hotel in Ulcinj — ask for a monthly rate.",
    "intro": [
     "Montenegro's digital-nomad visa and 300 days of sunshine make Ulcinj an easy place to work from. Hotel La Rosa Negra offers apartments with a kitchenette and living area, free WiFi throughout, a quiet terrace and a beach for the lunch break.",
     "For stays of 7 nights or more we offer reduced rates, and for a month or longer a tailored price with weekly cleaning — write to us with your dates."
    ],
    "facts": [
     {
      "label": "Apartments",
      "value": "Kitchenette, living area, balcony"
     },
     {
      "label": "WiFi",
      "value": "Free, fibre in all rooms and terrace"
     },
     {
      "label": "Long-stay rates",
      "value": "7+ nights discounted, monthly on request"
     },
     {
      "label": "Also",
      "value": "Half board, pool, free garage"
     }
    ],
    "faq": [
     {
      "q": "Is the WiFi good enough for video calls?",
      "a": "Yes — fibre connection with WiFi in every room and on the terrace; reception can also give you a quiet spot for calls."
     },
     {
      "q": "Can I cook in the room?",
      "a": "The apartments have a kitchenette with hob, fridge and kettle. Half board is still included if you prefer not to cook."
     },
     {
      "q": "How do I get a monthly rate?",
      "a": "E-mail larosaulcinj@gmail.com with your dates and preferred room type — we reply with a personal offer within 24 hours."
     }
    ]
   },
   {
    "slug": "cheap-hotel-ulcinj",
    "filter": "budget",
    "title": "Cheap hotel in Ulcinj on the beach — from €40",
    "metaTitle": "Cheap Beach Hotel in Ulcinj from €40 — La Rosa Negra, Velika Plaža",
    "metaDescription": "Budget rooms from €40 per night with half board, pool and free parking included — 2 minutes from Velika Plaža. The honest cheap hotel in Ulcinj: book direct, save 15 %.",
    "intro": [
     "Cheap does not have to mean far from the beach. Our economy double rooms and single rooms start at €40 per night and still include buffet breakfast, dinner, the pool and the garage — the same beach, the same sunsets as the sea-view rooms.",
     "Booking directly on this site is always at least 15 % cheaper than on Booking.com, and early-bird codes for June and September take another 10 % off."
    ],
    "facts": [
     {
      "label": "From",
      "value": "€40 per night incl. half board"
     },
     {
      "label": "Direct saving",
      "value": "≥ 15 % vs Booking.com"
     },
     {
      "label": "Early bird",
      "value": "−10 % June & September codes"
     },
     {
      "label": "Included",
      "value": "Pool, parking, WiFi, dinner"
     }
    ],
    "faq": [
     {
      "q": "What is the cheapest room?",
      "a": "The Small Single Room from €40 and the Economy Double Room with Balcony (no view) from €60 — both with half board."
     },
     {
      "q": "Why is direct cheaper?",
      "a": "We pay no commission on direct bookings and pass the saving to you; you also get free cancellation up to 24 h before arrival."
     },
     {
      "q": "When is Ulcinj cheapest?",
      "a": "May, June, September and October — great weather, warm sea and prices up to 40 % below July and August."
     }
    ]
   },
   {
    "slug": "hotel-with-parking-ulcinj",
    "filter": "all",
    "title": "Hotel with free parking in Ulcinj",
    "metaTitle": "Hotel with Free Parking in Ulcinj — 60-Space Garage | La Rosa Negra",
    "metaDescription": "Private 60-space garage included in every rate, 2 minutes from Velika Plaža. Hotel with free parking in Ulcinj — ideal for road trips through Montenegro and Albania.",
    "intro": [
     "Arriving by car from Dubrovnik, Podgorica or Tirana? Hotel La Rosa Negra has a private 60-space garage, free for all guests — no street parking stress in high season, and your car stays in the shade.",
     "From the hotel it is 5 km to the Old Town, 20 minutes to Ada Bojana, 45 minutes to Šaško Lake and an hour to Bar and Skadar Lake — Velika Plaža is the perfect base for a Montenegro road trip."
    ],
    "facts": [
     {
      "label": "Parking",
      "value": "60-space private garage, free"
     },
     {
      "label": "EV",
      "value": "Charging on request"
     },
     {
      "label": "Distances",
      "value": "Old Town 5 km · Ada Bojana 15 km · Bar 30 km"
     },
     {
      "label": "Border",
      "value": "Albania (Muriqan) 25 min"
     }
    ],
    "faq": [
     {
      "q": "Do I need to reserve a parking space?",
      "a": "No — the garage is included and there is space for every room. In the rare case it is full, free parking is available next to the hotel."
     },
     {
      "q": "Can I charge an electric car?",
      "a": "Yes, on request at reception (standard socket); fast chargers are available in Ulcinj town."
     },
     {
      "q": "Is the road from Dubrovnik easy?",
      "a": "About 3 h 30 along the coast via Budva and Bar; allow extra time at the Croatian border in July and August."
     }
    ]
   },
   {
    "slug": "hotels-in-ulcinj",
    "filter": "all",
    "title": "Hotels in Ulcinj: which area to choose",
    "metaTitle": "Hotels in Ulcinj — Where to Stay & Prices | La Rosa Negra",
    "metaDescription": "Hotels in Ulcinj, Montenegro: Old Town vs Velika Plaža vs Ada Bojana, what rooms cost in season, and a family-run hotel 2 minutes from Long Beach.",
    "intro": [
     "Ulcinj (Ulqin) has three very different places to sleep. The Old Town and Mala Plaža are lively and historic, with restaurants on the walls, but also stairs, traffic and almost no parking in July and August. Velika Plaža (Long Beach) and the Štoj plain behind it are flat, quiet and family-friendly, with 13 km of shallow sand and most of the town's newer hotels. Ada Bojana, at the far end of the beach, is a remote river island for kitesurfers and naturists.",
     "Hotel La Rosa Negra is on the Velika Plaža side: a family-run 3-star hotel about 2 minutes on foot from the sand, 5 km from the Old Town. The rate includes half board (buffet breakfast and dinner), the outdoor pool, WiFi and a 60-space private garage. Rooms cost €40–150 per night depending on season and view, and booking direct is 10% below our Booking.com price."
    ],
    "facts": [
     {
      "label": "Areas",
      "value": "Old Town · Velika Plaža / Štoj · Ada Bojana"
     },
     {
      "label": "Typical prices",
      "value": "3-star hotel rooms €40–150 per night, half board"
     },
     {
      "label": "Our location",
      "value": "2 min to the sand, 5 km to the Old Town"
     },
     {
      "label": "Getting here",
      "value": "Podgorica or Tivat airport ≈ 90 min, Tirana 2 h"
     }
    ],
    "faq": [
     {
      "q": "Which part of Ulcinj is best for a beach holiday?",
      "a": "Velika Plaža. The sand is fine and shallow for tens of metres, the beach bars rent loungers, and the area is flat and easy with children or a car. The Old Town is better for a city break: more restaurants and nightlife, but the beaches there are small and pebbly and parking is scarce."
     },
     {
      "q": "How much does a hotel in Ulcinj cost?",
      "a": "In July and August a double room in a 3-star hotel is usually €90–150 per night; in June and September €60–100; in spring and autumn from about €40. Our prices include breakfast and dinner, pool and parking, so compare the total, not the room-only rate."
     },
     {
      "q": "How do I get from the airport to a hotel on Velika Plaža?",
      "a": "Podgorica (TGD) and Tivat (TIV) airports are about 80 km / 90 minutes away; Tirana (TIA) is 130 km / 2 hours via the Muriqan border. We arrange a private transfer for €80 one way, or you can take the bus to Ulcinj and a taxi (about €10) for the last 4 km."
     }
    ]
   },
   {
    "slug": "velika-plaza-hotels",
    "filter": "all",
    "title": "Hotels on Velika Plaža (Long Beach), Ulcinj",
    "metaTitle": "Velika Plaža Hotels — Long Beach Ulcinj | La Rosa Negra",
    "metaDescription": "Hotels on Velika Plaža, Ulcinj: 13 km of shallow sand, how close hotels really are to the water, prices by month, and a family-run hotel 2 minutes from the beach.",
    "intro": [
     "Velika Plaža — Long Beach, Plazhi i Madh — runs for about 13 km from Port Milena to the Bojana river. It is the longest beach on the Adriatic east coast and one of the shallowest: the water stays knee-deep for tens of metres, which is why families with small children choose it. The beach itself is protected and largely undeveloped, so the hotels stand behind the coastal road in Štoj and Donji Štoj, a short walk from the sand.",
     "Hotel La Rosa Negra is one of them: about 2 minutes on foot from the water, with an outdoor pool, half board included in every rate, free WiFi and a 60-space private garage. Many rooms have a balcony facing the sea. The Old Town, Ulcinj's restaurants and the bus station are 4–5 km away — a 10-minute drive or a summer beach bus."
    ],
    "facts": [
     {
      "label": "The beach",
      "value": "≈13 km of fine grey sand, very shallow, lifeguards Jul–Aug"
     },
     {
      "label": "Distance to the sand",
      "value": "About 2 minutes on foot from the hotel"
     },
     {
      "label": "Sea temperature",
      "value": "22–26 °C from June to September"
     },
     {
      "label": "Activities",
      "value": "Kitesurfing at the Ada Bojana end, beach bars, cycling path"
     }
    ],
    "faq": [
     {
      "q": "Are there hotels directly on the sand of Velika Plaža?",
      "a": "No. The beach is a protected natural zone, so hotels and apartments stand behind the coastal road in Štoj and Donji Štoj. The closest, including Hotel La Rosa Negra, are about 150 m — 2 minutes on foot — from the water."
     },
     {
      "q": "How far is Velika Plaža from Ulcinj Old Town?",
      "a": "The beach starts about 1.5 km south-east of the town; our part of it is 5 km from the Old Town — around 10 minutes by car or taxi (about €10). In July and August a beach bus runs along the coastal road."
     },
     {
      "q": "When is the best time to stay on Velika Plaža?",
      "a": "June and September give warm sea (23–25 °C), quieter beaches and prices 30–40% below August. July and August are hottest and busiest. From October to May the beach is almost empty and many bars close; the hotel stays open with winter rates."
     }
    ]
   },
   {
    "slug": "sea-view-hotel-ulcinj",
    "filter": "couples",
    "title": "Sea-view hotel rooms in Ulcinj",
    "metaTitle": "Sea View Hotel Ulcinj — Balcony Rooms | La Rosa Negra",
    "metaDescription": "Sea-view balcony rooms in Ulcinj, 2 minutes from Velika Plaža: which rooms face the water, prices by season, half board included. Book direct and save 10%.",
    "intro": [
     "The hotel stands on the flat Štoj plain behind Velika Plaža, so the sea view here is the open Adriatic over the dunes and beach bars rather than a cliff-top panorama. Rooms marked “sea view” face south-west towards the water and get the sunset; rooms on the other side look at the pool and the Rumija mountains. Every balcony has a table and two chairs.",
     "Sea-view doubles are the most requested rooms in July and August, so book early. All rates include half board, the outdoor pool, WiFi and garage parking; direct bookings are 10% below our Booking.com price and can be changed or cancelled according to the rate you pick."
    ],
    "facts": [
     {
      "label": "View",
      "value": "Adriatic over the dunes, sunset side"
     },
     {
      "label": "Balcony",
      "value": "Private, with table and two chairs"
     },
     {
      "label": "Beach",
      "value": "About 2 minutes on foot"
     },
     {
      "label": "Price difference",
      "value": "Typically €10–20 per night above a pool-side room"
     }
    ],
    "faq": [
     {
      "q": "Can I see the sea from the room?",
      "a": "From sea-view rooms, yes — the open Adriatic beyond the dunes and the beach bars, about 150 m away. Ground-floor rooms see less; the upper floors have the clearest view. If the view matters to you, write it in the booking comment and we will assign the best available room."
     },
     {
      "q": "Which rooms have a sea view?",
      "a": "The sea-view double rooms with balcony and some of the family rooms; room names on this site say “sea view” when they face the water. Pool-view rooms are a little cheaper and quieter in the evening."
     },
     {
      "q": "Is a sea-view room worth it in Ulcinj?",
      "a": "For a summer holiday most couples say yes — sunset from the balcony is the highlight of the day. If you spend little time in the room, a pool-view room saves €10–20 per night for the same beach and meals."
     }
    ]
   },
   {
    "slug": "hotel-ulqin",
    "filter": "family",
    "title": "Hotel in Ulqin for guests from Kosovo and Albania",
    "metaTitle": "Hotel Ulqin — Prices for Bajram & Summer Weeks | La Rosa Negra",
    "metaDescription": "Family-run hotel in Ulqin, 2 minutes from Plazhi i Madh: live prices for Bajram, Dita e Verës and the diaspora summer weeks. Albanian spoken, garage, half board.",
    "intro": [
     "Ulqin is the closest sea to Prishtina and Tirana: about 5 hours from Prishtina via the Rruga e Kombit and Shkodër, 2 hours from Tirana and 1 hour from Shkodër through the Muriqan–Sukobin border. Hotel La Rosa Negra stands on the Plazhi i Madh (Velika Plaža) side of town, about 2 minutes on foot from the sand — Albanian is spoken at reception and the 60-space garage means your car is safe for the whole stay.",
     "Every rate includes half board (buffet breakfast and dinner), the outdoor pool with a children's section, WiFi and parking. Family rooms sleep 3–5. Below you see the live direct price for the weeks most of our Kosovar and Albanian guests travel: Fitër and Kurban Bajram, Dita e Verës, 17 February and the diaspora weeks of late July and August — booking direct is 10% below our Booking.com price."
    ],
    "facts": [
     {
      "label": "From Prishtina",
      "value": "≈ 330 km · about 5 h by car via Shkodër"
     },
     {
      "label": "From Tirana / Shkodër",
      "value": "130 km · 2 h / 45 km · 1 h"
     },
     {
      "label": "Language & money",
      "value": "Albanian spoken · euro, cash and card"
     },
     {
      "label": "Included",
      "value": "Half board, pool, WiFi, garage parking"
     }
    ],
    "faq": [
     {
      "q": "How do we get from Kosovo to Ulqin?",
      "a": "By car: Prishtina → Rruga e Kombit → Kukës → Shkodër → Muriqan border → Ulqin, about 5 hours; the border is usually quick outside the peak Friday and Sunday evenings in August. Buses run daily from Prishtina and Tirana to Ulqin in summer; a taxi from the Ulqin bus station to the hotel is about €10."
     },
     {
      "q": "Do you have rooms for the Bajram holidays?",
      "a": "Yes, when the hotel is open for the season — Kurban Bajram in May is within it, Fitër Bajram in March depends on the year. The table on this page shows the live price for each holiday; if it says 'on request', write to us on WhatsApp and we will confirm within a few hours."
     },
     {
      "q": "Can children eat with us at dinner, and is the food halal?",
      "a": "Half board covers everyone in the room, children included. Dinner is a buffet with fish, grilled meat, vegetables and salads. Like most hotels in Ulcinj we cook without pork, and the hotel is alcohol-free — a calm choice that many families from Kosovo, Albania and the diaspora appreciate."
     }
    ]
   },
   {
    "slug": "plazhi-i-madh-ulqin",
    "filter": "all",
    "title": "Plazhi i Madh, Ulqin — hotel 2 minutes from the sand",
    "metaTitle": "Plazhi i Madh Ulqin — Hotel 2 Min from the Beach | La Rosa Negra",
    "metaDescription": "Plazhi i Madh (Velika Plaža), Ulqin: 13 km of shallow sand, prices for the Kosovo & Albania summer weeks, and a family-run hotel 2 minutes from the beach.",
    "intro": [
     "Plazhi i Madh — Velika Plaža, the Long Beach — is 13 km of fine, shallow sand from Port Milena to the Buna river. The water stays knee-deep for tens of metres, which is why families from Kosovo and Albania have come here for generations. Beach bars rent loungers (about €10–15 a set in season), lifeguards work in July and August, and the Ada Bojana end is the kitesurfing spot.",
     "Hotel La Rosa Negra is about 2 minutes on foot from the sand, with sea-view balconies, an outdoor pool, half board in every rate and a private garage. The Old Town of Ulqin with its restaurants is 5 km away. The prices below are live for the weeks most of our Albanian-speaking guests travel; book direct and pay 10% less than on Booking.com."
    ],
    "facts": [
     {
      "label": "The beach",
      "value": "13 km of shallow sand · lifeguards Jul–Aug"
     },
     {
      "label": "Distance from the hotel",
      "value": "About 2 minutes on foot"
     },
     {
      "label": "Sea",
      "value": "23–26 °C from June to September"
     },
     {
      "label": "Old Town",
      "value": "5 km · taxi about €10 · summer beach bus"
     }
    ],
    "faq": [
     {
      "q": "Is Plazhi i Madh good for small children?",
      "a": "It is the shallowest beach on this coast — the sand slopes very gently, so children can play in knee-deep water far from the shore. Bring shade for midday; the hotel also has a children's pool section."
     },
     {
      "q": "How crowded is it in August?",
      "a": "The diaspora weeks (late July to mid-August) are the busiest of the year — book early, arrive at the beach before 10:00 for the first rows of loungers, and expect queues at the Muriqan border on Friday and Sunday evenings. Late August and September are much quieter with the same warm sea."
     },
     {
      "q": "Where do we park?",
      "a": "In our 60-space private garage, included in the price. On the beach road itself parking is paid and scarce in summer, so most guests leave the car at the hotel and walk."
     }
    ]
   },
   {
    "slug": "halal-friendly-family-hotel-ulcinj",
    "filter": "family",
    "title": "Alcohol-free family hotel in Ulcinj, 2 minutes from Velika Plaža",
    "metaTitle": "Alcohol-Free Family Hotel in Ulcinj (Ulqin) near Velika Plaža | La Rosa Negra",
    "metaDescription": "Calm family hotel in Ulcinj / Ulqin, 2 minutes from Velika Plaža (Plazhi i Madh): half board, pool with children's section, free garage, Albanian spoken, no alcohol served. Live prices for Bajram and the diaspora summer weeks.",
    "intro": [
     "Hotel La Rosa Negra is a family-run, three-star hotel on the Velika Plaža (Plazhi i Madh) side of Ulcinj, about 2 minutes on foot from the sand. It is a calm place: no bar scene, no alcohol served, children running between the pool and the beach, parents on the terrace with a coffee. Families from Kosovo, Albania, North Macedonia and the diaspora in Germany, Switzerland and Austria come back year after year — many of them for the same two weeks every summer.",
     "Half board is included in every rate — a buffet breakfast and a buffet dinner with fish, grilled meat, vegetables, salads and sweets, cooked the way Ulcinj kitchens cook; drinks at dinner are juices, soft drinks, water, coffee and tea. Family rooms sleep 3–5, the outdoor pool has a children's section, the 60-space garage is free and Albanian, Montenegrin, English and German are spoken at reception. Below you see the live direct price for the weeks our guests travel most — Fitër and Kurban Bajram, Dita e Verës and the diaspora weeks of late July and August — always 10% below our Booking.com price."
    ],
    "facts": [
     {
      "label": "Families",
      "value": "Rooms for 3–5 · children's pool · 2 min to the beach"
     },
     {
      "label": "Atmosphere",
      "value": "Quiet, alcohol-free hotel · terrace café"
     },
     {
      "label": "Included",
      "value": "Half board, pool, WiFi, garage parking"
     },
     {
      "label": "Languages",
      "value": "Albanian, Montenegrin, English, German"
     }
    ],
    "faq": [
     {
      "q": "Is the food suitable for Muslim families?",
      "a": "Yes — like most hotels in Ulcinj, our kitchen cooks without pork, and no alcohol is used in the kitchen or served in the hotel. We do not hold a formal halal certificate; if that matters to you, write to us before you book and we will tell you honestly how the meat is sourced."
     },
     {
      "q": "Is there really no alcohol, even in the room fridge or on the terrace?",
      "a": "Correct — the hotel is alcohol-free. The room fridges are empty for your own drinks, the café serves coffee, tea, fresh juices and soft drinks, and nothing alcoholic is sold at dinner or on the terrace. Guests who want a glass of wine find it in the beach restaurants 150 m away."
     },
     {
      "q": "Can we come for Bajram or the summer holidays with a big family?",
      "a": "Yes. Family rooms sleep up to 5, and if you travel as a larger group tell us and we will try to place you in neighbouring rooms. The table on this page shows the live price for Kurban Bajram, Fitër Bajram and the diaspora weeks — if a row says 'on request', send us a WhatsApp and we confirm within a few hours."
     }
    ]
   }
  ]
 },
 "me": {
  "nav": "Popularni boravci",
  "intro": "Pronađite boravak koji vam odgovara — svaka stranica prikazuje odgovarajuće sobe sa ažurnim direktnim cijenama.",
  "roomsHeading": "Sobe koje odgovaraju ovom boravku",
  "faqHeading": "Dobro je znati",
  "otherHeading": "Ostale popularne pretrage",
  "from": "od",
  "perNight": "po noćenju",
  "book": "Provjerite dostupnost",
  "topics": [
   {
    "slug": "family-hotel-velika-plaza",
    "filter": "family",
    "title": "Porodični hotel na Velikoj Plaži, Ulcinj",
    "metaTitle": "Porodični hotel na Velikoj Plaži, Ulcinj — La Rosa Negra",
    "metaDescription": "Porodične sobe za 3–5 osoba, dječji bazen, plitka pješčana plaža na par koraka, polupansion i besplatan parking. Porodični hotel na Velikoj Plaži, Ulcinj — najbolja cijena direktno.",
    "intro": [
     "Velika Plaža ima 13 km finog, plitkog pijeska — najbezbjednija plaža u Crnoj Gori za malu djecu, a Hotel La Rosa Negra nalazi se odmah pored nje. Naše porodične sobe i dvosobni apartman primaju od 3 do 5 osoba, sa sofama na razvlačenje, čajnim kuhinjama i terasama gdje djeca mogu da se igraju dok vi pijete kafu.",
     "Polupansion je uključen (švedski sto za doručak i večeru), bazen ima plitki dio za djecu sa ležaljkama, a privatna garaža sa 60 mjesta znači da nema traženja parkinga nakon izleta na Ada Bojana ili u Stari grad."
    ],
    "facts": [
     {
      "label": "Porodične sobe",
      "value": "3–5 gostiju, sofe na razvlačenje i čajne kuhinje"
     },
     {
      "label": "Plaža",
      "value": "Plitki pijesak, 2 minuta pješke"
     },
     {
      "label": "Obroci",
      "value": "Polupansion uključen"
     },
     {
      "label": "Dodaci",
      "value": "Dječji krevetac i pomoćni ležaj na upit"
     }
    ],
    "faq": [
     {
      "q": "Da li djeca borave besplatno?",
      "a": "Djeca do 2 godine borave besplatno u krevecu. Za stariju djecu preporučujemo porodičnu sobu ili dvosobni apartman — prikazana cijena već obuhvata navedeni broj gostiju."
     },
     {
      "q": "Da li je plaža bezbjedna za malu djecu?",
      "a": "Da — Velika Plaža ima veoma blag ulaz, pa voda ostaje plitka desetinama metara. Spasioci dežuraju u julu i avgustu."
     },
     {
      "q": "Možemo li dobiti dječji krevetac ili hranilicu?",
      "a": "Oboje je dostupno besplatno — tražite prilikom rezervacije ili na recepciji."
     }
    ]
   },
   {
    "slug": "hotel-with-pool-ulcinj",
    "filter": "pool",
    "title": "Hotel sa bazenom u Ulcinju",
    "metaTitle": "Hotel sa bazenom u Ulcinju, uz plažu — La Rosa Negra",
    "metaDescription": "Otvoreni bazen sa ležaljkama, dječjim dijelom i sobama uz bazen, 2 minuta od Velike Plaže. Hotel sa bazenom u Ulcinju — polupansion i parking uključeni.",
    "intro": [
     "More ujutro, bazen popodne: Hotel La Rosa Negra ima otvoreni bazen sa besplatnim ležaljkama i plitkim dijelom za djecu, okružen palmama i hotelskom terasom. Korišćenje bazena uključeno je za svakog gosta.",
     "Izaberite Dvokrevetnu sobu uz bazen i izađite direktno iz sobe na prostor oko bazena, ili sobu sa pogledom na more na spratu i sa balkona posmatrajte i bazen i Jadran."
    ],
    "facts": [
     {
      "label": "Bazen",
      "value": "Otvoreni, besplatne ležaljke, dio za djecu"
     },
     {
      "label": "Sezona",
      "value": "maj – oktobar"
     },
     {
      "label": "Sobe uz bazen",
      "value": "Dvokrevetna soba uz bazen"
     },
     {
      "label": "Takođe",
      "value": "Plaža 2 min, polupansion uključen"
     }
    ],
    "faq": [
     {
      "q": "Da li je bazen grijan?",
      "a": "Ne — to je otvoreni bazen sa slatkom vodom, prijatan od kraja maja do početka oktobra zahvaljujući 2 500 sunčanih sati godišnje."
     },
     {
      "q": "Da li su peškiri i ležaljke besplatni?",
      "a": "Ležaljke su besplatne za hotelske goste; peškiri za bazen dostupni su na recepciji."
     },
     {
      "q": "Mogu li djeca koristiti bazen?",
      "a": "Da, postoji plitki dio za djecu. Djeca moraju biti u pratnji odrasle osobe."
     }
    ]
   },
   {
    "slug": "half-board-hotel-ulcinj",
    "filter": "all",
    "title": "Hotel sa polupansionom u Ulcinju",
    "metaTitle": "Hotel sa polupansionom u Ulcinju — doručak i večera uključeni | La Rosa Negra",
    "metaDescription": "Švedski sto za doručak i večeru uključen je u svaku cijenu. Hotel sa polupansionom na Velikoj Plaži, Ulcinj sa bazenom, parkingom i sobama sa pogledom na more — od €40 po noćenju direktno.",
    "intro": [
     "Svaka cijena sobe u Hotelu La Rosa Negra uključuje polupansion: švedski sto za doručak i večeru od tri slijeda u našem restoranu, sa crnogorskim i mediteranskim jelima, svježom ribom iz Ulcinja i vegetarijanskim opcijama svakog dana.",
     "Polupansion vam olakšava planiranje odmora na plaži — vratite se sa pijeska, istuširajte se, i večera je spremna. Ručak možete uzeti u plažnim restoranima odmah ispred hotela."
    ],
    "facts": [
     {
      "label": "Uključeno",
      "value": "Švedski sto doručak + večera od 3 slijeda"
     },
     {
      "label": "Kuhinja",
      "value": "Crnogorska i mediteranska, svježa riba"
     },
     {
      "label": "Posebna ishrana",
      "value": "Vegetarijanski svakodnevno, alergije na upit"
     },
     {
      "label": "Cijene",
      "value": "Sobe od €40 po noćenju"
     }
    ],
    "faq": [
     {
      "q": "U koje vrijeme je večera?",
      "a": "Večera se služi od 19:00 do 21:30; doručak od 07:30 do 10:00 (termini se mogu blago mijenjati zavisno od sezone)."
     },
     {
      "q": "Mogu li rezervisati samo sobu?",
      "a": "Sve naše direktne cijene uključuju polupansion — to je najbolji odnos cijene i usluge. Kontaktirajte recepciju ako imate posebne zahtjeve."
     },
     {
      "q": "Da li su pića uključena?",
      "a": "Voda je uključena uz večeru; ostala pića dostupna su u restoranskom baru."
     }
    ]
   },
   {
    "slug": "hotel-near-podgorica-airport",
    "filter": "all",
    "title": "Hotel na plaži blizu aerodroma Podgorica i Tivat",
    "metaTitle": "Hotel na plaži 90 min od aerodroma Podgorica i Tivat — La Rosa Negra, Ulcinj",
    "metaDescription": "Sletite u Podgoricu (TGD) ili Tivat (TIV) i stignite na Veliku Plažu za oko 90 minuta. Aerodromski transfer €80 u jednom pravcu, besplatan parking, polupansion. Rezervišite direktno.",
    "intro": [
     "Ulcinj opslužuju dva crnogorska aerodroma — Podgorica (TGD, oko 85 km) i Tivat (TIV, oko 95 km) — oba su otprilike 90 minuta vožnje od Hotela La Rosa Negra. Aerodrom Tirana (TIA) u Albaniji je treća opcija, oko 2 sata vožnje preko graničnog prelaza Muriqan.",
     "Organizujemo privatne transfere za €80 u jednom pravcu (do 4 gosta) koji vas dočekuju u dolaznom holu; ako iznajmite automobil, naša privatna garaža sa 60 mjesta je besplatna za goste."
    ],
    "facts": [
     {
      "label": "Podgorica (TGD)",
      "value": "≈ 85 km · 1 h 30"
     },
     {
      "label": "Tivat (TIV)",
      "value": "≈ 95 km · 1 h 35"
     },
     {
      "label": "Tirana (TIA)",
      "value": "≈ 130 km · 2 h"
     },
     {
      "label": "Transfer",
      "value": "€80 u jednom pravcu, do 4 gosta"
     }
    ],
    "faq": [
     {
      "q": "Kako da rezervišem aerodromski transfer?",
      "a": "Dodajte ga tokom online check-ina ili nam pošaljite broj leta e-mailom — vozač čeka u dolascima sa tablom sa vašim imenom."
     },
     {
      "q": "Da li postoji autobus sa aerodroma?",
      "a": "Ne postoji direktan autobus. Uzmite taksi ili autobus do autobuske stanice u Podgorici ili Baru, pa autobus do Ulcinja (na svakih sat vremena ljeti), zatim taksi do hotela."
     },
     {
      "q": "Koji aerodrom je bolji?",
      "a": "Podgorica obično ima više letova i niže cijene; Tivat je slikovitiji. Vrijeme vožnje do hotela je gotovo isto."
     }
    ]
   },
   {
    "slug": "romantic-hotel-ulcinj",
    "filter": "couples",
    "title": "Romantični hotel sa pogledom na more u Ulcinju za parove",
    "metaTitle": "Romantični hotel sa pogledom na more u Ulcinju za parove — La Rosa Negra",
    "metaDescription": "Sobe sa balkonom i pogledom na more, zalasci sunca nad Velikom Plažom, večera uključena i romantična dekoracija na upit. Hotel za parove u Ulcinju, Crna Gora — rezervišite direktno.",
    "intro": [
     "Sunce zalazi pravo u Jadran ispred Hotela La Rosa Negra — posmatrajte to sa svog balkona sa pogledom na more uz čašu crnogorskog Vranca. Naše dvokrevetne sobe sa balkonom i pogledom na more i twin sobe sa zajedničkom terasom okrenutom ka moru stvorene su za dvoje.",
     "Dodajte romantičnu dekoraciju (cvijeće, voće i slatkiši u sobi) tokom online check-ina, večerajte na terasi uz uključen polupansion i odvezite se 20 minuta do Ada Bojana na riblju večeru uz rijeku."
    ],
    "facts": [
     {
      "label": "Sobe",
      "value": "Dvokrevetne sa balkonom i pogledom na more"
     },
     {
      "label": "Zalazak sunca",
      "value": "Direktno nad morem, zapadna strana"
     },
     {
      "label": "Romantična dekoracija",
      "value": "€35 — vino, voće, cvijeće"
     },
     {
      "label": "Izleti",
      "value": "Ada Bojana, Stari grad, uvala Valdanos"
     }
    ],
    "faq": [
     {
      "q": "Možete li pripremiti iznenađenje za godišnjicu?",
      "a": "Da — izaberite romantičnu dekoraciju tokom online check-ina ili nam pišite; sobu dekoriramo prije vašeg dolaska."
     },
     {
      "q": "Da li je hotel miran?",
      "a": "Hotel se nalazi na putu uz plažu na Velikoj Plaži, dalje od noćnog života Starog grada; sobe na višim spratovima sa pogledom na more su najmirnije."
     },
     {
      "q": "Možemo li imati kasnu odjavu?",
      "a": "Kasna odjava do 14:00 je €20, zavisno od dostupnosti — može se rezervisati tokom online check-ina."
     }
    ]
   },
   {
    "slug": "long-stay-workation-ulcinj",
    "filter": "longstay",
    "title": "Dugi boravak i workation u Ulcinju",
    "metaTitle": "Hotel za dugi boravak i workation u Ulcinju, Crna Gora — La Rosa Negra",
    "metaDescription": "Ostanite sedmicu ili mjesec na Velikoj Plaži: apartmani sa čajnom kuhinjom, besplatan WiFi, polupansion, parking. Hotel za dugi boravak i workation u Ulcinju — tražite mjesečnu cijenu.",
    "intro": [
     "Crnogorska viza za digitalne nomade i 300 sunčanih dana čine Ulcinj lakim mjestom za rad na daljinu. Hotel La Rosa Negra nudi apartmane sa čajnom kuhinjom i dnevnim boravkom, besplatan WiFi u cijelom objektu, mirnu terasu i plažu za pauzu za ručak.",
     "Za boravke od 7 noći ili više nudimo snižene cijene, a za mjesec ili duže prilagođenu ponudu sa sedmičnim čišćenjem — pišite nam sa svojim datumima."
    ],
    "facts": [
     {
      "label": "Apartmani",
      "value": "Čajna kuhinja, dnevni boravak, balkon"
     },
     {
      "label": "WiFi",
      "value": "Besplatan, optika u svim sobama i na terasi"
     },
     {
      "label": "Cijene za duži boravak",
      "value": "7+ noći s popustom, mjesečno na upit"
     },
     {
      "label": "Takođe",
      "value": "Polupansion, bazen, besplatna garaža"
     }
    ],
    "faq": [
     {
      "q": "Da li je WiFi dovoljno dobar za video pozive?",
      "a": "Da — optička konekcija sa WiFi signalom u svakoj sobi i na terasi; recepcija vam može obezbijediti i mirno mjesto za pozive."
     },
     {
      "q": "Mogu li kuvati u sobi?",
      "a": "Apartmani imaju čajnu kuhinju sa pločom za kuvanje, frižiderom i kuvalom za vodu. Polupansion je i dalje uključen ako ne želite da kuvate."
     },
     {
      "q": "Kako da dobijem mjesečnu cijenu?",
      "a": "Pošaljite e-mail na larosaulcinj@gmail.com sa svojim datumima i željenim tipom sobe — odgovaramo personalizovanom ponudom u roku od 24 sata."
     }
    ]
   },
   {
    "slug": "cheap-hotel-ulcinj",
    "filter": "budget",
    "title": "Povoljan hotel u Ulcinju na plaži — od €40",
    "metaTitle": "Povoljan hotel na plaži u Ulcinju od €40 — La Rosa Negra, Velika Plaža",
    "metaDescription": "Povoljne sobe od €40 po noćenju sa uključenim polupansionom, bazenom i besplatnim parkingom — 2 minuta od Velike Plaže. Pošten povoljan hotel u Ulcinju: rezervišite direktno, uštedite 15 %.",
    "intro": [
     "Povoljno ne mora značiti daleko od plaže. Naše economy dvokrevetne sobe i jednokrevetne sobe počinju od €40 po noćenju i i dalje uključuju švedski sto za doručak, večeru, bazen i garažu — ista plaža, isti zalasci sunca kao i iz soba sa pogledom na more.",
     "Rezervacija direktno na ovom sajtu uvijek je najmanje 15 % jeftinija nego na Booking.com, a early-bird kodovi za jun i septembar donose dodatnih 10 % popusta."
    ],
    "facts": [
     {
      "label": "Od",
      "value": "€40 po noćenju uklj. polupansion"
     },
     {
      "label": "Direktna ušteda",
      "value": "≥ 15 % u odnosu na Booking.com"
     },
     {
      "label": "Early bird",
      "value": "−10 % kodovi za jun i septembar"
     },
     {
      "label": "Uključeno",
      "value": "Bazen, parking, WiFi, večera"
     }
    ],
    "faq": [
     {
      "q": "Koja je najjeftinija soba?",
      "a": "Mala jednokrevetna soba od €40 i Economy dvokrevetna soba sa balkonom (bez pogleda) od €60 — obje sa polupansionom."
     },
     {
      "q": "Zašto je direktno jeftinije?",
      "a": "Ne plaćamo proviziju na direktne rezervacije i tu uštedu prenosimo vama; takođe dobijate besplatno otkazivanje do 24 h prije dolaska."
     },
     {
      "q": "Kada je Ulcinj najjeftiniji?",
      "a": "Maj, jun, septembar i oktobar — odlično vrijeme, toplo more i cijene do 40 % niže nego u julu i avgustu."
     }
    ]
   },
   {
    "slug": "hotel-with-parking-ulcinj",
    "filter": "all",
    "title": "Hotel sa besplatnim parkingom u Ulcinju",
    "metaTitle": "Hotel sa besplatnim parkingom u Ulcinju — garaža sa 60 mjesta | La Rosa Negra",
    "metaDescription": "Privatna garaža sa 60 mjesta uključena u svaku cijenu, 2 minuta od Velike Plaže. Hotel sa besplatnim parkingom u Ulcinju — idealan za putovanja automobilom kroz Crnu Goru i Albaniju.",
    "intro": [
     "Dolazite automobilom iz Dubrovnika, Podgorice ili Tirane? Hotel La Rosa Negra ima privatnu garažu sa 60 mjesta, besplatnu za sve goste — bez stresa sa uličnim parkingom u špicu sezone, a vaš automobil ostaje u hladu.",
     "Od hotela je 5 km do Starog grada, 20 minuta do Ada Bojana, 45 minuta do Šaskog jezera i sat vremena do Bara i Skadarskog jezera — Velika Plaža je savršena baza za putovanje automobilom kroz Crnu Goru."
    ],
    "facts": [
     {
      "label": "Parking",
      "value": "Privatna garaža sa 60 mjesta, besplatno"
     },
     {
      "label": "EV",
      "value": "Punjenje na upit"
     },
     {
      "label": "Udaljenosti",
      "value": "Stari grad 5 km · Ada Bojana 15 km · Bar 30 km"
     },
     {
      "label": "Granica",
      "value": "Albanija (Muriqan) 25 min"
     }
    ],
    "faq": [
     {
      "q": "Da li treba da rezervišem parking mjesto?",
      "a": "Ne — garaža je uključena i ima mjesta za svaku sobu. U rijetkom slučaju da je puna, besplatan parking je dostupan pored hotela."
     },
     {
      "q": "Mogu li puniti električni automobil?",
      "a": "Da, na upit na recepciji (standardna utičnica); brzi punjači dostupni su u gradu Ulcinju."
     },
     {
      "q": "Da li je put iz Dubrovnika lak?",
      "a": "Oko 3 h 30 duž obale preko Budve i Bara; računajte na dodatno vrijeme na hrvatskoj granici u julu i avgustu."
     }
    ]
   },
   {
    "slug": "hotels-in-ulcinj",
    "filter": "all",
    "title": "Hoteli u Ulcinju: koji dio odabrati",
    "metaTitle": "Hoteli u Ulcinju — Gdje odsjesti i cijene | La Rosa Negra",
    "metaDescription": "Hoteli u Ulcinju, Crna Gora: Stari grad ili Velika Plaža ili Ada Bojana, koliko koštaju sobe u sezoni i porodični hotel 2 minute od Velike plaže.",
    "intro": [
     "Ulcinj (Ulqin) ima tri veoma različita mjesta za noćenje. Stari grad i Mala Plaža su živahni i istorijski, sa restoranima na zidinama, ali i sa stepenicama, saobraćajem i gotovo bez parkinga u julu i avgustu. Velika Plaža i ravnica Štoja iza nje su ravne, mirne i pogodne za porodice, sa 13 km plitkog pijeska i većinom novijih hotelskih objekata u gradu. Ada Bojana, na krajnjem dijelu plaže, udaljeno je riječno ostrvo za kitesurfere i naturiste.",
     "Hotel La Rosa Negra nalazi se na strani Velike Plaže: porodični hotel sa 3 zvjezdice, oko 2 minute hoda od pijeska, 5 km od Starog grada. U cijenu su uključeni polupansion (doručak i večera na bazi švedskog stola), otvoreni bazen, WiFi i privatna garaža sa 60 mjesta. Sobe koštaju €40–150 po noći, u zavisnosti od sezone i pogleda, a direktna rezervacija je 10% niža od naše cijene na Booking.com."
    ],
    "facts": [
     {
      "label": "Područja",
      "value": "Stari grad · Velika Plaža / Štoj · Ada Bojana"
     },
     {
      "label": "Tipične cijene",
      "value": "Sobe u hotelu sa 3 zvjezdice €40–150 po noći, polupansion"
     },
     {
      "label": "Naša lokacija",
      "value": "2 min do pijeska, 5 km do Starog grada"
     },
     {
      "label": "Kako stići",
      "value": "Aerodrom Podgorica ili Tivat ≈ 90 min, Tirana 2 h"
     }
    ],
    "faq": [
     {
      "q": "Koji dio Ulcinja je najbolji za odmor na plaži?",
      "a": "Velika Plaža. Pijesak je sitan, more plitko desetinama metara, plažni restorani izdaju ležaljke, a područje je ravno i jednostavno za kretanje s djecom ili automobilom. Stari grad je bolji za gradski odmor: više restorana i noćnog života, ali su tamošnje plaže male i šljunkovite, a parking je ograničen."
     },
     {
      "q": "Koliko košta hotel u Ulcinju?",
      "a": "U julu i avgustu dvokrevetna soba u hotelu sa 3 zvjezdice obično košta €90–150 po noći; u junu i septembru €60–100; u proljeće i jesen od oko €40. Naše cijene uključuju doručak i večeru, bazen i parking, pa upoređujte ukupnu cijenu, a ne samo cijenu sobe."
     },
     {
      "q": "Kako da stignem od aerodroma do hotela na Velikoj Plaži?",
      "a": "Aerodromi Podgorica (TGD) i Tivat (TIV) udaljeni su oko 80 km / 90 minuta; Tirana (TIA) je 130 km / 2 sata preko graničnog prelaza Muriqan. Organizujemo privatni transfer za €80 u jednom smjeru, ili možete autobusom do Ulcinja pa taksijem (oko €10) za posljednja 4 km."
     }
    ]
   },
   {
    "slug": "velika-plaza-hotels",
    "filter": "all",
    "title": "Hoteli na Velikoj Plaži, Ulcinj",
    "metaTitle": "Hoteli na Velikoj Plaži — Ulcinj | La Rosa Negra",
    "metaDescription": "Hoteli na Velikoj Plaži, Ulcinj: 13 km plitkog pijeska, koliko su hoteli zaista blizu vodi, cijene po mjesecima i porodični hotel 2 minute od plaže.",
    "intro": [
     "Velika Plaža — Long Beach, Plazhi i Madh — proteže se oko 13 km od Port Milene do rijeke Bojane. To je najduža plaža na istočnoj obali Jadrana i jedna od najplićih: voda ostaje do koljena desetinama metara, zbog čega je biraju porodice s malom djecom. Sama plaža je zaštićena i uglavnom neizgrađena, pa se hoteli nalaze iza obalnog puta u Štoju i Donjem Štoju, na kratkoj pješačkoj udaljenosti od pijeska.",
     "Hotel La Rosa Negra je jedan od njih: oko 2 minute hoda od vode, sa otvorenim bazenom, polupansionom uključenim u svaku cijenu, besplatnim WiFi-jem i privatnom garažom sa 60 mjesta. Mnoge sobe imaju balkon okrenut prema moru. Stari grad, restorani u Ulcinju i autobuska stanica udaljeni su 4–5 km — 10 minuta vožnje ili ljetnjom autobuskom linijom za plažu."
    ],
    "facts": [
     {
      "label": "Plaža",
      "value": "≈13 km sitnog sivog pijeska, veoma plitko, spasioci jul–avgust"
     },
     {
      "label": "Udaljenost do pijeska",
      "value": "Oko 2 minute hoda od hotela"
     },
     {
      "label": "Temperatura mora",
      "value": "22–26 °C od juna do septembra"
     },
     {
      "label": "Aktivnosti",
      "value": "Kitesurfing na dijelu prema Adi Bojani, plažni restorani, biciklistička staza"
     }
    ],
    "faq": [
     {
      "q": "Ima li hotela direktno na pijesku Velike Plaže?",
      "a": "Ne. Plaža je zaštićena prirodna zona, pa se hoteli i apartmani nalaze iza obalnog puta u Štoju i Donjem Štoju. Najbliži, uključujući Hotel La Rosa Negra, udaljeni su oko 150 m — 2 minute hoda — od vode."
     },
     {
      "q": "Koliko je Velika Plaža udaljena od Starog grada u Ulcinju?",
      "a": "Plaža počinje oko 1,5 km jugoistočno od grada; naš dio je 5 km od Starog grada — oko 10 minuta automobilom ili taksijem (oko €10). U julu i avgustu ljetnja autobuska linija saobraća duž obalnog puta."
     },
     {
      "q": "Kada je najbolje boraviti na Velikoj Plaži?",
      "a": "Jun i septembar nude toplo more (23–25 °C), mirnije plaže i cijene 30–40% niže nego u avgustu. Jul i avgust su najtopliji i najprometniji. Od oktobra do maja plaža je gotovo prazna i mnogi plažni restorani su zatvoreni; hotel ostaje otvoren sa zimskim cijenama."
     }
    ]
   },
   {
    "slug": "sea-view-hotel-ulcinj",
    "filter": "couples",
    "title": "Hotelske sobe s pogledom na more u Ulcinju",
    "metaTitle": "Hotel s pogledom na more u Ulcinju — Sobe s balkonom | La Rosa Negra",
    "metaDescription": "Sobe s balkonom i pogledom na more u Ulcinju, 2 minute od Velike Plaže: koje sobe gledaju na vodu, cijene po sezoni, polupansion uključen. Rezervišite direktno i uštedite 10%.",
    "intro": [
     "Hotel se nalazi na ravnoj ravnici Štoja iza Velike Plaže, pa pogled na more ovdje znači otvoreni Jadran preko dina i plažnih restorana, a ne panoramu s litice. Sobe označene kao „pogled na more” okrenute su jugozapadno prema vodi i imaju zalazak sunca; sobe s druge strane gledaju na bazen i planinu Rumiju. Svaki balkon ima sto i dvije stolice.",
     "Dvokrevetne sobe s pogledom na more najtraženije su u julu i avgustu, zato rezervišite ranije. Sve cijene uključuju polupansion, otvoreni bazen, WiFi i parking u garaži; direktne rezervacije su 10% niže od naše cijene na Booking.com i mogu se izmijeniti ili otkazati prema tarifi koju odaberete."
    ],
    "facts": [
     {
      "label": "Pogled",
      "value": "Jadran preko dina, strana zalaska sunca"
     },
     {
      "label": "Balkon",
      "value": "Privatan, sa stolom i dvije stolice"
     },
     {
      "label": "Plaža",
      "value": "Oko 2 minute hoda"
     },
     {
      "label": "Razlika u cijeni",
      "value": "Obično €10–20 po noći više od sobe okrenute bazenu"
     }
    ],
    "faq": [
     {
      "q": "Mogu li vidjeti more iz sobe?",
      "a": "Iz soba s pogledom na more, da — otvoreni Jadran iza dina i plažnih restorana, udaljen oko 150 m. Sobe u prizemlju imaju slabiji pogled; viši spratovi imaju najjasniji pogled. Ako vam je pogled važan, napišite to u komentaru prilikom rezervacije i dodijelićemo vam najbolju dostupnu sobu."
     },
     {
      "q": "Koje sobe imaju pogled na more?",
      "a": "Dvokrevetne sobe s balkonom i pogledom na more i neke porodične sobe; nazivi soba na ovom sajtu sadrže „pogled na more” kada su okrenute prema vodi. Sobe s pogledom na bazen su malo jeftinije i mirnije uveče."
     },
     {
      "q": "Da li se isplati uzeti sobu s pogledom na more u Ulcinju?",
      "a": "Za ljetnji odmor većina parova kaže da — zalazak sunca s balkona je vrhunac dana. Ako provodite malo vremena u sobi, soba s pogledom na bazen štedi €10–20 po noći, uz istu plažu i obroke."
     }
    ]
   },
   {
    "slug": "hotel-ulqin",
    "filter": "family",
    "title": "Hotel u Ulqinju za goste iz Kosova i Albanije",
    "metaTitle": "Hotel Ulqin — Cijene za Bajram i ljetnje sedmice | La Rosa Negra",
    "metaDescription": "Porodični hotel u Ulqinju, 2 minuta od Plazhi i Madh: aktuelne cijene za Ramazanski i Kurban bajram, Dita e Verës i ljetnje sedmice dijaspore. Govori se albanski, garažni parking, polupansion.",
    "intro": [
     "Ulqin je najbliže more Prištini i Tirani: oko 5 sati od Prištine preko Rruga e Kombit i Skadra, 2 sata od Tirane i 1 sat od Skadra preko graničnog prelaza Muriqan–Sukobin. Hotel La Rosa Negra nalazi se na strani grada prema Plazhi i Madh (Velika Plaža), oko 2 minuta pješice od pijeska — na recepciji se govori albanski, a garaža sa 60 mjesta znači da je vaš automobil bezbjedan tokom cijelog boravka.",
     "Svaka cijena uključuje polupansion (doručak i večeru na bazi švedskog stola), vanjski bazen s dječjim dijelom, WiFi i parking. Porodične sobe primaju 3–5 osoba. Ispod vidite aktuelnu direktnu cijenu za sedmice kada putuje većina naših gostiju s Kosova i iz Albanije: Ramazanski i Kurban bajram, Dita e Verës, 17. februar i sedmice dijaspore krajem jula i u avgustu — direktna rezervacija je 10% niža od naše cijene na Booking.com."
    ],
    "facts": [
     {
      "label": "Iz Prištine",
      "value": "≈ 330 km · oko 5 h vožnje preko Skadra"
     },
     {
      "label": "Iz Tirane / Skadra",
      "value": "130 km · 2 h / 45 km · 1 h"
     },
     {
      "label": "Jezik i novac",
      "value": "Govori se albanski · euro, gotovina i kartica"
     },
     {
      "label": "Uključeno",
      "value": "Polupansion, bazen, WiFi, garažni parking"
     }
    ],
    "faq": [
     {
      "q": "Kako stižemo iz Kosova do Ulqinja?",
      "a": "Automobilom: Priština → Rruga e Kombit → Kukës → Skadar → granični prelaz Muriqan → Ulqin, oko 5 sati; granica je obično brza van udarnih termina petkom i nedjeljom uveče u avgustu. Autobusi ljeti svakodnevno voze iz Prištine i Tirane za Ulqin; taksi od autobuske stanice u Ulqinju do hotela je oko €10."
     },
     {
      "q": "Imate li sobe za bajramske praznike?",
      "a": "Da, kada je hotel otvoren za sezonu — Kurban bajram u maju spada u nju, dok Ramazanski bajram u martu zavisi od godine. Tabela na ovoj stranici prikazuje aktuelnu cijenu za svaki praznik; ako piše 'na upit', pišite nam na WhatsApp i potvrdićemo u roku od nekoliko sati."
     },
     {
      "q": "Mogu li djeca večerati s nama i da li je hrana halal?",
      "a": "Polupansion obuhvata sve u sobi, uključujući djecu. Večera je švedski sto s ribom, mesom sa roštilja, povrćem i salatama. Kao i većina hotela u Ulcinju, kuvamo bez svinjetine, a hotel je bez alkohola — miran izbor koji cijene mnoge porodice s Kosova, iz Albanije i dijaspore."
     }
    ]
   },
   {
    "slug": "plazhi-i-madh-ulqin",
    "filter": "all",
    "title": "Plazhi i Madh, Ulqin — hotel 2 minuta od pijeska",
    "metaTitle": "Plazhi i Madh Ulqin — Hotel 2 min od plaže | La Rosa Negra",
    "metaDescription": "Plazhi i Madh (Velika Plaža), Ulqin: 13 km plitkog pijeska za porodice, cijene za ljetnje sedmice za goste iz Kosova i Albanije i porodični hotel 2 minuta od plaže s polupansionom i bazenom.",
    "intro": [
     "Plazhi i Madh — Velika Plaža, Long Beach — ima 13 km sitnog, plitkog pijeska od Port Milene do rijeke Bojane. Voda ostaje do koljena desetinama metara, zbog čega porodice s Kosova i iz Albanije dolaze ovdje generacijama. Barovi na plaži iznajmljuju ležaljke (oko €10–15 za set u sezoni), spasioci rade u julu i avgustu, a kraj prema Ada Bojani je mjesto za kitesurfing.",
     "Hotel La Rosa Negra je oko 2 minuta pješice od pijeska, sa balkonima s pogledom na more, vanjskim bazenom, polupansionom u svakoj cijeni i privatnom garažom. Stari grad Ulqinja sa svojim restoranima udaljen je 5 km. Cijene ispod su aktuelne za sedmice kada putuje većina naših gostiju koji govore albanski; rezervišite direktno i platite 10% manje nego na Booking.com."
    ],
    "facts": [
     {
      "label": "Plaža",
      "value": "13 km plitkog pijeska · spasioci jul–avg"
     },
     {
      "label": "Udaljenost od hotela",
      "value": "Oko 2 minuta pješice"
     },
     {
      "label": "More",
      "value": "23–26 °C od juna do septembra"
     },
     {
      "label": "Stari grad",
      "value": "5 km · taksi oko €10 · ljetnji autobus za plažu"
     }
    ],
    "faq": [
     {
      "q": "Da li je Plazhi i Madh dobar za malu djecu?",
      "a": "To je najplića plaža na ovom dijelu obale — pijesak se vrlo blago spušta, pa se djeca mogu igrati u vodi do koljena daleko od obale. Ponesite hlad za podne; hotel takođe ima dječji dio bazena."
     },
     {
      "q": "Kolika je gužva u avgustu?",
      "a": "Sedmice dijaspore (od kraja jula do sredine avgusta) najprometniji su dio godine — rezervišite rano, dođite na plažu prije 10:00 za prve redove ležaljki i računajte na gužve na granici Muriqan petkom i nedjeljom uveče. Kraj avgusta i septembar mnogo su mirniji, uz isto toplo more."
     },
     {
      "q": "Gdje parkiramo?",
      "a": "U našoj privatnoj garaži sa 60 mjesta, uključeno u cijenu. Na samom putu uz plažu parking se ljeti plaća i teško nalazi, pa većina gostiju ostavi automobil u hotelu i ide pješice."
     }
    ]
   },
   {
    "slug": "halal-friendly-family-hotel-ulcinj",
    "filter": "family",
    "title": "Porodični hotel bez alkohola u Ulcinju, 2 minute od Velike Plaže",
    "metaTitle": "Porodični hotel bez alkohola u Ulcinju (Ulqin) blizu Velike Plaže | La Rosa Negra",
    "metaDescription": "Miran porodični hotel u Ulcinju / Ulqin, 2 minute od Velike Plaže (Plazhi i Madh): polupansion, bazen s dječijim dijelom, besplatna garaža, govori se albanski, ne služi se alkohol. Aktuelne cijene za Bajram i ljetnje sedmice dijaspore.",
    "intro": [
     "Hotel La Rosa Negra je porodični hotel s tri zvjezdice na strani Velike Plaže (Plazhi i Madh) u Ulcinju, oko 2 minute hoda od pijeska. To je mirno mjesto: nema barske scene, ne služi se alkohol, djeca trče između bazena i plaže, roditelji sjede na terasi uz kafu. Porodice s Kosova, iz Albanije, Sjeverne Makedonije i dijaspore u Njemačkoj, Švajcarskoj i Austriji vraćaju se iz godine u godinu — mnoge od njih baš za iste dvije sedmice svakog ljeta.",
     "Polupansion je uključen u svaku cijenu — švedski sto za doručak i švedski sto za večeru s ribom, mesom s roštilja, povrćem, salatama i slatkišima, pripremljeno onako kako kuvaju kuhinje u Ulcinju; pića uz večeru su sokovi, bezalkoholna pića, voda, kafa i čaj. Porodične sobe primaju 3–5 osoba, vanjski bazen ima dječiji dio, garaža sa 60 mjesta je besplatna, a na recepciji se govore albanski, crnogorski, engleski i njemački. Ispod vidite aktuelnu direktnu cijenu za sedmice kada naši gosti najviše putuju — Fitër i Kurban Bajram, Dita e Verës i sedmice dijaspore krajem jula i u avgustu — uvijek 10% nižu od naše cijene na Booking.com."
    ],
    "facts": [
     {
      "label": "Porodice",
      "value": "Sobe za 3–5 · dječiji bazen · 2 min do plaže"
     },
     {
      "label": "Atmosfera",
      "value": "Miran hotel bez alkohola · kafić na terasi"
     },
     {
      "label": "Uključeno",
      "value": "Polupansion, bazen, WiFi, parking u garaži"
     },
     {
      "label": "Jezici",
      "value": "Albanski, crnogorski, engleski, njemački"
     }
    ],
    "faq": [
     {
      "q": "Da li je hrana pogodna za muslimanske porodice?",
      "a": "Da — kao i u većini hotela u Ulcinju, u našoj kuhinji se ne priprema svinjetina, a alkohol se ne koristi u kuhinji niti se služi u hotelu. Nemamo formalni halal certifikat; ako vam je to važno, pišite nam prije rezervacije i iskreno ćemo vam reći kako se nabavlja meso."
     },
     {
      "q": "Da li zaista nema alkohola, čak ni u frižideru u sobi ili na terasi?",
      "a": "Tačno — hotel je bez alkohola. Frižideri u sobama su prazni za vaša pića, kafić služi kafu, čaj, svježe sokove i bezalkoholna pića, a ništa alkoholno se ne prodaje ni uz večeru ni na terasi. Gosti koji žele čašu vina mogu je naći u restoranima na plaži udaljenim 150 m."
     },
     {
      "q": "Možemo li doći za Bajram ili ljetnji odmor s velikom porodicom?",
      "a": "Da. Porodične sobe primaju do 5 osoba, a ako putujete kao veća grupa, recite nam i pokušaćemo da vas smjestimo u susjedne sobe. Tabela na ovoj stranici prikazuje aktuelnu cijenu za Kurban Bajram, Fitër Bajram i sedmice dijaspore — ako u nekom redu piše 'na upit', pošaljite nam WhatsApp poruku i potvrdićemo u roku od nekoliko sati."
     }
    ]
   }
  ]
 },
 "sq": {
  "nav": "Qëndrimet e njohura",
  "intro": "Gjeni qëndrimin që ju përshtatet — çdo faqe tregon dhomat përkatëse me çmime direkte në kohë reale.",
  "roomsHeading": "Dhomat që i përshtaten këtij qëndrimi",
  "faqHeading": "Mirë të dini",
  "otherHeading": "Kërkime të tjera të njohura",
  "from": "nga",
  "perNight": "për natë",
  "book": "Kontrollo disponueshmërinë",
  "topics": [
   {
    "slug": "family-hotel-velika-plaza",
    "filter": "family",
    "title": "Hotel familjar në Velika Plaža, Ulqin",
    "metaTitle": "Hotel Familjar në Velika Plaža, Ulqin — La Rosa Negra",
    "metaDescription": "Dhoma familjare për 3–5 persona, pishinë për fëmijë, plazh ranor i cekët vetëm pak hapa larg, gjysmë pansion dhe parkim falas. Hotel familjar në Velika Plaža, Ulqin — çmimi më i mirë direkt.",
    "intro": [
     "Velika Plaža është 13 km rërë e imët dhe e cekët — plazhi më i sigurt në Mal të Zi për fëmijët e vegjël, dhe Hotel La Rosa Negra ndodhet pikërisht pranë saj. Dhomat tona familjare dhe apartamenti me dy dhoma gjumi akomodojnë 3 deri në 5 persona, me divanë-krevat, kuzhina të vogla dhe tarraca ku fëmijët mund të luajnë ndërsa ju pini kafenë.",
     "Gjysmë pansion është i përfshirë (mëngjes dhe darkë bufet), pishina ka një pjesë të cekët për fëmijë me shezllone, dhe garazhi privat me 60 vende do të thotë se nuk keni nevojë të kërkoni parkim pas një dite në Ada Bojana ose në Qytetin e Vjetër."
    ],
    "facts": [
     {
      "label": "Dhoma familjare",
      "value": "3–5 mysafirë, divanë-krevat & kuzhina të vogla"
     },
     {
      "label": "Plazhi",
      "value": "Rërë e cekët, 2 minuta në këmbë"
     },
     {
      "label": "Vaktet",
      "value": "Gjysmë pansion i përfshirë"
     },
     {
      "label": "Shtesa",
      "value": "Krevat për bebe & krevat shtesë sipas kërkesës"
     }
    ],
    "faq": [
     {
      "q": "A qëndrojnë fëmijët falas?",
      "a": "Fëmijët deri në 2 vjeç qëndrojnë falas në krevat për bebe. Për fëmijët më të rritur rekomandojmë një dhomë familjare ose apartamentin me dy dhoma gjumi — çmimi i shfaqur tashmë mbulon numrin e deklaruar të mysafirëve."
     },
     {
      "q": "A është plazhi i sigurt për fëmijët e vegjël?",
      "a": "Po — Velika Plaža zbret shumë butë, kështu që uji mbetet i cekët për dhjetëra metra. Rojat e plazhit janë në detyrë në korrik dhe gusht."
     },
     {
      "q": "A mund të marrim krevat për bebe ose karrige të lartë për fëmijë?",
      "a": "Të dyja janë në dispozicion pa pagesë — kërkoni gjatë rezervimit ose në recepsion."
     }
    ]
   },
   {
    "slug": "hotel-with-pool-ulcinj",
    "filter": "pool",
    "title": "Hotel me pishinë në Ulqin",
    "metaTitle": "Hotel me Pishinë në Ulqin, pranë Plazhit — La Rosa Negra",
    "metaDescription": "Pishinë e jashtme me shezllone, pjesë për fëmijë dhe dhoma pranë pishinës, 2 minuta nga Velika Plaža. Hotel me pishinë në Ulqin — gjysmë pansion dhe parkim të përfshirë.",
    "intro": [
     "Deti në mëngjes, pishina pasdite: Hotel La Rosa Negra ka një pishinë të jashtme me shezllone falas dhe një pjesë të cekët për fëmijë, e rrethuar me palma dhe tarracën e hotelit. Hyrja në pishinë është e përfshirë për çdo mysafir.",
     "Zgjidhni një Dhomë Dyshe pranë Pishinës për të dalë direkt nga dera në zonën e pishinës, ose një dhomë me pamje nga deti në katet e sipërme dhe shikoni si pishinën ashtu edhe Adriatikun nga ballkoni juaj."
    ],
    "facts": [
     {
      "label": "Pishina",
      "value": "E jashtme, shezllone falas, pjesë për fëmijë"
     },
     {
      "label": "Sezoni",
      "value": "Maj – Tetor"
     },
     {
      "label": "Dhoma pranë pishinës",
      "value": "Dhomë Dyshe pranë Pishinës"
     },
     {
      "label": "Gjithashtu",
      "value": "Plazhi 2 min, gjysmë pansion i përfshirë"
     }
    ],
    "faq": [
     {
      "q": "A është pishina me ngrohje?",
      "a": "Jo — është një pishinë e jashtme e mbushur me ujë të freskët, e rehatshme nga fundi i majit deri në fillim të tetorit falë 2 500 orëve diell në vit."
     },
     {
      "q": "A janë peshqirët dhe shezllonet falas?",
      "a": "Shezllonet janë falas për mysafirët e hotelit; peshqirët e pishinës merren në recepsion."
     },
     {
      "q": "A mund ta përdorin fëmijët pishinën?",
      "a": "Po, ka një pjesë të cekët për fëmijë. Fëmijët duhet të shoqërohen nga një i rritur."
     }
    ]
   },
   {
    "slug": "half-board-hotel-ulcinj",
    "filter": "all",
    "title": "Hotel me gjysmë pansion në Ulqin",
    "metaTitle": "Hotel me Gjysmë Pansion në Ulqin — Mëngjesi & Darka të Përfshira | La Rosa Negra",
    "metaDescription": "Mëngjesi dhe darka bufet të përfshira në çdo tarifë. Hotel me gjysmë pansion në Velika Plaža, Ulqin me pishinë, parkim dhe dhoma me pamje nga deti — nga €40 për natë direkt.",
    "intro": [
     "Çdo tarifë dhome në Hotel La Rosa Negra përfshin gjysmë pansion: mëngjes bufet dhe darkë me tre pjata në restorantin tonë, me gatime malazeze dhe mesdhetare, peshk të freskët nga Ulqin dhe opsione vegjetariane çdo ditë.",
     "Gjysmë pansion ju heq planifikimin nga pushimet në plazh — ktheheni nga rëra, bëni dush, dhe darka është gati. Drekën mund ta hani në restorantet e plazhit pikërisht përballë hotelit."
    ],
    "facts": [
     {
      "label": "E përfshirë",
      "value": "Mëngjes bufet + darkë me 3 pjata"
     },
     {
      "label": "Kuzhina",
      "value": "Malazeze & Mesdhetare, peshk i freskët"
     },
     {
      "label": "Dietike",
      "value": "Vegjetariane çdo ditë, alergji sipas kërkesës"
     },
     {
      "label": "Çmimet",
      "value": "Dhomat nga €40 për natë"
     }
    ],
    "faq": [
     {
      "q": "Në çfarë ore është darka?",
      "a": "Darka shërbehet nga 19:00 deri në 21:30; mëngjesi nga 07:30 deri në 10:00 (orarët mund të ndryshojnë pak sipas sezonit)."
     },
     {
      "q": "A mund të rezervoj vetëm dhomën?",
      "a": "Të gjitha tarifat tona direkte përfshijnë gjysmë pansion — është vlera më e mirë. Kontaktoni recepsionin nëse keni kërkesa të veçanta."
     },
     {
      "q": "A përfshihen pijet?",
      "a": "Uji përfshihet në darkë; pijet e tjera janë të disponueshme në barin e restorantit."
     }
    ]
   },
   {
    "slug": "hotel-near-podgorica-airport",
    "filter": "all",
    "title": "Hotel plazhi pranë aeroporteve të Podgoricës & Tivatit",
    "metaTitle": "Hotel Plazhi 90 min nga Aeroportet e Podgoricës & Tivatit — La Rosa Negra, Ulqin",
    "metaDescription": "Fluturoni për në Podgoricë (TGD) ose Tivat (TIV) dhe mbërrini në Velika Plaža për rreth 90 minuta. Transfer nga aeroporti €80 për një drejtim, parkim falas, gjysmë pansion. Rezervoni direkt.",
    "intro": [
     "Ulqini shërbehet nga dy aeroporte malazeze — Podgorica (TGD, rreth 85 km) dhe Tivat (TIV, rreth 95 km) — të dy rreth 90 minuta me makinë nga Hotel La Rosa Negra. Aeroporti i Tiranës (TIA) në Shqipëri është një opsion i tretë rreth 2 orë larg përmes kufirit të Muriqanit.",
     "Ne organizojmë transfere private për €80 për një drejtim (deri në 4 mysafirë) që ju presin në sallën e mbërritjeve; nëse merrni makinë me qira, garazhi ynë privat me 60 vende është falas për mysafirët."
    ],
    "facts": [
     {
      "label": "Podgorica (TGD)",
      "value": "≈ 85 km · 1 h 30"
     },
     {
      "label": "Tivat (TIV)",
      "value": "≈ 95 km · 1 h 35"
     },
     {
      "label": "Tirana (TIA)",
      "value": "≈ 130 km · 2 h"
     },
     {
      "label": "Transferi",
      "value": "€80 për një drejtim, deri në 4 mysafirë"
     }
    ],
    "faq": [
     {
      "q": "Si ta rezervoj transferin nga aeroporti?",
      "a": "Shtojeni gjatë check-in online ose na dërgoni me e-mail numrin e fluturimit — shoferi ju pret te mbërritjet me një tabelë me emrin tuaj."
     },
     {
      "q": "A ka autobus nga aeroporti?",
      "a": "Jo autobus direkt. Merrni një taksi ose autobus për në stacionin e autobusëve në Podgoricë ose Bar dhe pastaj një autobus për në Ulqin (çdo orë në verë), pastaj taksi për në hotel."
     },
     {
      "q": "Cili aeroport është më i mirë?",
      "a": "Podgorica zakonisht ka më shumë fluturime dhe tarifa më të ulëta; Tivati është më panoramik. Koha e udhëtimit me makinë deri te hoteli është pothuajse e njëjtë."
     }
    ]
   },
   {
    "slug": "romantic-hotel-ulcinj",
    "filter": "couples",
    "title": "Hotel romantik me pamje nga deti në Ulqin për çifte",
    "metaTitle": "Hotel Romantik me Pamje nga Deti në Ulqin për Çifte — La Rosa Negra",
    "metaDescription": "Dhoma me ballkon dhe pamje nga deti, perëndime dielli mbi Velika Plaža, darka e përfshirë dhe set-up romantik sipas kërkesës. Hotel për çifte në Ulqin, Mali i Zi — rezervoni direkt.",
    "intro": [
     "Dielli perëndon drejt e në Adriatik përpara Hotel La Rosa Negra — shikojeni nga ballkoni juaj privat me pamje nga deti me një gotë Vranac malazez. Dhomat tona dyshe me ballkon dhe pamje nga deti dhe dhomat twin me tarracë të përbashkët nga deti janë krijuar për dy persona.",
     "Shtoni set-up-in romantik (lule, fruta dhe ëmbëlsira në dhomë) gjatë check-in online, darkoni në tarracë me gjysmë pansion të përfshirë, dhe bëni 20 minuta me makinë deri në Ada Bojana për një darkë me peshk pranë lumit."
    ],
    "facts": [
     {
      "label": "Dhomat",
      "value": "Dhoma dyshe me ballkon dhe pamje nga deti"
     },
     {
      "label": "Perëndimi i diellit",
      "value": "Direkt mbi det, nga perëndimi"
     },
     {
      "label": "Set-up romantik",
      "value": "€35 — verë, fruta, lule"
     },
     {
      "label": "Ekskursione ditore",
      "value": "Ada Bojana, Qyteti i Vjetër, gjiri i Valdanosit"
     }
    ],
    "faq": [
     {
      "q": "A mund të përgatisni një surprizë për përvjetor?",
      "a": "Po — zgjidhni set-up-in romantik gjatë check-in online ose na shkruani; ne e dekorojmë dhomën para mbërritjes suaj."
     },
     {
      "q": "A është hoteli i qetë?",
      "a": "Hoteli ndodhet në rrugën e plazhit në Velika Plaža, larg jetës së natës të Qytetit të Vjetër; dhomat me pamje nga deti në katet e sipërme janë më të qetat."
     },
     {
      "q": "A mund të kemi late check-out?",
      "a": "Late check-out deri në 14:00 kushton €20, sipas disponueshmërisë — mund të rezervohet gjatë check-in online."
     }
    ]
   },
   {
    "slug": "long-stay-workation-ulcinj",
    "filter": "longstay",
    "title": "Qëndrim i gjatë & workation në Ulqin",
    "metaTitle": "Hotel për Qëndrim të Gjatë & Workation në Ulqin, Mali i Zi — La Rosa Negra",
    "metaDescription": "Qëndroni një javë ose një muaj në Velika Plaža: apartamente me kuzhinë të vogël, WiFi falas, gjysmë pansion, parkim. Hotel për qëndrim të gjatë dhe workation në Ulqin — kërkoni tarifë mujore.",
    "intro": [
     "Viza e Malit të Zi për nomadët digjitalë dhe 300 ditë me diell e bëjnë Ulqinin një vend të lehtë për të punuar. Hotel La Rosa Negra ofron apartamente me kuzhinë të vogël dhe hapësirë ndenjjeje, WiFi falas në të gjithë ambientin, një tarracë të qetë dhe plazhin për pushimin e drekës.",
     "Për qëndrime prej 7 netësh ose më shumë ne ofrojmë tarifa të reduktuara, dhe për një muaj ose më gjatë një çmim të përshtatur me pastrim javor — na shkruani me datat tuaja."
    ],
    "facts": [
     {
      "label": "Apartamentet",
      "value": "Kuzhinë e vogël, hapësirë ndenjjeje, ballkon"
     },
     {
      "label": "WiFi",
      "value": "Falas, fibër në të gjitha dhomat dhe tarracën"
     },
     {
      "label": "Tarifat për qëndrim të gjatë",
      "value": "7+ net me zbritje, mujore sipas kërkesës"
     },
     {
      "label": "Gjithashtu",
      "value": "Gjysmë pansion, pishinë, garazh falas"
     }
    ],
    "faq": [
     {
      "q": "A është WiFi mjaftueshëm i mirë për video-thirrje?",
      "a": "Po — lidhje me fibër dhe WiFi në çdo dhomë dhe në tarracë; recepsioni mund t'ju ofrojë edhe një vend të qetë për telefonata."
     },
     {
      "q": "A mund të gatuaj në dhomë?",
      "a": "Apartamentet kanë kuzhinë të vogël me pllakë gatimi, frigorifer dhe çajnik. Gjysmë pansion është sërish i përfshirë nëse preferoni të mos gatuani."
     },
     {
      "q": "Si mund të marr një tarifë mujore?",
      "a": "Dërgoni e-mail në larosaulcinj@gmail.com me datat tuaja dhe llojin e preferuar të dhomës — ju përgjigjemi me një ofertë personale brenda 24 orësh."
     }
    ]
   },
   {
    "slug": "cheap-hotel-ulcinj",
    "filter": "budget",
    "title": "Hotel i lirë në Ulqin pranë plazhit — nga €40",
    "metaTitle": "Hotel i Lirë pranë Plazhit në Ulqin nga €40 — La Rosa Negra, Velika Plaža",
    "metaDescription": "Dhoma ekonomike nga €40 për natë me gjysmë pansion, pishinë dhe parkim falas të përfshirë — 2 minuta nga Velika Plaža. Hoteli i lirë dhe i ndershëm në Ulqin: rezervoni direkt, kurseni 15 %.",
    "intro": [
     "I lirë nuk do të thotë domosdoshmërisht larg plazhit. Dhomat tona ekonomike dyshe dhe dhomat teke fillojnë nga €40 për natë dhe ende përfshijnë mëngjes bufet, darkë, pishinën dhe garazhin — i njëjti plazh, të njëjtat perëndime si dhomat me pamje nga deti.",
     "Rezervimi direkt në këtë faqe është gjithmonë të paktën 15 % më i lirë se në Booking.com, dhe kodet early-bird për qershor dhe shtator japin edhe 10 % zbritje shtesë."
    ],
    "facts": [
     {
      "label": "Nga",
      "value": "€40 për natë me gjysmë pansion të përfshirë"
     },
     {
      "label": "Kursim direkt",
      "value": "≥ 15 % krahasuar me Booking.com"
     },
     {
      "label": "Early bird",
      "value": "−10 % kodet për Qershor & Shtator"
     },
     {
      "label": "E përfshirë",
      "value": "Pishinë, parkim, WiFi, darkë"
     }
    ],
    "faq": [
     {
      "q": "Cila është dhoma më e lirë?",
      "a": "Dhoma Teke e Vogël nga €40 dhe Dhoma Dyshe Economy me Ballkon (pa pamje) nga €60 — të dyja me gjysmë pansion."
     },
     {
      "q": "Pse është më lirë direkt?",
      "a": "Ne nuk paguajmë komision për rezervimet direkte dhe kursimin jua kalojmë juve; gjithashtu merrni anulim falas deri në 24 h para mbërritjes."
     },
     {
      "q": "Kur është Ulqini më i lirë?",
      "a": "Maj, qershor, shtator dhe tetor — mot i shkëlqyer, det i ngrohtë dhe çmime deri në 40 % më të ulëta se në korrik dhe gusht."
     }
    ]
   },
   {
    "slug": "hotel-with-parking-ulcinj",
    "filter": "all",
    "title": "Hotel me parkim falas në Ulqin",
    "metaTitle": "Hotel me Parkim Falas në Ulqin — Garazh me 60 Vende | La Rosa Negra",
    "metaDescription": "Garazh privat me 60 vende i përfshirë në çdo tarifë, 2 minuta nga Velika Plaža. Hotel me parkim falas në Ulqin — ideal për udhëtime rrugore nëpër Mal të Zi dhe Shqipëri.",
    "intro": [
     "Po vini me makinë nga Dubrovniku, Podgorica apo Tirana? Hotel La Rosa Negra ka një garazh privat me 60 vende, falas për të gjithë mysafirët — pa stres për parkim në rrugë gjatë sezonit të lartë, dhe makina juaj mbetet në hije.",
     "Nga hoteli janë 5 km deri te Qyteti i Vjetër, 20 minuta deri në Ada Bojana, 45 minuta deri te Liqeni i Shasit dhe një orë deri në Bar dhe Liqenin e Shkodrës — Velika Plaža është baza e përsosur për një road trip në Mal të Zi."
    ],
    "facts": [
     {
      "label": "Parkimi",
      "value": "Garazh privat me 60 vende, falas"
     },
     {
      "label": "EV",
      "value": "Karikim sipas kërkesës"
     },
     {
      "label": "Distancat",
      "value": "Qyteti i Vjetër 5 km · Ada Bojana 15 km · Bar 30 km"
     },
     {
      "label": "Kufiri",
      "value": "Shqipëria (Muriqan) 25 min"
     }
    ],
    "faq": [
     {
      "q": "A duhet të rezervoj një vend parkimi?",
      "a": "Jo — garazhi është i përfshirë dhe ka vend për çdo dhomë. Në rastin e rrallë që mbushet, parkim falas ka pranë hotelit."
     },
     {
      "q": "A mund të karikoj një makinë elektrike?",
      "a": "Po, sipas kërkesës në recepsion (prizë standarde); karikues të shpejtë ka në qytetin e Ulqinit."
     },
     {
      "q": "A është e lehtë rruga nga Dubrovniku?",
      "a": "Rreth 3 h 30 përgjatë bregdetit përmes Budvës dhe Barit; lini kohë shtesë në kufirin kroat në korrik dhe gusht."
     }
    ]
   },
   {
    "slug": "hotels-in-ulcinj",
    "filter": "all",
    "title": "Hotele në Ulqin: cilën zonë të zgjidhni",
    "metaTitle": "Hotele në Ulqin — Ku të qëndroni & Çmimet | La Rosa Negra",
    "metaDescription": "Hotele në Ulqin, Mali i Zi: Qyteti i Vjetër kundrejt Velika Plaža kundrejt Ada Bojana, sa kushtojnë dhomat në sezon dhe një hotel familjar 2 minuta nga Long Beach.",
    "intro": [
     "Ulqini (Ulcinj) ka tre vende shumë të ndryshme për të fjetur. Qyteti i Vjetër dhe Mala Plaža janë të gjalla dhe historike, me restorante mbi mure, por edhe me shkallë, trafik dhe pothuajse pa parkim në korrik dhe gusht. Velika Plaža (Long Beach) dhe fusha e Štoj pas saj janë të sheshta, të qeta dhe miqësore për familje, me 13 km rërë të cekët dhe shumicën e hoteleve më të reja të qytetit. Ada Bojana, në skajin më të largët të plazhit, është një ishull lumor i largët për kitesurferë dhe naturistë.",
     "Hotel La Rosa Negra është në anën e Velika Plaža: një hotel familjar me 3 yje rreth 2 minuta në këmbë nga rëra, 5 km nga Qyteti i Vjetër. Çmimi përfshin gjysmë pensionin (mëngjes dhe darkë bufet), pishinën e jashtme, WiFi dhe një garazh privat me 60 vende. Dhomat kushtojnë €40–150 për natë në varësi të sezonit dhe pamjes, dhe rezervimi direkt është 10% më i lirë se çmimi ynë në Booking.com."
    ],
    "facts": [
     {
      "label": "Zonat",
      "value": "Qyteti i Vjetër · Velika Plaža / Štoj · Ada Bojana"
     },
     {
      "label": "Çmime tipike",
      "value": "Dhoma hoteli me 3 yje €40–150 për natë, gjysmë pension"
     },
     {
      "label": "Vendndodhja jonë",
      "value": "2 min deri te rëra, 5 km deri te Qyteti i Vjetër"
     },
     {
      "label": "Si të vini këtu",
      "value": "Aeroporti i Podgoricës ose Tivat ≈ 90 min, Tirana 2 h"
     }
    ],
    "faq": [
     {
      "q": "Cila pjesë e Ulqinit është më e mira për një pushim plazhi?",
      "a": "Velika Plaža. Rëra është e imët dhe e cekët për dhjetëra metra, restorantet e plazhit japin shezlongë me qira, dhe zona është e sheshtë dhe e lehtë për familjet me fëmijë ose me makinë. Qyteti i Vjetër është më i mirë për një city break: më shumë restorante dhe jetë nate, por plazhet atje janë të vegjël dhe me gurë dhe parkimi është i pakët."
     },
     {
      "q": "Sa kushton një hotel në Ulqin?",
      "a": "Në korrik dhe gusht një dhomë dyshe në një hotel me 3 yje zakonisht kushton €90–150 për natë; në qershor dhe shtator €60–100; në pranverë dhe vjeshtë nga rreth €40. Çmimet tona përfshijnë mëngjesin dhe darkën, pishinën dhe parkimin, prandaj krahasoni totalin, jo vetëm çmimin e dhomës."
     },
     {
      "q": "Si të shkoj nga aeroporti te një hotel në Velika Plaža?",
      "a": "Aeroportet e Podgoricës (TGD) dhe Tivat (TIV) janë rreth 80 km / 90 minuta larg; Tirana (TIA) është 130 km / 2 orë përmes kufirit të Muriqanit. Ne organizojmë transfer privat për €80 një drejtim, ose mund të merrni autobusin për në Ulqin dhe një taksi (rreth €10) për 4 km e fundit."
     }
    ]
   },
   {
    "slug": "velika-plaza-hotels",
    "filter": "all",
    "title": "Hotele në Velika Plaža (Long Beach), Ulqin",
    "metaTitle": "Hotele në Velika Plaža — Long Beach Ulqin | La Rosa Negra",
    "metaDescription": "Hotele në Velika Plaža, Ulqin: 13 km rërë e cekët, sa afër ujit janë realisht hotelet, çmime sipas muajit dhe një hotel familjar 2 minuta nga plazhi.",
    "intro": [
     "Velika Plaža — Long Beach, Plazhi i Madh — shtrihet për rreth 13 km nga Port Milena deri te lumi Buna. Është plazhi më i gjatë në bregun lindor të Adriatikut dhe një nga më të cekëtit: uji mbetet deri në gju për dhjetëra metra, prandaj familjet me fëmijë të vegjël e zgjedhin. Vetë plazhi është zonë e mbrojtur dhe kryesisht i pandërtuar, ndaj hotelet ndodhen pas rrugës bregdetare në Štoj dhe Donji Štoj, në një ecje të shkurtër nga rëra.",
     "Hotel La Rosa Negra është një prej tyre: rreth 2 minuta në këmbë nga uji, me pishinë të jashtme, gjysmë pension të përfshirë në çdo çmim, WiFi falas dhe një garazh privat me 60 vende. Shumë dhoma kanë ballkon me pamje nga deti. Qyteti i Vjetër, restorantet e Ulqinit dhe stacioni i autobusëve janë 4–5 km larg — 10 minuta me makinë ose me autobusin veror të plazhit."
    ],
    "facts": [
     {
      "label": "Plazhi",
      "value": "≈13 km rërë e imët gri, shumë i cekët, roje plazhi korrik–gusht"
     },
     {
      "label": "Distanca deri te rëra",
      "value": "Rreth 2 minuta në këmbë nga hoteli"
     },
     {
      "label": "Temperatura e detit",
      "value": "22–26 °C nga qershori në shtator"
     },
     {
      "label": "Aktivitete",
      "value": "Kitesurf në skajin e Ada Bojana, restorante plazhi, shteg për çiklizëm"
     }
    ],
    "faq": [
     {
      "q": "A ka hotele direkt mbi rërën e Velika Plaža?",
      "a": "Jo. Plazhi është një zonë natyrore e mbrojtur, ndaj hotelet dhe apartamentet ndodhen pas rrugës bregdetare në Štoj dhe Donji Štoj. Më të afërtit, përfshirë Hotel La Rosa Negra, janë rreth 150 m — 2 minuta në këmbë — nga uji."
     },
     {
      "q": "Sa larg është Velika Plaža nga Qyteti i Vjetër i Ulqinit?",
      "a": "Plazhi fillon rreth 1.5 km në juglindje të qytetit; pjesa jonë e tij është 5 km nga Qyteti i Vjetër — rreth 10 minuta me makinë ose taksi (rreth €10). Në korrik dhe gusht një autobus plazhi qarkullon përgjatë rrugës bregdetare."
     },
     {
      "q": "Kur është koha më e mirë për të qëndruar në Velika Plaža?",
      "a": "Qershori dhe shtatori sjellin det të ngrohtë (23–25 °C), plazhe më të qeta dhe çmime 30–40% më të ulëta se në gusht. Korriku dhe gushti janë muajt më të nxehtë dhe më të ngarkuar. Nga tetori deri në maj plazhi është pothuajse bosh dhe shumë restorante plazhi mbyllen; hoteli mbetet i hapur me çmime dimërore."
     }
    ]
   },
   {
    "slug": "sea-view-hotel-ulcinj",
    "filter": "couples",
    "title": "Dhoma hoteli me pamje nga deti në Ulqin",
    "metaTitle": "Hotel me pamje nga deti në Ulqin — Dhoma me ballkon | La Rosa Negra",
    "metaDescription": "Dhoma me ballkon dhe pamje nga deti në Ulqin, 2 minuta nga Velika Plaža: cilat dhoma shohin nga uji, çmime sipas sezonit, gjysmë pension i përfshirë. Rezervoni direkt dhe kurseni 10%.",
    "intro": [
     "Hoteli ndodhet në fushën e sheshtë të Štoj pas Velika Plaža, ndaj pamja nga deti këtu është Adriatiku i hapur mbi dunat dhe restorantet e plazhit, dhe jo një panoramë nga maja e shkëmbit. Dhomat e shënuara “sea view” janë të orientuara nga jugperëndimi drejt ujit dhe marrin perëndimin e diellit; dhomat në anën tjetër shohin nga pishina dhe malet e Rumisë. Çdo ballkon ka një tavolinë dhe dy karrige.",
     "Dhomat dyshe me pamje nga deti janë më të kërkuarat në korrik dhe gusht, ndaj rezervoni herët. Të gjitha çmimet përfshijnë gjysmë pensionin, pishinën e jashtme, WiFi dhe parkimin në garazh; rezervimet direkte janë 10% më të lira se çmimi ynë në Booking.com dhe mund të ndryshohen ose anulohen sipas tarifës që zgjidhni."
    ],
    "facts": [
     {
      "label": "Pamja",
      "value": "Adriatiku mbi dunat, ana e perëndimit të diellit"
     },
     {
      "label": "Ballkoni",
      "value": "Privat, me tavolinë dhe dy karrige"
     },
     {
      "label": "Plazhi",
      "value": "Rreth 2 minuta në këmbë"
     },
     {
      "label": "Diferenca e çmimit",
      "value": "Zakonisht €10–20 për natë më shumë se një dhomë nga ana e pishinës"
     }
    ],
    "faq": [
     {
      "q": "A mund ta shoh detin nga dhoma?",
      "a": "Nga dhomat me pamje nga deti, po — Adriatikun e hapur përtej dunave dhe restoranteve të plazhit, rreth 150 m larg. Dhomat në katin përdhes shohin më pak; katet e sipërme kanë pamjen më të qartë. Nëse pamja ka rëndësi për ju, shkruajeni në komentin e rezervimit dhe ne do t'ju caktojmë dhomën më të mirë të disponueshme."
     },
     {
      "q": "Cilat dhoma kanë pamje nga deti?",
      "a": "Dhomat dyshe me ballkon dhe pamje nga deti dhe disa nga dhomat familjare; emrat e dhomave në këtë faqe tregojnë “sea view” kur janë të orientuara drejt ujit. Dhomat me pamje nga pishina janë pak më të lira dhe më të qeta në mbrëmje."
     },
     {
      "q": "A ia vlen një dhomë me pamje nga deti në Ulqin?",
      "a": "Për pushime verore shumica e çifteve thonë po — perëndimi i diellit nga ballkoni është kulmi i ditës. Nëse kaloni pak kohë në dhomë, një dhomë me pamje nga pishina ju kursen €10–20 për natë për të njëjtin plazh dhe të njëjtat vakte."
     }
    ]
   },
   {
    "slug": "hotel-ulqin",
    "filter": "family",
    "title": "Hotel në Ulqin për mysafirë nga Kosova dhe Shqipëria",
    "metaTitle": "Hotel Ulqin — Çmime për Bajram & Javët e Verës | La Rosa Negra",
    "metaDescription": "Hotel familjar në Ulqin, 2 minuta nga Plazhi i Madh: çmime live për Fitër dhe Kurban Bajramin, Ditën e Verës dhe javët verore të diasporës. Flitet shqip, parkim në garazh, gjysmë pension.",
    "intro": [
     "Ulqin është deti më i afërt për Prishtinën dhe Tiranën: rreth 5 orë nga Prishtina përmes Rrugës së Kombit dhe Shkodrës, 2 orë nga Tirana dhe 1 orë nga Shkodra përmes kufirit Muriqan–Sukobin. Hotel La Rosa Negra ndodhet në anën e Plazhit të Madh (Velika Plaža) të qytetit, rreth 2 minuta në këmbë nga rëra — në recepsion flitet shqip dhe garazhi me 60 vende do të thotë se makina juaj është e sigurt gjatë gjithë qëndrimit.",
     "Çdo tarifë përfshin gjysmë pension (mëngjes dhe darkë buffet), pishinën e jashtme me pjesë për fëmijë, WiFi dhe parkim. Dhomat familjare akomodojnë 3–5 persona. Më poshtë shihni çmimin direkt live për javët kur udhëtojnë shumica e mysafirëve tanë nga Kosova dhe Shqipëria: Fitër dhe Kurban Bajrami, Dita e Verës, 17 Shkurti dhe javët e diasporës në fund të korrikut dhe gusht — rezervimi direkt është 10% më i ulët se çmimi ynë në Booking.com."
    ],
    "facts": [
     {
      "label": "Nga Prishtina",
      "value": "≈ 330 km · rreth 5 orë me makinë përmes Shkodrës"
     },
     {
      "label": "Nga Tirana / Shkodra",
      "value": "130 km · 2 orë / 45 km · 1 orë"
     },
     {
      "label": "Gjuha & pagesa",
      "value": "Flitet shqip · euro, para në dorë dhe kartë"
     },
     {
      "label": "Të përfshira",
      "value": "Gjysmë pension, pishinë, WiFi, parkim në garazh"
     }
    ],
    "faq": [
     {
      "q": "Si të vijmë nga Kosova në Ulqin?",
      "a": "Me makinë: Prishtinë → Rruga e Kombit → Kukës → Shkodër → kufiri Muriqan → Ulqin, rreth 5 orë; kufiri zakonisht kalohet shpejt jashtë orëve më të ngarkuara të së premtes dhe të dielës në mbrëmje gjatë gushtit. Autobusët qarkullojnë çdo ditë nga Prishtina dhe Tirana për në Ulqin gjatë verës; një taksi nga stacioni i autobusëve në Ulqin deri te hoteli kushton rreth €10."
     },
     {
      "q": "A keni dhoma për pushimet e Bajramit?",
      "a": "Po, kur hoteli është i hapur për sezonin — Kurban Bajrami në maj hyn në të, ndërsa Fitër Bajrami në mars varet nga viti. Tabela në këtë faqe tregon çmimin live për secilën festë; nëse shkruan 'on request', na shkruani në WhatsApp dhe do t’ju konfirmojmë brenda pak orësh."
     },
     {
      "q": "A mund të hanë fëmijët me ne në darkë, dhe a është ushqimi hallall?",
      "a": "Gjysmë pensioni mbulon të gjithë në dhomë, përfshirë fëmijët. Darka është buffet me peshk, mish në skarë, perime dhe sallata. Si shumica e hoteleve në Ulqin, gatuajmë pa mish derri, dhe hoteli është pa alkool — një zgjedhje e qetë që e vlerësojnë shumë familje nga Kosova, Shqipëria dhe diaspora."
     }
    ]
   },
   {
    "slug": "plazhi-i-madh-ulqin",
    "filter": "all",
    "title": "Plazhi i Madh, Ulqin — hotel 2 minuta nga rëra",
    "metaTitle": "Plazhi i Madh Ulqin — Hotel 2 Minuta nga Plazhi | La Rosa Negra",
    "metaDescription": "Plazhi i Madh (Velika Plaža), Ulqin: 13 km rërë e cekët për familje, çmime për javët e verës nga Kosova dhe Shqipëria, dhe një hotel familjar 2 minuta nga plazhi me gjysmë pension dhe pishinë.",
    "intro": [
     "Plazhi i Madh — Velika Plaža, Long Beach — është 13 km rërë e imët dhe e cekët nga Port Milena deri te lumi Buna. Uji mbetet deri në gju për dhjetëra metra, prandaj familjet nga Kosova dhe Shqipëria vijnë këtu prej brezash. Restorantet e plazhit japin shezlongë me qira (rreth €10–15 një set në sezon), rojtarët e plazhit punojnë në korrik dhe gusht, ndërsa pjesa te Ada Bojana është vendi për kitesurfing.",
     "Hotel La Rosa Negra është rreth 2 minuta në këmbë nga rëra, me ballkone me pamje nga deti, pishinë të jashtme, gjysmë pension në çdo tarifë dhe garazh privat. Qyteti i Vjetër i Ulqinit me restorantet e tij është 5 km larg. Çmimet më poshtë janë live për javët kur udhëtojnë shumica e mysafirëve tanë shqipfolës; rezervoni direkt dhe paguani 10% më pak se në Booking.com."
    ],
    "facts": [
     {
      "label": "Plazhi",
      "value": "13 km rërë e cekët · rojtarë plazhi Kor–Gush"
     },
     {
      "label": "Distanca nga hoteli",
      "value": "Rreth 2 minuta në këmbë"
     },
     {
      "label": "Deti",
      "value": "23–26 °C nga qershori në shtator"
     },
     {
      "label": "Qyteti i Vjetër",
      "value": "5 km · taksi rreth €10 · autobus veror për plazh"
     }
    ],
    "faq": [
     {
      "q": "A është Plazhi i Madh i përshtatshëm për fëmijë të vegjël?",
      "a": "Është plazhi më i cekët në këtë bregdet — rëra zbret shumë butë, kështu që fëmijët mund të luajnë në ujë deri në gju larg bregut. Merrni hije për mesin e ditës; hoteli ka gjithashtu një pjesë të pishinës për fëmijë."
     },
     {
      "q": "Sa i mbushur është në gusht?",
      "a": "Javët e diasporës (fundi i korrikut deri në mesin e gushtit) janë periudha më e ngarkuar e vitit — rezervoni herët, shkoni në plazh para orës 10:00 për rreshtat e parë të shezlongëve dhe prisni kolona në kufirin Muriqan të premten dhe të dielën në mbrëmje. Fundi i gushtit dhe shtatori janë shumë më të qetë me të njëjtin det të ngrohtë."
     },
     {
      "q": "Ku parkojmë?",
      "a": "Në garazhin tonë privat me 60 vende, i përfshirë në çmim. Në vetë rrugën e plazhit parkimi është me pagesë dhe i kufizuar gjatë verës, ndaj shumica e mysafirëve e lënë makinën te hoteli dhe ecin në këmbë."
     }
    ]
   },
   {
    "slug": "halal-friendly-family-hotel-ulcinj",
    "filter": "family",
    "title": "Hotel familjar pa alkool në Ulqin, 2 minuta nga Plazhi i Madh",
    "metaTitle": "Hotel familjar pa alkool në Ulqin pranë Velika Plaža | La Rosa Negra",
    "metaDescription": "Hotel i qetë familjar në Ulqin, 2 minuta nga Velika Plaža (Plazhi i Madh): gjysmë pension, pishinë me pjesë për fëmijë, garazh falas, flitet shqip, nuk shërbehet alkool. Çmime live për Bajram dhe javët verore të diasporës.",
    "intro": [
     "Hotel La Rosa Negra është një hotel familjar me tre yje në anën e Velika Plaža (Plazhi i Madh) të Ulqinit, rreth 2 minuta në këmbë nga rëra. Është një vend i qetë: pa skenë bari, nuk shërbehet alkool, fëmijë që vrapojnë mes pishinës dhe plazhit, prindër në tarracë me një kafe. Familje nga Kosova, Shqipëria, Maqedonia e Veriut dhe diaspora në Gjermani, Zvicër dhe Austri kthehen vit pas viti — shumë prej tyre për të njëjtat dy javë çdo verë.",
     "Gjysmë pensioni përfshihet në çdo tarifë — mëngjes bufet dhe darkë bufet me peshk, mish në skarë, perime, sallata dhe ëmbëlsira, të gatuara siç gatuajnë kuzhinat e Ulqinit; pijet në darkë janë lëngje, pije joalkoolike, ujë, kafe dhe çaj. Dhomat familjare akomodojnë 3–5 persona, pishina e jashtme ka pjesë për fëmijë, garazhi me 60 vende është falas dhe në recepsion fliten shqip, malazezçe, anglisht dhe gjermanisht. Më poshtë shihni çmimin direkt live për javët kur udhëtojnë më së shumti mysafirët tanë — Fitër dhe Kurban Bajrami, Dita e Verës dhe javët e diasporës në fund të korrikut dhe në gusht — gjithmonë 10% më poshtë se çmimi ynë në Booking.com."
    ],
    "facts": [
     {
      "label": "Familje",
      "value": "Dhoma për 3–5 persona · pishinë për fëmijë · 2 min deri te plazhi"
     },
     {
      "label": "Atmosfera",
      "value": "Hotel i qetë, pa alkool · kafene në tarracë"
     },
     {
      "label": "Përfshihet",
      "value": "Gjysmë pension, pishinë, WiFi, parkim në garazh"
     },
     {
      "label": "Gjuhët",
      "value": "Shqip, malazezçe, anglisht, gjermanisht"
     }
    ],
    "faq": [
     {
      "q": "A është ushqimi i përshtatshëm për familjet myslimane?",
      "a": "Po — si shumica e hoteleve në Ulqin, kuzhina jonë gatuan pa mish derri dhe në kuzhinë nuk përdoret alkool, as nuk shërbehet në hotel. Nuk kemi një certifikatë formale hallall; nëse kjo ka rëndësi për ju, na shkruani para rezervimit dhe do t’ju tregojmë sinqerisht si sigurohet mishi."
     },
     {
      "q": "A nuk ka vërtet alkool, as në frigoriferin e dhomës apo në tarracë?",
      "a": "Saktë — hoteli është pa alkool. Frigoriferët e dhomave janë bosh për pijet tuaja, kafeneja shërben kafe, çaj, lëngje të freskëta dhe pije joalkoolike, dhe nuk shitet asgjë me alkool në darkë apo në tarracë. Mysafirët që duan një gotë verë e gjejnë në restorantet e plazhit 150 m larg."
     },
     {
      "q": "A mund të vijmë për Bajram ose pushimet verore me një familje të madhe?",
      "a": "Po. Dhomat familjare akomodojnë deri në 5 persona, dhe nëse udhëtoni si grup më i madh na tregoni dhe do të përpiqemi t’ju vendosim në dhoma ngjitur. Tabela në këtë faqe tregon çmimin live për Kurban Bajramin, Fitër Bajramin dhe javët e diasporës — nëse një rresht thotë 'on request', na dërgoni një WhatsApp dhe ju konfirmojmë brenda pak orësh."
     }
    ]
   }
  ]
 },
 "de": {
  "nav": "Beliebte Aufenthalte",
  "intro": "Finden Sie den Aufenthalt, der zu Ihnen passt — auf jeder Seite sehen Sie die passenden Zimmer mit aktuellen Direktpreisen.",
  "roomsHeading": "Zimmer, die zu diesem Aufenthalt passen",
  "faqHeading": "Gut zu wissen",
  "otherHeading": "Weitere beliebte Suchen",
  "from": "ab",
  "perNight": "pro Nacht",
  "book": "Verfügbarkeit prüfen",
  "topics": [
   {
    "slug": "family-hotel-velika-plaza",
    "filter": "family",
    "title": "Familienhotel an der Velika Plaža, Ulcinj",
    "metaTitle": "Familienhotel an der Velika Plaža, Ulcinj — La Rosa Negra",
    "metaDescription": "Familienzimmer für 3–5 Personen, Kinderpool, flacher Sandstrand nur wenige Schritte entfernt, Halbpension und kostenloses Parken. Familienhotel an der Velika Plaža, Ulcinj — bester Preis direkt.",
    "intro": [
     "Die Velika Plaža ist 13 km feiner, flacher Sand — der sicherste Strand in Montenegro für kleine Kinder, und das Hotel La Rosa Negra liegt direkt daneben. Unsere Familienzimmer und das Apartment mit zwei Schlafzimmern bieten Platz für 3 bis 5 Personen, mit Schlafsofas, Kitchenettes und Terrassen, auf denen die Kinder spielen können, während Sie Ihren Kaffee trinken.",
     "Halbpension ist inklusive (Frühstücks- und Abendbuffet), der Pool hat einen flachen Kinderbereich mit Liegen, und die private Garage mit 60 Stellplätzen erspart Ihnen nach einem Ausflug nach Ada Bojana oder in die Altstadt die Parkplatzsuche."
    ],
    "facts": [
     {
      "label": "Familienzimmer",
      "value": "3–5 Gäste, Schlafsofas & Kitchenettes"
     },
     {
      "label": "Strand",
      "value": "Flacher Sand, 2 Minuten zu Fuß"
     },
     {
      "label": "Mahlzeiten",
      "value": "Halbpension inklusive"
     },
     {
      "label": "Extras",
      "value": "Babybett & Zustellbett auf Anfrage"
     }
    ],
    "faq": [
     {
      "q": "Übernachten Kinder kostenlos?",
      "a": "Kinder bis 2 Jahre übernachten kostenlos im Babybett. Für ältere Kinder empfehlen wir ein Familienzimmer oder das Apartment mit zwei Schlafzimmern — der angezeigte Preis deckt bereits die angegebene Gästezahl ab."
     },
     {
      "q": "Ist der Strand sicher für Kleinkinder?",
      "a": "Ja — die Velika Plaža fällt sehr sanft ab, sodass das Wasser über viele zehn Meter flach bleibt. Im Juli und August sind Rettungsschwimmer im Einsatz."
     },
     {
      "q": "Können wir ein Babybett oder einen Hochstuhl bekommen?",
      "a": "Beides ist kostenlos verfügbar — fragen Sie einfach bei der Buchung oder an der Rezeption."
     }
    ]
   },
   {
    "slug": "hotel-with-pool-ulcinj",
    "filter": "pool",
    "title": "Hotel mit Pool in Ulcinj",
    "metaTitle": "Hotel mit Pool in Ulcinj, am Strand — La Rosa Negra",
    "metaDescription": "Außenpool mit Sonnenliegen, Kinderbereich und Zimmern am Pool, 2 Minuten von der Velika Plaža entfernt. Hotel mit Pool in Ulcinj — Halbpension und Parken inklusive.",
    "intro": [
     "Meer am Morgen, Pool am Nachmittag: Das Hotel La Rosa Negra hat einen Außenpool mit kostenlosen Sonnenliegen und einem flachen Kinderbereich, umgeben von Palmen und der Hotelterrasse. Der Zugang zum Pool ist für jeden Gast inklusive.",
     "Wählen Sie ein Doppelzimmer am Pool und treten Sie direkt von Ihrer Tür auf die Poolterrasse, oder ein Zimmer mit Meerblick im Obergeschoss und genießen Sie von Ihrem Balkon den Blick auf Pool und Adria."
    ],
    "facts": [
     {
      "label": "Pool",
      "value": "Außenpool, kostenlose Liegen, Kinderbereich"
     },
     {
      "label": "Saison",
      "value": "Mai – Oktober"
     },
     {
      "label": "Zimmer am Pool",
      "value": "Doppelzimmer am Pool"
     },
     {
      "label": "Außerdem",
      "value": "Strand 2 Min., Halbpension inklusive"
     }
    ],
    "faq": [
     {
      "q": "Ist der Pool beheizt?",
      "a": "Nein — es ist ein Außenpool mit Süßwasser, der dank 2 500 Sonnenstunden im Jahr von Ende Mai bis Anfang Oktober angenehm ist."
     },
     {
      "q": "Sind Handtücher und Liegen kostenlos?",
      "a": "Liegen sind für Hotelgäste kostenlos; Poolhandtücher erhalten Sie an der Rezeption."
     },
     {
      "q": "Können Kinder den Pool nutzen?",
      "a": "Ja, es gibt einen flachen Kinderbereich. Kinder müssen von einem Erwachsenen begleitet werden."
     }
    ]
   },
   {
    "slug": "half-board-hotel-ulcinj",
    "filter": "all",
    "title": "Hotel mit Halbpension in Ulcinj",
    "metaTitle": "Hotel mit Halbpension in Ulcinj — Frühstück & Abendessen inklusive | La Rosa Negra",
    "metaDescription": "Frühstücks- und Abendbuffet in jedem Preis inklusive. Hotel mit Halbpension an der Velika Plaža, Ulcinj mit Pool, Parkplatz und Zimmern mit Meerblick — ab €40 pro Nacht direkt.",
    "intro": [
     "Jeder Zimmerpreis im Hotel La Rosa Negra beinhaltet Halbpension: ein Frühstücksbuffet und ein Abendessen mit drei Gängen in unserem Restaurant, mit montenegrinischen und mediterranen Gerichten, frischem Fisch aus Ulcinj und täglich vegetarischen Optionen.",
     "Mit Halbpension wird der Strandurlaub ganz entspannt — kommen Sie vom Strand zurück, duschen Sie, und das Abendessen ist schon fertig. Das Mittagessen können Sie in den Strandrestaurants direkt vor dem Hotel einnehmen."
    ],
    "facts": [
     {
      "label": "Inklusive",
      "value": "Frühstücksbuffet + 3-Gänge-Abendessen"
     },
     {
      "label": "Küche",
      "value": "Montenegrinisch & mediterran, frischer Fisch"
     },
     {
      "label": "Ernährung",
      "value": "Täglich vegetarisch, Allergien auf Anfrage"
     },
     {
      "label": "Preise",
      "value": "Zimmer ab €40 pro Nacht"
     }
    ],
    "faq": [
     {
      "q": "Um wie viel Uhr ist das Abendessen?",
      "a": "Das Abendessen wird von 19:00 bis 21:30 serviert; das Frühstück von 07:30 bis 10:00 (die Zeiten können sich je nach Saison leicht verschieben)."
     },
     {
      "q": "Kann ich nur das Zimmer buchen?",
      "a": "Alle unsere Direktpreise beinhalten Halbpension — das bietet das beste Preis-Leistungs-Verhältnis. Kontaktieren Sie die Rezeption, wenn Sie besondere Wünsche haben."
     },
     {
      "q": "Sind Getränke inklusive?",
      "a": "Wasser ist beim Abendessen inklusive; andere Getränke sind an der Restaurantbar erhältlich."
     }
    ]
   },
   {
    "slug": "hotel-near-podgorica-airport",
    "filter": "all",
    "title": "Strandhotel nahe den Flughäfen Podgorica & Tivat",
    "metaTitle": "Strandhotel 90 Min. von den Flughäfen Podgorica & Tivat — La Rosa Negra, Ulcinj",
    "metaDescription": "Fliegen Sie nach Podgorica (TGD) oder Tivat (TIV) und seien Sie in etwa 90 Minuten an der Velika Plaža. Flughafentransfer €80 pro Strecke, kostenloses Parken, Halbpension. Direkt buchen.",
    "intro": [
     "Ulcinj wird von zwei montenegrinischen Flughäfen bedient — Podgorica (TGD, etwa 85 km) und Tivat (TIV, etwa 95 km) — beide liegen ungefähr 90 Autominuten vom Hotel La Rosa Negra entfernt. Der Flughafen Tirana (TIA) in Albanien ist eine dritte Option, etwa 2 Stunden entfernt über den Grenzübergang Muriqan.",
     "Wir organisieren private Transfers für €80 pro Strecke (bis zu 4 Gäste), die Sie in der Ankunftshalle abholen; wenn Sie ein Auto mieten, ist unsere private Garage mit 60 Stellplätzen für Gäste kostenlos."
    ],
    "facts": [
     {
      "label": "Podgorica (TGD)",
      "value": "≈ 85 km · 1 h 30"
     },
     {
      "label": "Tivat (TIV)",
      "value": "≈ 95 km · 1 h 35"
     },
     {
      "label": "Tirana (TIA)",
      "value": "≈ 130 km · 2 h"
     },
     {
      "label": "Transfer",
      "value": "€80 pro Strecke, bis zu 4 Gäste"
     }
    ],
    "faq": [
     {
      "q": "Wie buche ich den Flughafentransfer?",
      "a": "Fügen Sie ihn beim Online-Check-in hinzu oder senden Sie uns Ihre Flugnummer per E-Mail — der Fahrer wartet im Ankunftsbereich mit einem Namensschild."
     },
     {
      "q": "Gibt es einen Bus vom Flughafen?",
      "a": "Keine Direktverbindung. Nehmen Sie ein Taxi oder einen Bus zum Busbahnhof Podgorica oder Bar und dann einen Reisebus nach Ulcinj (im Sommer stündlich), anschließend ein Taxi zum Hotel."
     },
     {
      "q": "Welcher Flughafen ist besser?",
      "a": "Podgorica hat meist mehr Flüge und günstigere Tarife; Tivat ist landschaftlich reizvoller. Die Fahrzeit zum Hotel ist fast gleich."
     }
    ]
   },
   {
    "slug": "romantic-hotel-ulcinj",
    "filter": "couples",
    "title": "Romantisches Hotel mit Meerblick in Ulcinj für Paare",
    "metaTitle": "Romantisches Hotel mit Meerblick in Ulcinj für Paare — La Rosa Negra",
    "metaDescription": "Zimmer mit Balkon und Meerblick, Sonnenuntergänge über der Velika Plaža, Abendessen inklusive und romantisches Arrangement auf Anfrage. Hotel für Paare in Ulcinj, Montenegro — direkt buchen.",
    "intro": [
     "Die Sonne geht direkt vor dem Hotel La Rosa Negra in die Adria unter — genießen Sie das von Ihrem eigenen Balkon mit Meerblick bei einem Glas montenegrinischem Vranac. Unsere Doppelzimmer mit Balkon und Meerblick sowie die Zweibettzimmer mit gemeinsamer Meeresterrasse sind wie gemacht für zwei.",
     "Fügen Sie das romantische Arrangement (Blumen, Obst und Süßes im Zimmer) beim Online-Check-in hinzu, speisen Sie auf der Terrasse mit inkludierter Halbpension und fahren Sie 20 Minuten nach Ada Bojana für ein Fischabendessen am Fluss."
    ],
    "facts": [
     {
      "label": "Zimmer",
      "value": "Doppelzimmer mit Balkon und Meerblick"
     },
     {
      "label": "Sonnenuntergang",
      "value": "Direkt über dem Meer, nach Westen ausgerichtet"
     },
     {
      "label": "Romantisches Arrangement",
      "value": "€35 — Wein, Obst, Blumen"
     },
     {
      "label": "Ausflüge",
      "value": "Ada Bojana, Altstadt, Bucht von Valdanos"
     }
    ],
    "faq": [
     {
      "q": "Können Sie eine Überraschung zum Jahrestag vorbereiten?",
      "a": "Ja — wählen Sie das romantische Arrangement beim Online-Check-in oder schreiben Sie uns; wir dekorieren das Zimmer vor Ihrer Ankunft."
     },
     {
      "q": "Ist das Hotel ruhig?",
      "a": "Das Hotel liegt an der Strandstraße der Velika Plaža, abseits des Nachtlebens der Altstadt; Zimmer mit Meerblick in den oberen Etagen sind am ruhigsten."
     },
     {
      "q": "Können wir spät auschecken?",
      "a": "Später Check-out bis 14:00 kostet €20, je nach Verfügbarkeit — buchbar beim Online-Check-in."
     }
    ]
   },
   {
    "slug": "long-stay-workation-ulcinj",
    "filter": "longstay",
    "title": "Langzeitaufenthalt & Workation in Ulcinj",
    "metaTitle": "Hotel für Langzeitaufenthalt & Workation in Ulcinj, Montenegro — La Rosa Negra",
    "metaDescription": "Bleiben Sie eine Woche oder einen Monat an der Velika Plaža: Apartments mit Kitchenette, kostenlosem WLAN, Halbpension, Parkplatz. Hotel für Langzeitaufenthalte und Workation in Ulcinj — fragen Sie nach einem Monatspreis.",
    "intro": [
     "Montenegros Visum für digitale Nomaden und 300 Sonnentage machen Ulcinj zu einem idealen Ort zum Arbeiten. Das Hotel La Rosa Negra bietet Apartments mit Kitchenette und Wohnbereich, kostenloses WLAN im ganzen Haus, eine ruhige Terrasse und einen Strand für die Mittagspause.",
     "Für Aufenthalte ab 7 Nächten bieten wir reduzierte Preise, und für einen Monat oder länger einen individuellen Preis mit wöchentlicher Reinigung — schreiben Sie uns mit Ihren Daten."
    ],
    "facts": [
     {
      "label": "Apartments",
      "value": "Kitchenette, Wohnbereich, Balkon"
     },
     {
      "label": "WLAN",
      "value": "Kostenlos, Glasfaser in allen Zimmern und auf der Terrasse"
     },
     {
      "label": "Langzeitpreise",
      "value": "Ab 7 Nächten ermäßigt, monatlich auf Anfrage"
     },
     {
      "label": "Außerdem",
      "value": "Halbpension, Pool, kostenlose Garage"
     }
    ],
    "faq": [
     {
      "q": "Ist das WLAN gut genug für Videoanrufe?",
      "a": "Ja — Glasfaserverbindung mit WLAN in jedem Zimmer und auf der Terrasse; die Rezeption kann Ihnen auch einen ruhigen Platz für Anrufe geben."
     },
     {
      "q": "Kann ich im Zimmer kochen?",
      "a": "Die Apartments haben eine Kitchenette mit Kochfeld, Kühlschrank und Wasserkocher. Halbpension ist weiterhin inklusive, falls Sie nicht kochen möchten."
     },
     {
      "q": "Wie bekomme ich einen Monatspreis?",
      "a": "Senden Sie eine E-Mail an larosaulcinj@gmail.com mit Ihren Daten und dem gewünschten Zimmertyp — wir antworten innerhalb von 24 Stunden mit einem persönlichen Angebot."
     }
    ]
   },
   {
    "slug": "cheap-hotel-ulcinj",
    "filter": "budget",
    "title": "Günstiges Hotel in Ulcinj am Strand — ab €40",
    "metaTitle": "Günstiges Strandhotel in Ulcinj ab €40 — La Rosa Negra, Velika Plaža",
    "metaDescription": "Budget-Zimmer ab €40 pro Nacht inklusive Halbpension, Pool und kostenlosem Parken — 2 Minuten von der Velika Plaža entfernt. Das ehrliche günstige Hotel in Ulcinj: direkt buchen, 15 % sparen.",
    "intro": [
     "Günstig muss nicht weit vom Strand entfernt bedeuten. Unsere Economy-Doppelzimmer und Einzelzimmer beginnen ab €40 pro Nacht und beinhalten trotzdem Frühstücksbuffet, Abendessen, den Pool und die Garage — derselbe Strand, dieselben Sonnenuntergänge wie bei den Zimmern mit Meerblick.",
     "Eine Direktbuchung auf dieser Website ist immer mindestens 15 % günstiger als bei Booking.com, und Frühbuchercodes für Juni und September bringen weitere 10 % Rabatt."
    ],
    "facts": [
     {
      "label": "Ab",
      "value": "€40 pro Nacht inkl. Halbpension"
     },
     {
      "label": "Direkt sparen",
      "value": "≥ 15 % ggü. Booking.com"
     },
     {
      "label": "Frühbucher",
      "value": "−10 % Codes für Juni & September"
     },
     {
      "label": "Inklusive",
      "value": "Pool, Parkplatz, WLAN, Abendessen"
     }
    ],
    "faq": [
     {
      "q": "Welches ist das günstigste Zimmer?",
      "a": "Das Kleine Einzelzimmer ab €40 und das Economy-Doppelzimmer mit Balkon (ohne Aussicht) ab €60 — beide mit Halbpension."
     },
     {
      "q": "Warum ist direkt günstiger?",
      "a": "Wir zahlen bei Direktbuchungen keine Provision und geben die Ersparnis an Sie weiter; außerdem erhalten Sie kostenlose Stornierung bis 24 h vor Anreise."
     },
     {
      "q": "Wann ist Ulcinj am günstigsten?",
      "a": "Mai, Juni, September und Oktober — großartiges Wetter, warmes Meer und Preise bis zu 40 % unter Juli und August."
     }
    ]
   },
   {
    "slug": "hotel-with-parking-ulcinj",
    "filter": "all",
    "title": "Hotel mit kostenlosem Parkplatz in Ulcinj",
    "metaTitle": "Hotel mit kostenlosem Parkplatz in Ulcinj — Garage mit 60 Stellplätzen | La Rosa Negra",
    "metaDescription": "Private Garage mit 60 Stellplätzen in jedem Preis inklusive, 2 Minuten von der Velika Plaža entfernt. Hotel mit kostenlosem Parkplatz in Ulcinj — ideal für Roadtrips durch Montenegro und Albanien.",
    "intro": [
     "Sie kommen mit dem Auto aus Dubrovnik, Podgorica oder Tirana? Das Hotel La Rosa Negra verfügt über eine private Garage mit 60 Stellplätzen, kostenlos für alle Gäste — kein Stress mit Straßenparkplätzen in der Hochsaison, und Ihr Auto steht im Schatten.",
     "Vom Hotel sind es 5 km bis zur Altstadt, 20 Minuten bis Ada Bojana, 45 Minuten bis zum Šaško-See und eine Stunde bis Bar und zum Skadar-See — die Velika Plaža ist der perfekte Ausgangspunkt für einen Roadtrip durch Montenegro."
    ],
    "facts": [
     {
      "label": "Parken",
      "value": "Private Garage mit 60 Stellplätzen, kostenlos"
     },
     {
      "label": "E-Auto",
      "value": "Laden auf Anfrage"
     },
     {
      "label": "Entfernungen",
      "value": "Altstadt 5 km · Ada Bojana 15 km · Bar 30 km"
     },
     {
      "label": "Grenze",
      "value": "Albanien (Muriqan) 25 Min."
     }
    ],
    "faq": [
     {
      "q": "Muss ich einen Parkplatz reservieren?",
      "a": "Nein — die Garage ist inklusive und es gibt Platz für jedes Zimmer. Im seltenen Fall, dass sie voll ist, stehen neben dem Hotel kostenlose Parkplätze zur Verfügung."
     },
     {
      "q": "Kann ich ein Elektroauto laden?",
      "a": "Ja, auf Anfrage an der Rezeption (Standardsteckdose); Schnellladestationen gibt es in der Stadt Ulcinj."
     },
     {
      "q": "Ist die Straße von Dubrovnik aus einfach?",
      "a": "Etwa 3 h 30 entlang der Küste über Budva und Bar; planen Sie im Juli und August zusätzliche Zeit an der kroatischen Grenze ein."
     }
    ]
   },
   {
    "slug": "hotels-in-ulcinj",
    "filter": "all",
    "title": "Hotels in Ulcinj: Welche Gegend soll man wählen?",
    "metaTitle": "Hotels in Ulcinj — Wo übernachten & Preise | La Rosa Negra",
    "metaDescription": "Hotels in Ulcinj, Montenegro: Altstadt vs. Velika Plaža vs. Ada Bojana, was Zimmer in der Saison kosten, und ein familiengeführtes Hotel 2 Minuten vom Long Beach entfernt.",
    "intro": [
     "Ulcinj (Ulqin) hat drei sehr unterschiedliche Übernachtungsgegenden. Die Altstadt und Mala Plaža sind lebhaft und historisch, mit Restaurants auf den Stadtmauern, aber auch mit Treppen, Verkehr und im Juli und August fast ohne Parkplätze. Velika Plaža (Long Beach) und die Štoj-Ebene dahinter sind flach, ruhig und familienfreundlich, mit 13 km flachem Sandstrand und den meisten neueren Hotels der Stadt. Ada Bojana, am äußersten Ende des Strandes, ist eine abgelegene Flussinsel für Kitesurfer und Naturisten.",
     "Hotel La Rosa Negra liegt auf der Seite von Velika Plaža: ein familiengeführtes 3-Sterne-Hotel, etwa 2 Minuten zu Fuß vom Sand entfernt, 5 km von der Altstadt. Im Preis enthalten sind Halbpension (Frühstücks- und Abendbuffet), der Außenpool, WLAN und eine private Garage mit 60 Stellplätzen. Die Zimmer kosten je nach Saison und Aussicht €40–150 pro Nacht, und bei Direktbuchung liegen wir 10% unter unserem Booking.com-Preis."
    ],
    "facts": [
     {
      "label": "Gegenden",
      "value": "Altstadt · Velika Plaža / Štoj · Ada Bojana"
     },
     {
      "label": "Typische Preise",
      "value": "3-Sterne-Hotelzimmer €40–150 pro Nacht, Halbpension"
     },
     {
      "label": "Unsere Lage",
      "value": "2 Min. bis zum Sand, 5 km bis zur Altstadt"
     },
     {
      "label": "Anreise",
      "value": "Flughafen Podgorica oder Tivat ≈ 90 Min., Tirana 2 Std."
     }
    ],
    "faq": [
     {
      "q": "Welcher Teil von Ulcinj ist am besten für einen Strandurlaub?",
      "a": "Velika Plaža. Der Sand ist fein und das Wasser über viele Dutzend Meter flach, Strandrestaurants vermieten Liegen, und die Gegend ist mit Kindern oder Auto eben und unkompliziert. Die Altstadt eignet sich besser für einen Städtetrip: mehr Restaurants und Nachtleben, aber die Strände dort sind klein und kieselig und Parkplätze sind rar."
     },
     {
      "q": "Wie viel kostet ein Hotel in Ulcinj?",
      "a": "Im Juli und August kostet ein Doppelzimmer in einem 3-Sterne-Hotel normalerweise €90–150 pro Nacht; im Juni und September €60–100; im Frühling und Herbst ab etwa €40. Unsere Preise beinhalten Frühstück und Abendessen, Pool und Parkplatz — vergleichen Sie also den Gesamtpreis, nicht nur den Zimmerpreis."
     },
     {
      "q": "Wie komme ich vom Flughafen zu einem Hotel an der Velika Plaža?",
      "a": "Die Flughäfen Podgorica (TGD) und Tivat (TIV) sind etwa 80 km / 90 Minuten entfernt; Tirana (TIA) 130 km / 2 Stunden über den Grenzübergang Muriqan. Wir organisieren einen privaten Transfer für €80 pro Strecke, oder Sie nehmen den Bus nach Ulcinj und für die letzten 4 km ein Taxi (etwa €10)."
     }
    ]
   },
   {
    "slug": "velika-plaza-hotels",
    "filter": "all",
    "title": "Hotels an der Velika Plaža (Long Beach), Ulcinj",
    "metaTitle": "Velika Plaža Hotels — Long Beach Ulcinj | La Rosa Negra",
    "metaDescription": "Hotels an der Velika Plaža, Ulcinj: 13 km flacher Sandstrand, wie nah Hotels wirklich am Wasser sind, Preise nach Monat und ein familiengeführtes Hotel 2 Minuten vom Strand entfernt.",
    "intro": [
     "Velika Plaža — Long Beach, Plazhi i Madh — erstreckt sich über etwa 13 km von Port Milena bis zum Fluss Bojana. Es ist der längste Strand an der östlichen Adriaküste und einer der flachsten: Das Wasser bleibt über viele Dutzend Meter knietief, weshalb Familien mit kleinen Kindern ihn wählen. Der Strand selbst ist geschützt und weitgehend unbebaut, daher stehen die Hotels hinter der Küstenstraße in Štoj und Donji Štoj, nur einen kurzen Spaziergang vom Sand entfernt.",
     "Hotel La Rosa Negra ist eines davon: etwa 2 Minuten zu Fuß vom Wasser entfernt, mit Außenpool, Halbpension in jedem Preis inbegriffen, kostenlosem WLAN und einer privaten Garage mit 60 Stellplätzen. Viele Zimmer haben einen Balkon mit Meerblick. Die Altstadt, die Restaurants von Ulcinj und der Busbahnhof sind 4–5 km entfernt — 10 Minuten mit dem Auto oder mit dem sommerlichen Strandbus."
    ],
    "facts": [
     {
      "label": "Der Strand",
      "value": "≈13 km feiner grauer Sand, sehr flach, Rettungsschwimmer Jul–Aug"
     },
     {
      "label": "Entfernung zum Sand",
      "value": "Etwa 2 Minuten zu Fuß vom Hotel"
     },
     {
      "label": "Wassertemperatur",
      "value": "22–26 °C von Juni bis September"
     },
     {
      "label": "Aktivitäten",
      "value": "Kitesurfen am Ada-Bojana-Ende, Strandrestaurants, Radweg"
     }
    ],
    "faq": [
     {
      "q": "Gibt es Hotels direkt auf dem Sand der Velika Plaža?",
      "a": "Nein. Der Strand ist eine geschützte Naturzone, daher stehen Hotels und Apartments hinter der Küstenstraße in Štoj und Donji Štoj. Die nächstgelegenen, einschließlich Hotel La Rosa Negra, sind etwa 150 m — 2 Minuten zu Fuß — vom Wasser entfernt."
     },
     {
      "q": "Wie weit ist Velika Plaža von der Altstadt von Ulcinj entfernt?",
      "a": "Der Strand beginnt etwa 1,5 km südöstlich der Stadt; unser Abschnitt liegt 5 km von der Altstadt entfernt — rund 10 Minuten mit dem Auto oder Taxi (etwa €10). Im Juli und August fährt ein Strandbus entlang der Küstenstraße."
     },
     {
      "q": "Wann ist die beste Zeit für einen Aufenthalt an der Velika Plaža?",
      "a": "Juni und September bieten warmes Meer (23–25 °C), ruhigere Strände und Preise 30–40% unter August. Juli und August sind am heißesten und am belebtesten. Von Oktober bis Mai ist der Strand fast leer und viele Bars schließen; das Hotel bleibt mit Winterpreisen geöffnet."
     }
    ]
   },
   {
    "slug": "sea-view-hotel-ulcinj",
    "filter": "couples",
    "title": "Hotelzimmer mit Meerblick in Ulcinj",
    "metaTitle": "Meerblick-Hotel Ulcinj — Zimmer mit Balkon | La Rosa Negra",
    "metaDescription": "Zimmer mit Balkon und Meerblick in Ulcinj, 2 Minuten von Velika Plaža entfernt: welche Zimmer zum Wasser ausgerichtet sind, Preise nach Saison, Halbpension inklusive. Direkt buchen und 10% sparen.",
    "intro": [
     "Das Hotel steht auf der flachen Štoj-Ebene hinter Velika Plaža, daher ist der Meerblick hier die offene Adria über den Dünen und Strandrestaurants und kein Panorama von einer Klippe. Zimmer mit der Kennzeichnung „Meerblick“ sind nach Südwesten zum Wasser ausgerichtet und bieten Sonnenuntergänge; Zimmer auf der anderen Seite blicken auf den Pool und das Rumija-Gebirge. Jeder Balkon hat einen Tisch und zwei Stühle.",
     "Doppelzimmer mit Meerblick sind im Juli und August am gefragtesten, buchen Sie also früh. Alle Preise beinhalten Halbpension, den Außenpool, WLAN und Garagenparkplatz; Direktbuchungen liegen 10% unter unserem Booking.com-Preis und können je nach gewähltem Tarif geändert oder storniert werden."
    ],
    "facts": [
     {
      "label": "Aussicht",
      "value": "Adria über den Dünen, Sonnenuntergangsseite"
     },
     {
      "label": "Balkon",
      "value": "Privat, mit Tisch und zwei Stühlen"
     },
     {
      "label": "Strand",
      "value": "Etwa 2 Minuten zu Fuß"
     },
     {
      "label": "Preisunterschied",
      "value": "Normalerweise €10–20 pro Nacht über einem Zimmer zur Poolseite"
     }
    ],
    "faq": [
     {
      "q": "Kann ich das Meer vom Zimmer aus sehen?",
      "a": "Von Zimmern mit Meerblick ja — die offene Adria hinter den Dünen und Strandrestaurants, etwa 150 m entfernt. Zimmer im Erdgeschoss sehen weniger; die oberen Etagen haben die klarste Aussicht. Wenn Ihnen die Aussicht wichtig ist, schreiben Sie es in den Buchungskommentar, und wir weisen Ihnen das bestverfügbare Zimmer zu."
     },
     {
      "q": "Welche Zimmer haben Meerblick?",
      "a": "Die Doppelzimmer mit Meerblick und Balkon sowie einige Familienzimmer; die Zimmernamen auf dieser Website enthalten „Meerblick“, wenn sie zum Wasser ausgerichtet sind. Zimmer mit Poolblick sind etwas günstiger und abends ruhiger."
     },
     {
      "q": "Lohnt sich ein Zimmer mit Meerblick in Ulcinj?",
      "a": "Für einen Sommerurlaub sagen die meisten Paare ja — der Sonnenuntergang vom Balkon ist der Höhepunkt des Tages. Wenn Sie wenig Zeit im Zimmer verbringen, sparen Sie mit einem Zimmer mit Poolblick €10–20 pro Nacht bei demselben Strand und denselben Mahlzeiten."
     }
    ]
   },
   {
    "slug": "hotel-ulqin",
    "filter": "family",
    "title": "Hotel in Ulqin für Gäste aus Kosovo und Albanien",
    "metaTitle": "Hotel Ulqin — Preise für Bajram & Sommerwochen | La Rosa Negra",
    "metaDescription": "Familiengeführtes Hotel in Ulqin, 2 Minuten von Plazhi i Madh entfernt: aktuelle Preise für Fitër und Kurban Bajram, Dita e Verës und die Sommerwochen der Diaspora. Albanischsprachiger Service, Garagenparkplätze, Halbpension.",
    "intro": [
     "Ulqin ist das nächstgelegene Meer für Prishtina und Tirana: etwa 5 Stunden von Prishtina über die Rruga e Kombit und Shkodër, 2 Stunden von Tirana und 1 Stunde von Shkodër über den Grenzübergang Muriqan–Sukobin. Das Hotel La Rosa Negra liegt auf der Seite von Plazhi i Madh (Velika Plaža), etwa 2 Gehminuten vom Sand entfernt — an der Rezeption wird Albanisch gesprochen und die Garage mit 60 Stellplätzen bedeutet, dass Ihr Auto während des gesamten Aufenthalts sicher steht.",
     "Jeder Preis beinhaltet Halbpension (Frühstücks- und Abendbuffet), den Außenpool mit Kinderbereich, WLAN und Parkplatz. Die Familienzimmer bieten Platz für 3–5 Personen. Unten sehen Sie den aktuellen Direktpreis für die Wochen, in denen die meisten unserer Gäste aus Kosovo und Albanien reisen: Fitër und Kurban Bajram, Dita e Verës, 17. Februar und die Diaspora-Wochen Ende Juli und im August — bei Direktbuchung zahlen Sie 10% weniger als auf Booking.com."
    ],
    "facts": [
     {
      "label": "Von Prishtina",
      "value": "≈ 330 km · etwa 5 Std. mit dem Auto über Shkodër"
     },
     {
      "label": "Von Tirana / Shkodër",
      "value": "130 km · 2 Std. / 45 km · 1 Std."
     },
     {
      "label": "Sprache & Geld",
      "value": "Albanisch gesprochen · Euro, bar und Karte"
     },
     {
      "label": "Inbegriffen",
      "value": "Halbpension, Pool, WLAN, Garagenparkplatz"
     }
    ],
    "faq": [
     {
      "q": "Wie kommen wir von Kosovo nach Ulqin?",
      "a": "Mit dem Auto: Prishtina → Rruga e Kombit → Kukës → Shkodër → Grenzübergang Muriqan → Ulqin, etwa 5 Stunden; außerhalb der Hauptzeiten am Freitag- und Sonntagabend im August geht es an der Grenze meist schnell. Im Sommer fahren täglich Busse von Prishtina und Tirana nach Ulqin; ein Taxi vom Busbahnhof Ulqin zum Hotel kostet etwa €10."
     },
     {
      "q": "Haben Sie Zimmer für die Bajram-Feiertage?",
      "a": "Ja, wenn das Hotel saisonal geöffnet ist — Kurban Bajram im Mai liegt innerhalb der Saison, Fitër Bajram im März hängt vom jeweiligen Jahr ab. Die Tabelle auf dieser Seite zeigt den aktuellen Preis für jeden Feiertag; wenn dort „auf Anfrage“ steht, schreiben Sie uns auf WhatsApp und wir bestätigen innerhalb weniger Stunden."
     },
     {
      "q": "Können Kinder beim Abendessen mit uns essen, und ist das Essen halal?",
      "a": "Die Halbpension gilt für alle Personen im Zimmer, Kinder eingeschlossen. Das Abendessen ist ein Buffet mit Fisch, gegrilltem Fleisch, Gemüse und Salaten. Wie die meisten Hotels in Ulcinj kochen wir ohne Schweinefleisch, und das Hotel ist alkoholfrei — eine ruhige Wahl, die viele Familien aus dem Kosovo, Albanien und der Diaspora schätzen."
     }
    ]
   },
   {
    "slug": "plazhi-i-madh-ulqin",
    "filter": "all",
    "title": "Plazhi i Madh, Ulqin — Hotel 2 Minuten vom Sand entfernt",
    "metaTitle": "Plazhi i Madh Ulqin — Hotel 2 Min vom Strand | La Rosa Negra",
    "metaDescription": "Plazhi i Madh (Velika Plaža), Ulqin: 13 km flacher Sandstrand für Familien, Preise für die Sommerwochen aus Kosovo und Albanien und ein familiengeführtes Hotel 2 Minuten vom Strand entfernt mit Halbpension und Pool.",
    "intro": [
     "Plazhi i Madh — Velika Plaža, der Long Beach — ist 13 km feiner, flacher Sand von Port Milena bis zum Fluss Buna. Das Wasser bleibt über viele Dutzend Meter knietief, weshalb Familien aus Kosovo und Albanien seit Generationen hierherkommen. Strandrestaurants vermieten Liegen (in der Saison etwa €10–15 pro Set), Rettungsschwimmer sind im Juli und August im Einsatz, und der Abschnitt bei Ada Bojana ist der Kitesurfing-Spot.",
     "Das Hotel La Rosa Negra liegt etwa 2 Gehminuten vom Sand entfernt und bietet Balkone mit Meerblick, einen Außenpool, Halbpension in jedem Preis und eine private Garage. Die Altstadt von Ulqin mit ihren Restaurants ist 5 km entfernt. Die untenstehenden Preise sind aktuell für die Wochen, in denen die meisten unserer albanischsprachigen Gäste reisen; bei Direktbuchung zahlen Sie 10% weniger als auf Booking.com."
    ],
    "facts": [
     {
      "label": "Der Strand",
      "value": "13 km flacher Sand · Rettungsschwimmer Jul–Aug"
     },
     {
      "label": "Entfernung vom Hotel",
      "value": "Etwa 2 Minuten zu Fuß"
     },
     {
      "label": "Meer",
      "value": "23–26 °C von Juni bis September"
     },
     {
      "label": "Altstadt",
      "value": "5 km · Taxi etwa €10 · Strandbus im Sommer"
     }
    ],
    "faq": [
     {
      "q": "Ist Plazhi i Madh gut für kleine Kinder?",
      "a": "Es ist der flachste Strand an dieser Küste — der Sand fällt sehr sanft ab, sodass Kinder weit vom Ufer entfernt im knietiefen Wasser spielen können. Bringen Sie für die Mittagszeit Schatten mit; das Hotel hat auch einen Kinderbereich im Pool."
     },
     {
      "q": "Wie voll ist es im August?",
      "a": "Die Diaspora-Wochen (Ende Juli bis Mitte August) sind die geschäftigste Zeit des Jahres — buchen Sie früh, gehen Sie vor 10:00 Uhr an den Strand, wenn Sie die ersten Reihen der Liegen möchten, und rechnen Sie am Freitag- und Sonntagabend mit Warteschlangen am Grenzübergang Muriqan. Ende August und im September ist es deutlich ruhiger bei gleich warmem Meer."
     },
     {
      "q": "Wo parken wir?",
      "a": "In unserer privaten Garage mit 60 Stellplätzen, im Preis inbegriffen. Auf der Strandstraße selbst ist das Parken im Sommer kostenpflichtig und knapp, daher lassen die meisten Gäste das Auto am Hotel stehen und gehen zu Fuß."
     }
    ]
   },
   {
    "slug": "halal-friendly-family-hotel-ulcinj",
    "filter": "family",
    "title": "Alkoholfreies Familienhotel in Ulcinj, 2 Minuten von Velika Plaža entfernt",
    "metaTitle": "Alkoholfreies Familienhotel in Ulcinj (Ulqin) nahe Velika Plaža | La Rosa Negra",
    "metaDescription": "Ruhiges Familienhotel in Ulcinj / Ulqin, 2 Minuten von Velika Plaža (Plazhi i Madh) entfernt: Halbpension, Pool mit Kinderbereich, kostenlose Garage, Albanisch wird gesprochen, kein Alkoholausschank. Live-Preise für Bajram und die Sommerwochen der Diaspora.",
    "intro": [
     "Hotel La Rosa Negra ist ein familiengeführtes Drei-Sterne-Hotel auf der Seite von Velika Plaža (Plazhi i Madh) in Ulcinj, etwa 2 Gehminuten vom Sand entfernt. Es ist ein ruhiger Ort: keine Barszene, kein Alkoholausschank, Kinder laufen zwischen Pool und Strand hin und her, Eltern sitzen mit einem Kaffee auf der Terrasse. Familien aus Kosovo, Albanien, Nordmazedonien und der Diaspora in Deutschland, der Schweiz und Österreich kommen Jahr für Jahr wieder — viele von ihnen immer für dieselben zwei Wochen im Sommer.",
     "Halbpension ist in jedem Preis inbegriffen — Frühstücksbuffet und Abendbuffet mit Fisch, Grillfleisch, Gemüse, Salaten und Süßspeisen, so zubereitet, wie in den Küchen von Ulcinj gekocht wird; zum Abendessen gibt es Säfte, Softdrinks, Wasser, Kaffee und Tee. Die Familienzimmer bieten Platz für 3–5 Personen, der Außenpool hat einen Kinderbereich, die Garage mit 60 Stellplätzen ist kostenlos und an der Rezeption wird Albanisch, Montenegrinisch, Englisch und Deutsch gesprochen. Unten sehen Sie den aktuellen Direktpreis für die Wochen, in denen unsere Gäste am häufigsten reisen — Fitër und Kurban Bajram, Dita e Verës und die Diaspora-Wochen Ende Juli und im August — immer 10% unter unserem Preis auf Booking.com."
    ],
    "facts": [
     {
      "label": "Familien",
      "value": "Zimmer für 3–5 · Kinderpool · 2 Min. bis zum Strand"
     },
     {
      "label": "Atmosphäre",
      "value": "Ruhiges, alkoholfreies Hotel · Terrassencafé"
     },
     {
      "label": "Inbegriffen",
      "value": "Halbpension, Pool, WLAN, Garagenparkplatz"
     },
     {
      "label": "Sprachen",
      "value": "Albanisch, Montenegrinisch, Englisch, Deutsch"
     }
    ],
    "faq": [
     {
      "q": "Ist das Essen für muslimische Familien geeignet?",
      "a": "Ja — wie in den meisten Hotels in Ulcinj kocht unsere Küche ohne Schweinefleisch, und in der Küche wird kein Alkohol verwendet oder im Hotel ausgeschenkt. Wir haben kein formelles Halal-Zertifikat; wenn Ihnen das wichtig ist, schreiben Sie uns vor der Buchung, und wir sagen Ihnen ehrlich, woher das Fleisch kommt."
     },
     {
      "q": "Gibt es wirklich keinen Alkohol, auch nicht im Zimmerkühlschrank oder auf der Terrasse?",
      "a": "Genau — das Hotel ist alkoholfrei. Die Kühlschränke in den Zimmern sind leer für Ihre eigenen Getränke, das Café serviert Kaffee, Tee, frische Säfte und Softdrinks, und weder beim Abendessen noch auf der Terrasse wird Alkohol verkauft. Gäste, die ein Glas Wein möchten, finden es in den Strandrestaurants 150 m entfernt."
     },
     {
      "q": "Können wir zu Bajram oder in den Sommerferien mit einer großen Familie kommen?",
      "a": "Ja. Die Familienzimmer bieten Platz für bis zu 5 Personen, und wenn Sie als größere Gruppe reisen, sagen Sie uns Bescheid, dann versuchen wir, Sie in benachbarten Zimmern unterzubringen. Die Tabelle auf dieser Seite zeigt den aktuellen Preis für Kurban Bajram, Fitër Bajram und die Diaspora-Wochen — wenn in einer Zeile „auf Anfrage“ steht, schicken Sie uns eine WhatsApp-Nachricht und wir bestätigen innerhalb weniger Stunden."
     }
    ]
   }
  ]
 },
 "ru": {
  "nav": "Популярные варианты проживания",
  "intro": "Найдите вариант проживания, который подходит именно вам — на каждой странице показаны подходящие номера с актуальными прямыми ценами.",
  "roomsHeading": "Номера, подходящие для этого варианта проживания",
  "faqHeading": "Полезно знать",
  "otherHeading": "Другие популярные поисковые запросы",
  "from": "от",
  "perNight": "за ночь",
  "book": "Проверить наличие",
  "topics": [
   {
    "slug": "family-hotel-velika-plaza",
    "filter": "family",
    "title": "Семейный отель на Velika Plaža, Улцинь",
    "metaTitle": "Семейный отель на Velika Plaža, Улцинь — La Rosa Negra",
    "metaDescription": "Семейные номера для 3–5 гостей, детский бассейн, мелкий песчаный пляж в нескольких шагах, полупансион и бесплатная парковка. Семейный отель на Velika Plaža, Улцинь — лучшая цена напрямую.",
    "intro": [
     "Velika Plaža — это 13 км мелкого песка и пологого входа в море, самый безопасный пляж в Черногории для маленьких детей, а Hotel La Rosa Negra находится прямо рядом с ним. В наших семейных номерах и двухспартаментных апартаментах могут разместиться от 3 до 5 гостей; есть диваны-кровати, мини-кухни и террасы, где дети могут играть, пока вы пьёте кофе.",
     "Полупансион включён (завтрак и ужин «шведский стол»), в бассейне есть неглубокая детская зона с шезлонгами, а частный гараж на 60 мест избавит вас от поисков парковки после поездки в Ada Bojana или Старый город."
    ],
    "facts": [
     {
      "label": "Семейные номера",
      "value": "3–5 гостей, диваны-кровати и мини-кухни"
     },
     {
      "label": "Пляж",
      "value": "Мелкий песок, 2 минуты пешком"
     },
     {
      "label": "Питание",
      "value": "Полупансион включён"
     },
     {
      "label": "Дополнительно",
      "value": "Детская кроватка и дополнительная кровать по запросу"
     }
    ],
    "faq": [
     {
      "q": "Дети проживают бесплатно?",
      "a": "Дети до 2 лет проживают бесплатно в детской кроватке. Для детей постарше мы рекомендуем семейный номер или двухспальные апартаменты — указанная цена уже включает заявленное количество гостей."
     },
     {
      "q": "Пляж безопасен для малышей?",
      "a": "Да — на Velika Plaža очень пологий вход в воду, поэтому море остаётся мелким на десятки метров. В июле и августе дежурят спасатели."
     },
     {
      "q": "Можно ли получить детскую кроватку или стульчик для кормления?",
      "a": "И то и другое предоставляется бесплатно — сообщите при бронировании или на стойке регистрации."
     }
    ]
   },
   {
    "slug": "hotel-with-pool-ulcinj",
    "filter": "pool",
    "title": "Отель с бассейном в Улцине",
    "metaTitle": "Отель с бассейном в Улцине у пляжа — La Rosa Negra",
    "metaDescription": "Открытый бассейн с шезлонгами, детской зоной и номерами у бассейна, в 2 минутах от Velika Plaža. Отель с бассейном в Улцине — полупансион и парковка включены.",
    "intro": [
     "Море утром, бассейн днём: в Hotel La Rosa Negra есть открытый бассейн с бесплатными шезлонгами и неглубокой детской зоной, окружённый пальмами и террасой отеля. Доступ к бассейну включён для всех гостей.",
     "Выберите двухместный номер у бассейна, чтобы выходить прямо из номера на террасу у воды, или номер с видом на море на верхнем этаже и наблюдайте с балкона и за бассейном, и за Адриатикой."
    ],
    "facts": [
     {
      "label": "Бассейн",
      "value": "Открытый, бесплатные шезлонги, детская зона"
     },
     {
      "label": "Сезон",
      "value": "Май – октябрь"
     },
     {
      "label": "Номера у бассейна",
      "value": "Двухместный номер у бассейна"
     },
     {
      "label": "Также",
      "value": "Пляж в 2 минутах, полупансион включён"
     }
    ],
    "faq": [
     {
      "q": "Бассейн подогревается?",
      "a": "Нет — это открытый бассейн с пресной водой, комфортный с конца мая до начала октября благодаря 2 500 часам солнечного света в год."
     },
     {
      "q": "Полотенца и шезлонги бесплатные?",
      "a": "Шезлонги бесплатны для гостей отеля; полотенца для бассейна выдаются на стойке регистрации."
     },
     {
      "q": "Могут ли дети пользоваться бассейном?",
      "a": "Да, есть неглубокая детская зона. Дети должны находиться в сопровождении взрослых."
     }
    ]
   },
   {
    "slug": "half-board-hotel-ulcinj",
    "filter": "all",
    "title": "Отель с полупансионом в Улцине",
    "metaTitle": "Отель с полупансионом в Улцине — завтрак и ужин включены | La Rosa Negra",
    "metaDescription": "Завтрак и ужин «шведский стол» включены в каждый тариф. Отель с полупансионом на Velika Plaža, Улцинь, с бассейном, парковкой и номерами с видом на море — от €40 за ночь при прямом бронировании.",
    "intro": [
     "Во все тарифы Hotel La Rosa Negra включён полупансион: завтрак «шведский стол» и ужин из трёх блюд в нашем ресторане с черногорской и средиземноморской кухней, свежей рыбой из Улциня и ежедневными вегетарианскими блюдами.",
     "Полупансион избавляет от лишнего планирования пляжного отдыха — вернитесь с пляжа, примите душ, и ужин уже готов. Пообедать можно в пляжных барах прямо перед отелем."
    ],
    "facts": [
     {
      "label": "Включено",
      "value": "Завтрак «шведский стол» + ужин из 3 блюд"
     },
     {
      "label": "Кухня",
      "value": "Черногорская и средиземноморская, свежая рыба"
     },
     {
      "label": "Питание",
      "value": "Вегетарианские блюда ежедневно, аллергии — по запросу"
     },
     {
      "label": "Цены",
      "value": "Номера от €40 за ночь"
     }
    ],
    "faq": [
     {
      "q": "Во сколько ужин?",
      "a": "Ужин подаётся с 19:00 до 21:30; завтрак — с 07:30 до 10:00 (часы могут немного меняться в зависимости от сезона)."
     },
     {
      "q": "Можно ли забронировать только номер?",
      "a": "Все наши прямые тарифы включают полупансион — это лучшее соотношение цены и качества. Свяжитесь со стойкой регистрации, если у вас есть особые требования."
     },
     {
      "q": "Напитки включены?",
      "a": "Вода включена в ужин; другие напитки доступны в баре ресторана."
     }
    ]
   },
   {
    "slug": "hotel-near-podgorica-airport",
    "filter": "all",
    "title": "Пляжный отель рядом с аэропортами Подгорицы и Тивата",
    "metaTitle": "Пляжный отель в 90 минутах от аэропортов Подгорицы и Тивата — La Rosa Negra, Улцинь",
    "metaDescription": "Прилетайте в Подгорицу (TGD) или Тиват (TIV) и добирайтесь до Velika Plaža примерно за 90 минут. Трансфер из аэропорта €80 в одну сторону, бесплатная парковка, полупансион. Бронируйте напрямую.",
    "intro": [
     "Улцинь обслуживают два аэропорта Черногории — Подгорица (TGD, около 85 км) и Тиват (TIV, около 95 км) — оба находятся примерно в 90 минутах езды на машине от Hotel La Rosa Negra. Аэропорт Тираны (TIA) в Албании — третий вариант, примерно в 2 часах через погранпереход Muriqan.",
     "Мы организуем индивидуальные трансферы за €80 в одну сторону (до 4 гостей): вас встретят в зале прилёта; если вы арендуете автомобиль, наш частный гараж на 60 мест предоставляется гостям бесплатно."
    ],
    "facts": [
     {
      "label": "Подгорица (TGD)",
      "value": "≈ 85 км · 1 ч 30 мин"
     },
     {
      "label": "Тиват (TIV)",
      "value": "≈ 95 км · 1 ч 35 мин"
     },
     {
      "label": "Тирана (TIA)",
      "value": "≈ 130 км · 2 ч"
     },
     {
      "label": "Трансфер",
      "value": "€80 в одну сторону, до 4 гостей"
     }
    ],
    "faq": [
     {
      "q": "Как забронировать трансфер из аэропорта?",
      "a": "Добавьте его при онлайн-регистрации или отправьте нам номер рейса по электронной почте — водитель будет ждать в зоне прилёта с табличкой с именем."
     },
     {
      "q": "Есть ли автобус из аэропорта?",
      "a": "Прямого автобуса нет. Доедьте на такси или автобусе до автовокзала Подгорицы или Бара, затем сядьте на автобус до Улциня (летом — каждый час), после чего возьмите такси до отеля."
     },
     {
      "q": "Какой аэропорт лучше?",
      "a": "В Подгорицу обычно больше рейсов и ниже тарифы; Тиват живописнее. Время в пути до отеля почти одинаковое."
     }
    ]
   },
   {
    "slug": "romantic-hotel-ulcinj",
    "filter": "couples",
    "title": "Романтический отель с видом на море в Улцине для пар",
    "metaTitle": "Романтический отель с видом на море в Улцине для пар — La Rosa Negra",
    "metaDescription": "Номера с балконом и видом на море, закаты над Velika Plaža, ужин включён и романтическое оформление по запросу. Отель для пар в Улцине, Черногория — бронируйте напрямую.",
    "intro": [
     "Солнце садится прямо в Адриатику напротив Hotel La Rosa Negra — наблюдайте за этим с собственного балкона с видом на море с бокалом черногорского Vranac. Наши двухместные номера с балконом и видом на море и twin-номера с общей террасой с видом на море созданы для двоих.",
     "Добавьте романтическое оформление (цветы, фрукты и сладости в номере) во время онлайн-регистрации, поужинайте на террасе с включённым полупансионом и съездите за 20 минут в Ada Bojana на рыбный ужин у реки."
    ],
    "facts": [
     {
      "label": "Номера",
      "value": "Двухместные номера с балконом и видом на море"
     },
     {
      "label": "Закат",
      "value": "Прямо над морем, западная сторона"
     },
     {
      "label": "Романтическое оформление",
      "value": "€35 — вино, фрукты, цветы"
     },
     {
      "label": "Поездки на день",
      "value": "Ada Bojana, Старый город, бухта Valdanos"
     }
    ],
    "faq": [
     {
      "q": "Можно ли подготовить сюрприз на годовщину?",
      "a": "Да — выберите романтическое оформление при онлайн-регистрации или напишите нам; мы украсим номер до вашего приезда."
     },
     {
      "q": "В отеле тихо?",
      "a": "Отель находится на пляжной дороге Velika Plaža, вдали от ночной жизни Старого города; самые тихие номера — с видом на море на верхних этажах."
     },
     {
      "q": "Можно ли поздний выезд?",
      "a": "Поздний выезд до 14:00 стоит €20 при наличии возможности — можно забронировать при онлайн-регистрации."
     }
    ]
   },
   {
    "slug": "long-stay-workation-ulcinj",
    "filter": "longstay",
    "title": "Длительное проживание и workation в Улцине",
    "metaTitle": "Отель для длительного проживания и workation в Улцине, Черногория — La Rosa Negra",
    "metaDescription": "Остановитесь на неделю или месяц на Velika Plaža: апартаменты с мини-кухней, бесплатный Wi‑Fi, полупансион, парковка. Отель для длительного проживания и workation в Улцине — запросите месячный тариф.",
    "intro": [
     "Виза цифрового кочевника в Черногории и 300 солнечных дней в году делают Улцинь удобным местом для работы на удалёнке. Hotel La Rosa Negra предлагает апартаменты с мини-кухней и жилой зоной, бесплатный Wi‑Fi на всей территории, тихую террасу и пляж для обеденного перерыва.",
     "При проживании от 7 ночей мы предлагаем сниженные тарифы, а на месяц и дольше — индивидуальную цену с еженедельной уборкой. Напишите нам ваши даты."
    ],
    "facts": [
     {
      "label": "Апартаменты",
      "value": "Мини-кухня, жилая зона, балкон"
     },
     {
      "label": "Wi‑Fi",
      "value": "Бесплатный, оптоволоконный во всех номерах и на террасе"
     },
     {
      "label": "Тарифы для длительного проживания",
      "value": "Скидки от 7+ ночей, месячный тариф по запросу"
     },
     {
      "label": "Также",
      "value": "Полупансион, бассейн, бесплатный гараж"
     }
    ],
    "faq": [
     {
      "q": "Wi‑Fi достаточно хорош для видеозвонков?",
      "a": "Да — оптоволоконное подключение с Wi‑Fi в каждом номере и на террасе; на стойке регистрации вам также могут предложить тихое место для звонков."
     },
     {
      "q": "Можно ли готовить в номере?",
      "a": "В апартаментах есть мини-кухня с варочной панелью, холодильником и чайником. Полупансион всё равно включён, если вы не хотите готовить."
     },
     {
      "q": "Как получить месячный тариф?",
      "a": "Напишите на larosaulcinj@gmail.com ваши даты и предпочитаемый тип номера — мы ответим персональным предложением в течение 24 часов."
     }
    ]
   },
   {
    "slug": "cheap-hotel-ulcinj",
    "filter": "budget",
    "title": "Недорогой отель в Улцине на пляже — от €40",
    "metaTitle": "Недорогой пляжный отель в Улцине от €40 — La Rosa Negra, Velika Plaža",
    "metaDescription": "Бюджетные номера от €40 за ночь с включёнными полупансионом, бассейном и бесплатной парковкой — в 2 минутах от Velika Plaža. Честный недорогой отель в Улцине: бронируйте напрямую, экономьте 15 %.",
    "intro": [
     "Недорого — не значит далеко от пляжа. Наши двухместные номера economy и одноместные номера начинаются от €40 за ночь и при этом включают завтрак «шведский стол», ужин, бассейн и гараж — тот же пляж, те же закаты, что и в номерах с видом на море.",
     "Бронирование напрямую на этом сайте всегда как минимум на 15 % дешевле, чем на Booking.com, а ранние промокоды на июнь и сентябрь дают ещё 10 % скидки."
    ],
    "facts": [
     {
      "label": "От",
      "value": "€40 за ночь, включая полупансион"
     },
     {
      "label": "Экономия при прямом бронировании",
      "value": "≥ 15 % по сравнению с Booking.com"
     },
     {
      "label": "Раннее бронирование",
      "value": "−10 % по кодам на июнь и сентябрь"
     },
     {
      "label": "Включено",
      "value": "Бассейн, парковка, Wi‑Fi, ужин"
     }
    ],
    "faq": [
     {
      "q": "Какой номер самый дешёвый?",
      "a": "Small Single Room от €40 и Economy Double Room with Balcony (без вида) от €60 — оба с полупансионом."
     },
     {
      "q": "Почему напрямую дешевле?",
      "a": "Мы не платим комиссию за прямые бронирования и передаём эту экономию вам; также вы получаете бесплатную отмену до 24 ч до заезда."
     },
     {
      "q": "Когда в Улцине дешевле всего?",
      "a": "Май, июнь, сентябрь и октябрь — отличная погода, тёплое море и цены до 40 % ниже, чем в июле и августе."
     }
    ]
   },
   {
    "slug": "hotel-with-parking-ulcinj",
    "filter": "all",
    "title": "Отель с бесплатной парковкой в Улцине",
    "metaTitle": "Отель с бесплатной парковкой в Улцине — гараж на 60 мест | La Rosa Negra",
    "metaDescription": "Частный гараж на 60 мест включён в каждый тариф, в 2 минутах от Velika Plaža. Отель с бесплатной парковкой в Улцине — идеально для автопутешествий по Черногории и Албании.",
    "intro": [
     "Приезжаете на машине из Дубровника, Подгорицы или Тираны? В Hotel La Rosa Negra есть частный гараж на 60 мест, бесплатный для всех гостей — никакого стресса с уличной парковкой в высокий сезон, а ваш автомобиль остаётся в тени.",
     "От отеля 5 км до Старого города, 20 минут до Ada Bojana, 45 минут до Šaško Lake и час до Бара и Скадарского озера — Velika Plaža станет идеальной базой для автопутешествия по Черногории."
    ],
    "facts": [
     {
      "label": "Парковка",
      "value": "Частный гараж на 60 мест, бесплатно"
     },
     {
      "label": "Электромобили",
      "value": "Зарядка по запросу"
     },
     {
      "label": "Расстояния",
      "value": "Старый город 5 км · Ada Bojana 15 км · Бар 30 км"
     },
     {
      "label": "Граница",
      "value": "Албания (Muriqan) 25 мин"
     }
    ],
    "faq": [
     {
      "q": "Нужно ли резервировать парковочное место?",
      "a": "Нет — гараж включён, и место есть для каждого номера. В редком случае, если он заполнен, рядом с отелем доступна бесплатная парковка."
     },
     {
      "q": "Можно ли зарядить электромобиль?",
      "a": "Да, по запросу на стойке регистрации (обычная розетка); быстрые зарядные станции есть в городе Улцинь."
     },
     {
      "q": "Легко ли ехать из Дубровника?",
      "a": "Около 3 ч 30 мин вдоль побережья через Будву и Бар; в июле и августе закладывайте дополнительное время на хорватской границе."
     }
    ]
   },
   {
    "slug": "hotels-in-ulcinj",
    "filter": "all",
    "title": "Отели в Улцине: какой район выбрать",
    "metaTitle": "Отели в Улцине — где остановиться и цены | La Rosa Negra",
    "metaDescription": "Отели в Улцине, Черногория: Старый город или Velika Plaža, или Ada Bojana, сколько стоят номера в сезон и семейный отель в 2 минутах от Long Beach.",
    "intro": [
     "В Улцине (Ulqin) есть три очень разные зоны для проживания. Старый город и Mala Plaža — оживлённые и исторические места, с ресторанами на крепостных стенах, но также со ступеньками, трафиком и почти полным отсутствием парковки в июле и августе. Velika Plaža (Long Beach) и равнина Штой за ней — ровные, тихие и удобные для семейного отдыха, с 13 км мелководного песчаного пляжа и большинством новых отелей города. Ada Bojana, в самом конце пляжа, — удалённый речной остров для кайтсёрферов и натуристов.",
     "Hotel La Rosa Negra находится со стороны Velika Plaža: это семейный отель 3 звезды примерно в 2 минутах ходьбы от песка и в 5 км от Старого города. В стоимость входит полупансион (завтрак и ужин «шведский стол»), открытый бассейн, Wi‑Fi и частный гараж на 60 мест. Номера стоят €40–150 за ночь в зависимости от сезона и вида, а при прямом бронировании цена на 10% ниже, чем у нас на Booking.com."
    ],
    "facts": [
     {
      "label": "Районы",
      "value": "Старый город · Velika Plaža / Штой · Ada Bojana"
     },
     {
      "label": "Типичные цены",
      "value": "Номера в отелях 3 звезды €40–150 за ночь, полупансион"
     },
     {
      "label": "Наше расположение",
      "value": "2 мин до песка, 5 км до Старого города"
     },
     {
      "label": "Как добраться",
      "value": "Аэропорт Подгорицы или Тивата ≈ 90 мин, Тирана 2 ч"
     }
    ],
    "faq": [
     {
      "q": "Какая часть Улциня лучше всего подходит для пляжного отдыха?",
      "a": "Velika Plaža. Песок здесь мелкий, а вход в воду остаётся неглубоким на десятки метров, пляжные рестораны сдают шезлонги, а местность ровная и удобная для отдыха с детьми или на машине. Старый город больше подходит для короткой городской поездки: там больше ресторанов и ночной жизни, но пляжи маленькие, галечные, а парковки мало."
     },
     {
      "q": "Сколько стоит отель в Улцине?",
      "a": "В июле и августе двухместный номер в отеле 3 звезды обычно стоит €90–150 за ночь; в июне и сентябре €60–100; весной и осенью — от примерно €40. В наши цены входят завтрак и ужин, бассейн и парковка, поэтому сравнивайте общую стоимость, а не только цену номера без питания."
     },
     {
      "q": "Как добраться из аэропорта до отеля на Velika Plaža?",
      "a": "Аэропорты Подгорицы (TGD) и Тивата (TIV) находятся примерно в 80 км / 90 минутах езды; Тирана (TIA) — в 130 км / 2 часах через погранпереход Muriqan. Мы организуем частный трансфер за €80 в одну сторону, либо можно доехать на автобусе до Улциня и взять такси (около €10) на последние 4 км."
     }
    ]
   },
   {
    "slug": "velika-plaza-hotels",
    "filter": "all",
    "title": "Отели на Velika Plaža (Long Beach), Улцинь",
    "metaTitle": "Отели Velika Plaža — Long Beach Ulcinj | La Rosa Negra",
    "metaDescription": "Отели на Velika Plaža, Улцинь: 13 км мелководного песчаного пляжа, насколько близко отели находятся к воде, цены по месяцам и семейный отель в 2 минутах от пляжа.",
    "intro": [
     "Velika Plaža — Long Beach, Plazhi i Madh — тянется примерно на 13 км от Port Milena до реки Bojana. Это самый длинный пляж на восточном побережье Адриатики и один из самых мелководных: вода остаётся по колено на десятки метров, поэтому его выбирают семьи с маленькими детьми. Сам пляж охраняется и почти не застроен, поэтому отели расположены за прибрежной дорогой в Штое и Доньи Штое, в нескольких минутах ходьбы от песка.",
     "Hotel La Rosa Negra — один из них: примерно в 2 минутах ходьбы от воды, с открытым бассейном, полупансионом, включённым в каждый тариф, бесплатным Wi‑Fi и частным гаражом на 60 мест. Во многих номерах есть балкон с видом на море. Старый город, рестораны Улциня и автовокзал находятся в 4–5 км — это 10 минут на машине или летний пляжный автобус."
    ],
    "facts": [
     {
      "label": "Пляж",
      "value": "≈13 км мелкого серого песка, очень мелко, спасатели июль–август"
     },
     {
      "label": "Расстояние до песка",
      "value": "Около 2 минут пешком от отеля"
     },
     {
      "label": "Температура моря",
      "value": "22–26 °C с июня по сентябрь"
     },
     {
      "label": "Чем заняться",
      "value": "Кайтсёрфинг в конце у Ada Bojana, пляжные рестораны, велодорожка"
     }
    ],
    "faq": [
     {
      "q": "Есть ли отели прямо на песке Velika Plaža?",
      "a": "Нет. Пляж — это охраняемая природная зона, поэтому отели и апартаменты расположены за прибрежной дорогой в Штое и Доньи Штое. Ближайшие, включая Hotel La Rosa Negra, находятся примерно в 150 м — 2 минутах пешком — от воды."
     },
     {
      "q": "Как далеко Velika Plaža от Старого города Улциня?",
      "a": "Пляж начинается примерно в 1,5 км к юго-востоку от города; наша часть находится в 5 км от Старого города — около 10 минут на машине или такси (примерно €10). В июле и августе по прибрежной дороге ходит пляжный автобус."
     },
     {
      "q": "Когда лучше всего останавливаться на Velika Plaža?",
      "a": "Июнь и сентябрь — это тёплое море (23–25 °C), более спокойные пляжи и цены на 30–40% ниже, чем в августе. Июль и август — самые жаркие и самые оживлённые месяцы. С октября по май пляж почти пустой, и многие пляжные рестораны закрыты; отель остаётся открытым с зимними тарифами."
     }
    ]
   },
   {
    "slug": "sea-view-hotel-ulcinj",
    "filter": "couples",
    "title": "Номера в отеле с видом на море в Улцине",
    "metaTitle": "Отель с видом на море в Улцине — номера с балконом | La Rosa Negra",
    "metaDescription": "Номера с балконом и видом на море в Улцине, в 2 минутах от Velika Plaža: какие номера выходят к воде, цены по сезонам, полупансион включён. Бронируйте напрямую и экономьте 10%.",
    "intro": [
     "Отель расположен на ровной равнине Штой за Velika Plaža, поэтому вид на море здесь — это открытая Адриатика над дюнами и пляжными ресторанами, а не панорама с вершины утёса. Номера с пометкой «вид на море» выходят на юго-запад в сторону воды и заката; номера с другой стороны смотрят на бассейн и горы Румия. На каждом балконе есть стол и два стула.",
     "Двухместные номера с видом на море — самые востребованные в июле и августе, поэтому бронируйте заранее. Во все тарифы входят полупансион, открытый бассейн, Wi‑Fi и парковка в гараже; при прямом бронировании цена на 10% ниже, чем у нас на Booking.com, а изменить или отменить бронирование можно в соответствии с выбранным тарифом."
    ],
    "facts": [
     {
      "label": "Вид",
      "value": "Адриатика над дюнами, сторона заката"
     },
     {
      "label": "Балкон",
      "value": "Собственный, со столом и двумя стульями"
     },
     {
      "label": "Пляж",
      "value": "Около 2 минут пешком"
     },
     {
      "label": "Разница в цене",
      "value": "Обычно на €10–20 за ночь дороже, чем номер у бассейна"
     }
    ],
    "faq": [
     {
      "q": "Можно ли увидеть море из номера?",
      "a": "Из номеров с видом на море — да: открытая Адриатика за дюнами и пляжными ресторанами, примерно в 150 м. Из номеров на первом этаже видно меньше; с верхних этажей вид самый лучший. Если вид для вас важен, напишите об этом в комментарии к бронированию, и мы предоставим лучший доступный номер."
     },
     {
      "q": "Какие номера имеют вид на море?",
      "a": "Двухместные номера с балконом и видом на море, а также некоторые семейные номера; в названиях номеров на этом сайте указано «вид на море», если они выходят к воде. Номера с видом на бассейн немного дешевле и тише по вечерам."
     },
     {
      "q": "Стоит ли брать номер с видом на море в Улцине?",
      "a": "Для летнего отдыха большинство пар считают, что да — закат с балкона становится главным моментом дня. Если вы мало времени проводите в номере, номер с видом на бассейн позволит сэкономить €10–20 за ночь при том же пляже и питании."
     }
    ]
   },
   {
    "slug": "hotel-ulqin",
    "filter": "family",
    "title": "Отель в Ulqin для гостей из Косово и Албании",
    "metaTitle": "Отель Ulqin — Цены на Байрам и летние недели | La Rosa Negra",
    "metaDescription": "Семейный отель в Ulqin, в 2 минутах от Plazhi i Madh: актуальные цены на Фитр-байрам и Курбан-байрам, Dita e Verës и летние недели диаспоры. На ресепшене говорят по-албански, есть крытая парковка, полупансион.",
    "intro": [
     "Ulqin — ближайшее море для Притиштины и Тираны: около 5 часов от Приштины через Rruga e Kombit и Shkodër, 2 часа от Тираны и 1 час от Shkodër через погранпереход Muriqan–Sukobin. Hotel La Rosa Negra находится со стороны Plazhi i Madh (Velika Plaža), примерно в 2 минутах пешком от песка — на ресепшене говорят по-албански, а гараж на 60 мест означает, что ваш автомобиль будет в безопасности в течение всего отдыха.",
     "В каждый тариф включены полупансион (завтрак и ужин «шведский стол»), открытый бассейн с детской зоной, Wi‑Fi и парковка. Семейные номера рассчитаны на 3–5 человек. Ниже вы видите актуальную прямую цену на недели, в которые путешествует большинство наших гостей из Косово и Албании: Фитр-байрам, Курбан-байрам, Dita e Verës, 17 февраля и недели диаспоры в конце июля и августе — при прямом бронировании цена на 10% ниже, чем на Booking.com."
    ],
    "facts": [
     {
      "label": "Из Приштины",
      "value": "≈ 330 км · около 5 ч на машине через Shkodër"
     },
     {
      "label": "Из Тираны / Shkodër",
      "value": "130 км · 2 ч / 45 км · 1 ч"
     },
     {
      "label": "Язык и валюта",
      "value": "Говорят по-албански · евро, наличные и карта"
     },
     {
      "label": "Включено",
      "value": "Полупансион, бассейн, Wi‑Fi, парковка в гараже"
     }
    ],
    "faq": [
     {
      "q": "Как добраться из Косово в Ulqin?",
      "a": "На машине: Prishtina → Rruga e Kombit → Kukës → Shkodër → граница Muriqan → Ulqin, около 5 часов; на границе обычно быстро, кроме пиковых вечеров пятницы и воскресенья в августе. Летом автобусы ежедневно ходят из Prishtina и Tirana в Ulqin; такси от автовокзала Ulqin до отеля стоит около €10."
     },
     {
      "q": "Есть ли у вас номера на праздники Байрам?",
      "a": "Да, если отель уже открыт на сезон — Курбан-байрам в мае входит в него, а Фитр-байрам в марте зависит от года. Таблица на этой странице показывает актуальную цену на каждый праздник; если указано 'по запросу', напишите нам в WhatsApp, и мы подтвердим в течение нескольких часов."
     },
     {
      "q": "Могут ли дети ужинать с нами, и халяльная ли еда?",
      "a": "Полупансион распространяется на всех проживающих в номере, включая детей. Ужин — «шведский стол» с рыбой, мясом на гриле, овощами и салатами. Как и большинство отелей Улциня, мы готовим без свинины, а отель — безалкогольный; спокойный выбор, который ценят многие семьи из Косово, Албании и диаспоры."
     }
    ]
   },
   {
    "slug": "plazhi-i-madh-ulqin",
    "filter": "all",
    "title": "Plazhi i Madh, Ulqin — отель в 2 минутах от песка",
    "metaTitle": "Plazhi i Madh Ulqin — Отель в 2 минутах от пляжа | La Rosa Negra",
    "metaDescription": "Plazhi i Madh (Velika Plaža), Ulqin: 13 км мелкого песка для семей, цены на летние недели для гостей из Косово и Албании и семейный отель в 2 минутах от пляжа с полупансионом и бассейном.",
    "intro": [
     "Plazhi i Madh — Velika Plaža, Длинный пляж — это 13 км мелкого пологого песка от Port Milena до реки Buna. Вода остаётся по колено на десятки метров, поэтому семьи из Косово и Албании приезжают сюда уже не одно поколение. Пляжные рестораны сдают в аренду лежаки (около €10–15 за комплект в сезон), спасатели работают в июле и августе, а участок у Ada Bojana — место для кайтсёрфинга.",
     "Hotel La Rosa Negra находится примерно в 2 минутах пешком от песка; к услугам гостей балконы с видом на море, открытый бассейн, полупансион в каждом тарифе и частный гараж. Старый город Ulqin с его ресторанами находится в 5 км. Цены ниже — актуальные для недель, в которые путешествует большинство наших албаноязычных гостей; бронируйте напрямую и платите на 10% меньше, чем на Booking.com."
    ],
    "facts": [
     {
      "label": "Пляж",
      "value": "13 км мелкого песка · спасатели июль–август"
     },
     {
      "label": "Расстояние от отеля",
      "value": "Около 2 минут пешком"
     },
     {
      "label": "Море",
      "value": "23–26 °C с июня по сентябрь"
     },
     {
      "label": "Старый город",
      "value": "5 км · такси около €10 · летний пляжный автобус"
     }
    ],
    "faq": [
     {
      "q": "Подходит ли Plazhi i Madh для маленьких детей?",
      "a": "Это самый мелководный пляж на этом побережье — песок уходит в воду очень плавно, поэтому дети могут играть по колено в воде далеко от берега. В полдень возьмите тень или зонт; в отеле также есть детская секция бассейна."
     },
     {
      "q": "Насколько многолюдно здесь в августе?",
      "a": "Недели диаспоры (конец июля — середина августа) — самые загруженные в году, поэтому бронируйте заранее, приходите на пляж до 10:00, чтобы занять первые ряды лежаков, и рассчитывайте на очереди на границе Muriqan в пятницу и воскресенье вечером. В конце августа и в сентябре здесь намного спокойнее, а море остаётся таким же тёплым."
     },
     {
      "q": "Где мы паркуемся?",
      "a": "В нашем частном гараже на 60 мест, который включён в стоимость. На самой пляжной дороге парковка платная и летом мест мало, поэтому большинство гостей оставляют машину в отеле и ходят пешком."
     }
    ]
   },
   {
    "slug": "halal-friendly-family-hotel-ulcinj",
    "filter": "family",
    "title": "Семейный отель без алкоголя в Улцине, в 2 минутах от Velika Plaža",
    "metaTitle": "Семейный отель без алкоголя в Улцине (Ulqin) рядом с Velika Plaža | La Rosa Negra",
    "metaDescription": "Спокойный семейный отель в Улцине / Ulqin, в 2 минутах от Velika Plaža (Plazhi i Madh): полупансион, бассейн с детской зоной, бесплатный гараж, говорят по-албански, алкоголь не подаётся. Актуальные цены на Байрам и летние недели диаспоры.",
    "intro": [
     "Hotel La Rosa Negra — семейный трёхзвёздочный отель на стороне Velika Plaža (Plazhi i Madh) в Улцине, примерно в 2 минутах ходьбы от песчаного пляжа. Здесь спокойно: без барной атмосферы, алкоголь не подаётся, дети бегают между бассейном и пляжем, родители сидят на террасе с кофе. Семьи из Косово, Албании, Северной Македонии и диаспоры в Германии, Швейцарии и Австрии возвращаются сюда из года в год — многие приезжают на одни и те же две недели каждое лето.",
     "Полупансион включён в любой тариф — завтрак «шведский стол» и ужин «шведский стол» с рыбой, мясом на гриле, овощами, салатами и десертами, приготовленными так, как готовят на кухнях Улциня; напитки на ужине — соки, безалкогольные напитки, вода, кофе и чай. Семейные номера рассчитаны на 3–5 человек, в открытом бассейне есть детская зона, гараж на 60 мест предоставляется бесплатно, а на стойке регистрации говорят на албанском, черногорском, английском и немецком. Ниже вы видите актуальную прямую цену на недели, когда наши гости путешествуют чаще всего — Fitër и Kurban Bajram, Dita e Verës и недели диаспоры в конце июля и в августе — всегда на 10% ниже нашей цены на Booking.com."
    ],
    "facts": [
     {
      "label": "Семьи",
      "value": "Номера на 3–5 человек · детский бассейн · 2 мин до пляжа"
     },
     {
      "label": "Атмосфера",
      "value": "Тихий отель без алкоголя · кафе на террасе"
     },
     {
      "label": "Включено",
      "value": "Полупансион, бассейн, Wi‑Fi, парковка в гараже"
     },
     {
      "label": "Языки",
      "value": "Албанский, черногорский, английский, немецкий"
     }
    ],
    "faq": [
     {
      "q": "Подходит ли питание для мусульманских семей?",
      "a": "Да — как и в большинстве отелей Улциня, на нашей кухне не готовят свинину, а алкоголь не используется на кухне и не подаётся в отеле. У нас нет официального сертификата халяль; если для вас это важно, напишите нам до бронирования, и мы честно расскажем, откуда поступает мясо."
     },
     {
      "q": "Правда ли, что алкоголя нет совсем, даже в холодильнике в номере или на террасе?",
      "a": "Да — отель полностью без алкоголя. Холодильники в номерах пустые и предназначены для ваших собственных напитков, в кафе подают кофе, чай, свежие соки и безалкогольные напитки, а на ужине и на террасе ничего алкогольного не продаётся. Гости, которые хотят бокал вина, находят его в пляжных ресторанах в 150 м от отеля."
     },
     {
      "q": "Можно ли приехать на Байрам или на летние каникулы большой семьёй?",
      "a": "Да. Семейные номера вмещают до 5 человек, а если вы путешествуете большой группой, сообщите нам, и мы постараемся разместить вас в соседних номерах. Таблица на этой странице показывает актуальную цену на Kurban Bajram, Fitër Bajram и недели диаспоры — если в строке указано 'по запросу', отправьте нам сообщение в WhatsApp, и мы подтвердим в течение нескольких часов."
     }
    ]
   }
  ]
 },
 "pl": {
  "nav": "Popularne pobyty",
  "intro": "Znajdź pobyt dopasowany do siebie — na każdej stronie pokazujemy pasujące pokoje z aktualnymi cenami bezpośrednimi.",
  "roomsHeading": "Pokoje pasujące do tego pobytu",
  "faqHeading": "Warto wiedzieć",
  "otherHeading": "Inne popularne wyszukiwania",
  "from": "od",
  "perNight": "za noc",
  "book": "Sprawdź dostępność",
  "topics": [
   {
    "slug": "family-hotel-velika-plaza",
    "filter": "family",
    "title": "Hotel rodzinny przy Velika Plaža, Ulcinj",
    "metaTitle": "Hotel rodzinny przy Velika Plaža, Ulcinj — La Rosa Negra",
    "metaDescription": "Pokoje rodzinne dla 3–5 osób, basen dla dzieci, płytka piaszczysta plaża kilka kroków od hotelu, śniadanie i obiadokolacja oraz bezpłatny parking. Hotel rodzinny przy Velika Plaža, Ulcinj — najlepsza cena bezpośrednio.",
    "intro": [
     "Velika Plaža to 13 km drobnego, płytkiego piasku — najbezpieczniejsza plaża w Czarnogórze dla małych dzieci, a Hotel La Rosa Negra stoi tuż obok. Nasze pokoje rodzinne i apartament z dwiema sypialniami mieszczą od 3 do 5 osób, z sofami do spania, aneksami kuchennymi i tarasami, gdzie dzieci mogą się bawić, gdy Ty pijesz kawę.",
     "W cenę wliczone jest śniadanie i obiadokolacja (śniadanie i kolacja w formie bufetu), basen ma płytką część dla dzieci z leżakami, a prywatny garaż na 60 miejsc oznacza brak szukania parkingu po dniu spędzonym w Ada Bojana lub na Starym Mieście."
    ],
    "facts": [
     {
      "label": "Pokoje rodzinne",
      "value": "3–5 gości, sofy do spania i aneksy kuchenne"
     },
     {
      "label": "Plaża",
      "value": "Płytki piasek, 2 minuty pieszo"
     },
     {
      "label": "Wyżywienie",
      "value": "Śniadanie i obiadokolacja w cenie"
     },
     {
      "label": "Dodatki",
      "value": "Łóżeczko dziecięce i dodatkowe łóżko na życzenie"
     }
    ],
    "faq": [
     {
      "q": "Czy dzieci nocują za darmo?",
      "a": "Dzieci do 2 lat nocują bezpłatnie w łóżeczku. Dla starszych dzieci polecamy pokój rodzinny lub apartament z dwiema sypialniami — pokazana cena obejmuje już podaną liczbę gości."
     },
     {
      "q": "Czy plaża jest bezpieczna dla maluchów?",
      "a": "Tak — zejście do wody na Velika Plaža jest bardzo łagodne, więc woda pozostaje płytka przez dziesiątki metrów. Ratownicy są na dyżurze w lipcu i sierpniu."
     },
     {
      "q": "Czy możemy dostać łóżeczko dziecięce lub krzesełko do karmienia?",
      "a": "Oba są dostępne bezpłatnie — wystarczy poprosić przy rezerwacji lub w recepcji."
     }
    ]
   },
   {
    "slug": "hotel-with-pool-ulcinj",
    "filter": "pool",
    "title": "Hotel z basenem w Ulcinj",
    "metaTitle": "Hotel z basenem w Ulcinj, przy plaży — La Rosa Negra",
    "metaDescription": "Basen zewnętrzny z leżakami, częścią dla dzieci i pokojami przy basenie, 2 minuty od Velika Plaža. Hotel z basenem w Ulcinj — śniadanie i obiadokolacja oraz parking w cenie.",
    "intro": [
     "Morze rano, basen po południu: Hotel La Rosa Negra ma odkryty basen z bezpłatnymi leżakami i płytką częścią dla dzieci, otoczony palmami i hotelowym tarasem. Korzystanie z basenu jest wliczone dla każdego gościa.",
     "Wybierz Pokój Dwuosobowy przy Basenie, aby wyjść prosto z pokoju na taras basenowy, albo pokój z widokiem na morze na piętrze i obserwuj z balkonu zarówno basen, jak i Adriatyk."
    ],
    "facts": [
     {
      "label": "Basen",
      "value": "Zewnętrzny, bezpłatne leżaki, część dla dzieci"
     },
     {
      "label": "Sezon",
      "value": "Maj – październik"
     },
     {
      "label": "Pokoje przy basenie",
      "value": "Pokój Dwuosobowy przy Basenie"
     },
     {
      "label": "Także",
      "value": "Plaża 2 min, śniadanie i obiadokolacja w cenie"
     }
    ],
    "faq": [
     {
      "q": "Czy basen jest podgrzewany?",
      "a": "Nie — to odkryty basen napełniany słodką wodą, komfortowy od końca maja do początku października dzięki 2 500 godzinom słońca rocznie."
     },
     {
      "q": "Czy ręczniki i leżaki są bezpłatne?",
      "a": "Leżaki są bezpłatne dla gości hotelowych; ręczniki basenowe wydawane są w recepcji."
     },
     {
      "q": "Czy dzieci mogą korzystać z basenu?",
      "a": "Tak, jest płytka część dla dzieci. Dzieci muszą być pod opieką osoby dorosłej."
     }
    ]
   },
   {
    "slug": "half-board-hotel-ulcinj",
    "filter": "all",
    "title": "Hotel ze śniadaniem i obiadokolacją w Ulcinj",
    "metaTitle": "Hotel ze śniadaniem i obiadokolacją w Ulcinj — śniadanie i kolacja w cenie | La Rosa Negra",
    "metaDescription": "Śniadanie i kolacja w formie bufetu wliczone w każdą cenę. Hotel ze śniadaniem i obiadokolacją przy Velika Plaža, Ulcinj z basenem, parkingiem i pokojami z widokiem na morze — od €40 za noc bezpośrednio.",
    "intro": [
     "Każda cena pokoju w Hotelu La Rosa Negra obejmuje śniadanie i obiadokolację: śniadanie w formie bufetu oraz trzydaniową kolację w naszej restauracji, z daniami kuchni czarnogórskiej i śródziemnomorskiej, świeżymi rybami z Ulcinj i codziennymi opcjami wegetariańskimi.",
     "Śniadanie i obiadokolacja ułatwiają planowanie plażowego urlopu — wracasz z plaży, bierzesz prysznic i kolacja już czeka. Lunch możesz zjeść w plażowych restauracjach tuż przed hotelem."
    ],
    "facts": [
     {
      "label": "W cenie",
      "value": "Śniadanie w formie bufetu + 3-daniowa kolacja"
     },
     {
      "label": "Kuchnia",
      "value": "Czarnogórska i śródziemnomorska, świeże ryby"
     },
     {
      "label": "Dieta",
      "value": "Opcje wegetariańskie codziennie, alergie na życzenie"
     },
     {
      "label": "Ceny",
      "value": "Pokoje od €40 za noc"
     }
    ],
    "faq": [
     {
      "q": "O której jest kolacja?",
      "a": "Kolacja serwowana jest od 19:00 do 21:30; śniadanie od 07:30 do 10:00 (godziny mogą się nieznacznie zmieniać w zależności od sezonu)."
     },
     {
      "q": "Czy mogę zarezerwować sam pokój?",
      "a": "Wszystkie nasze ceny bezpośrednie obejmują śniadanie i obiadokolację — to najlepsza opcja cenowa. Skontaktuj się z recepcją, jeśli masz szczególne wymagania."
     },
     {
      "q": "Czy napoje są wliczone?",
      "a": "Woda jest wliczona do kolacji; inne napoje są dostępne w barze restauracyjnym."
     }
    ]
   },
   {
    "slug": "hotel-near-podgorica-airport",
    "filter": "all",
    "title": "Hotel przy plaży blisko lotnisk Podgorica i Tivat",
    "metaTitle": "Hotel przy plaży 90 min od lotnisk Podgorica i Tivat — La Rosa Negra, Ulcinj",
    "metaDescription": "Przyleć do Podgoricy (TGD) lub Tivatu (TIV) i dotrzyj na Velika Plaža w około 90 minut. Transfer lotniskowy €80 w jedną stronę, bezpłatny parking, śniadanie i obiadokolacja. Rezerwuj bezpośrednio.",
    "intro": [
     "Ulcinj obsługują dwa lotniska w Czarnogórze — Podgorica (TGD, około 85 km) i Tivat (TIV, około 95 km) — oba położone mniej więcej 90 minut jazdy samochodem od Hotelu La Rosa Negra. Lotnisko w Tiranie (TIA) w Albanii to trzecia opcja, około 2 godzin przez przejście graniczne Muriqan.",
     "Organizujemy prywatne transfery za €80 w jedną stronę (do 4 gości), z odbiorem w hali przylotów; jeśli wynajmujesz samochód, nasz prywatny garaż na 60 miejsc jest bezpłatny dla gości."
    ],
    "facts": [
     {
      "label": "Podgorica (TGD)",
      "value": "≈ 85 km · 1 h 30"
     },
     {
      "label": "Tivat (TIV)",
      "value": "≈ 95 km · 1 h 35"
     },
     {
      "label": "Tirana (TIA)",
      "value": "≈ 130 km · 2 h"
     },
     {
      "label": "Transfer",
      "value": "€80 w jedną stronę, do 4 gości"
     }
    ],
    "faq": [
     {
      "q": "Jak zarezerwować transfer z lotniska?",
      "a": "Dodaj go podczas online check-in lub wyślij nam e-mail z numerem lotu — kierowca czeka w hali przylotów z tabliczką z nazwiskiem."
     },
     {
      "q": "Czy z lotniska jedzie autobus?",
      "a": "Nie ma bezpośredniego autobusu. Weź taksówkę lub autobus do dworca autobusowego w Podgoricy lub Barze, a stamtąd autokar do Ulcinj (latem co godzinę), potem taksówkę do hotelu."
     },
     {
      "q": "Które lotnisko jest lepsze?",
      "a": "Podgorica zwykle ma więcej lotów i niższe ceny; Tivat jest bardziej malowniczy. Czas dojazdu do hotelu jest prawie taki sam."
     }
    ]
   },
   {
    "slug": "romantic-hotel-ulcinj",
    "filter": "couples",
    "title": "Romantyczny hotel z widokiem na morze w Ulcinj dla par",
    "metaTitle": "Romantyczny hotel z widokiem na morze w Ulcinj dla par — La Rosa Negra",
    "metaDescription": "Pokoje z balkonem i widokiem na morze, zachody słońca nad Velika Plaža, kolacja w cenie i romantyczna aranżacja na życzenie. Hotel dla par w Ulcinj, Czarnogóra — rezerwuj bezpośrednio.",
    "intro": [
     "Słońce zachodzi prosto nad Adriatykiem przed Hotelem La Rosa Negra — oglądaj je z własnego balkonu z widokiem na morze z kieliszkiem czarnogórskiego Vranaca. Nasze pokoje dwuosobowe z balkonem i widokiem na morze oraz pokoje twin ze wspólnym tarasem z widokiem na morze są stworzone dla dwojga.",
     "Dodaj romantyczną aranżację (kwiaty, owoce i słodycze w pokoju) podczas online check-in, zjedz kolację na tarasie w ramach śniadania i obiadokolacji, a potem wybierz się 20 minut samochodem do Ada Bojana na kolację z rybą nad rzeką."
    ],
    "facts": [
     {
      "label": "Pokoje",
      "value": "Pokoje dwuosobowe z balkonem i widokiem na morze"
     },
     {
      "label": "Zachód słońca",
      "value": "Bezpośrednio nad morzem, ekspozycja zachodnia"
     },
     {
      "label": "Romantyczna aranżacja",
      "value": "€35 — wino, owoce, kwiaty"
     },
     {
      "label": "Wycieczki",
      "value": "Ada Bojana, Stare Miasto, zatoka Valdanos"
     }
    ],
    "faq": [
     {
      "q": "Czy możecie przygotować niespodziankę na rocznicę?",
      "a": "Tak — wybierz romantyczną aranżację w online check-in lub napisz do nas; udekorujemy pokój przed Twoim przyjazdem."
     },
     {
      "q": "Czy hotel jest cichy?",
      "a": "Hotel znajduje się przy nadmorskiej drodze na Velika Plaža, z dala od nocnego życia Starego Miasta; pokoje z widokiem na morze na wyższych piętrach są najcichsze."
     },
     {
      "q": "Czy możemy mieć późne wymeldowanie?",
      "a": "Późne wymeldowanie do 14:00 kosztuje €20, w zależności od dostępności — można je zarezerwować podczas online check-in."
     }
    ]
   },
   {
    "slug": "long-stay-workation-ulcinj",
    "filter": "longstay",
    "title": "Długi pobyt i workation w Ulcinj",
    "metaTitle": "Hotel na długi pobyt i workation w Ulcinj, Czarnogóra — La Rosa Negra",
    "metaDescription": "Zostań tydzień lub miesiąc przy Velika Plaža: apartamenty z aneksem kuchennym, bezpłatne WiFi, śniadanie i obiadokolacja, parking. Hotel na dłuższy pobyt i workation w Ulcinj — zapytaj o stawkę miesięczną.",
    "intro": [
     "Wiza dla cyfrowych nomadów w Czarnogórze i 300 słonecznych dni w roku sprawiają, że Ulcinj to łatwe miejsce do pracy zdalnej. Hotel La Rosa Negra oferuje apartamenty z aneksem kuchennym i częścią dzienną, bezpłatne WiFi w całym obiekcie, cichy taras i plażę idealną na przerwę obiadową.",
     "Przy pobytach od 7 nocy oferujemy obniżone stawki, a na miesiąc lub dłużej indywidualną cenę z cotygodniowym sprzątaniem — napisz do nas ze swoimi terminami."
    ],
    "facts": [
     {
      "label": "Apartamenty",
      "value": "Aneks kuchenny, część dzienna, balkon"
     },
     {
      "label": "WiFi",
      "value": "Bezpłatne, światłowód we wszystkich pokojach i na tarasie"
     },
     {
      "label": "Stawki długoterminowe",
      "value": "Zniżki od 7+ nocy, miesięczne na zapytanie"
     },
     {
      "label": "Także",
      "value": "Śniadanie i obiadokolacja, basen, bezpłatny garaż"
     }
    ],
    "faq": [
     {
      "q": "Czy WiFi jest wystarczająco dobre do wideorozmów?",
      "a": "Tak — łącze światłowodowe z WiFi w każdym pokoju i na tarasie; recepcja może też wskazać Ci ciche miejsce do rozmów."
     },
     {
      "q": "Czy mogę gotować w pokoju?",
      "a": "Apartamenty mają aneks kuchenny z płytą grzewczą, lodówką i czajnikiem. Śniadanie i obiadokolacja są nadal wliczone, jeśli wolisz nie gotować."
     },
     {
      "q": "Jak uzyskać stawkę miesięczną?",
      "a": "Napisz na larosaulcinj@gmail.com, podając terminy i preferowany typ pokoju — odpowiemy z indywidualną ofertą w ciągu 24 godzin."
     }
    ]
   },
   {
    "slug": "cheap-hotel-ulcinj",
    "filter": "budget",
    "title": "Tani hotel w Ulcinj przy plaży — od €40",
    "metaTitle": "Tani hotel przy plaży w Ulcinj od €40 — La Rosa Negra, Velika Plaža",
    "metaDescription": "Pokoje budżetowe od €40 za noc ze śniadaniem i obiadokolacją, basenem i bezpłatnym parkingiem w cenie — 2 minuty od Velika Plaža. Uczciwy tani hotel w Ulcinj: rezerwuj bezpośrednio, oszczędź 15 %.",
    "intro": [
     "Tanio nie musi oznaczać daleko od plaży. Nasze ekonomiczne pokoje dwuosobowe i pokoje jednoosobowe zaczynają się od €40 za noc i nadal obejmują śniadanie w formie bufetu, kolację, basen i garaż — ta sama plaża, te same zachody słońca co w pokojach z widokiem na morze.",
     "Rezerwacja bezpośrednio na tej stronie jest zawsze co najmniej o 15 % tańsza niż na Booking.com, a kody early bird na czerwiec i wrzesień dają kolejne 10 % zniżki."
    ],
    "facts": [
     {
      "label": "Od",
      "value": "€40 za noc ze śniadaniem i obiadokolacją"
     },
     {
      "label": "Oszczędność przy rezerwacji bezpośredniej",
      "value": "≥ 15 % vs Booking.com"
     },
     {
      "label": "Early bird",
      "value": "−10 % kody na czerwiec i wrzesień"
     },
     {
      "label": "W cenie",
      "value": "Basen, parking, WiFi, kolacja"
     }
    ],
    "faq": [
     {
      "q": "Jaki jest najtańszy pokój?",
      "a": "Mały Pokój Jednoosobowy od €40 oraz Ekonomiczny Pokój Dwuosobowy z Balkonem (bez widoku) od €60 — oba ze śniadaniem i obiadokolacją."
     },
     {
      "q": "Dlaczego bezpośrednio jest taniej?",
      "a": "Nie płacimy prowizji od rezerwacji bezpośrednich i przekazujemy tę oszczędność Tobie; otrzymujesz też bezpłatne anulowanie do 24 h przed przyjazdem."
     },
     {
      "q": "Kiedy Ulcinj jest najtańszy?",
      "a": "Maj, czerwiec, wrzesień i październik — świetna pogoda, ciepłe morze i ceny nawet do 40 % niższe niż w lipcu i sierpniu."
     }
    ]
   },
   {
    "slug": "hotel-with-parking-ulcinj",
    "filter": "all",
    "title": "Hotel z bezpłatnym parkingiem w Ulcinj",
    "metaTitle": "Hotel z bezpłatnym parkingiem w Ulcinj — garaż na 60 miejsc | La Rosa Negra",
    "metaDescription": "Prywatny garaż na 60 miejsc wliczony w każdą cenę, 2 minuty od Velika Plaža. Hotel z bezpłatnym parkingiem w Ulcinj — idealny na road trip po Czarnogórze i Albanii.",
    "intro": [
     "Przyjeżdżasz samochodem z Dubrownika, Podgoricy lub Tirany? Hotel La Rosa Negra ma prywatny garaż na 60 miejsc, bezpłatny dla wszystkich gości — bez stresu z parkowaniem na ulicy w szczycie sezonu, a Twój samochód stoi w cieniu.",
     "Z hotelu jest 5 km do Starego Miasta, 20 minut do Ada Bojana, 45 minut do jeziora Šaško i godzina do Baru oraz jeziora Szkoderskiego — Velika Plaža to idealna baza na road trip po Czarnogórze."
    ],
    "facts": [
     {
      "label": "Parking",
      "value": "Prywatny garaż na 60 miejsc, bezpłatny"
     },
     {
      "label": "EV",
      "value": "Ładowanie na życzenie"
     },
     {
      "label": "Odległości",
      "value": "Stare Miasto 5 km · Ada Bojana 15 km · Bar 30 km"
     },
     {
      "label": "Granica",
      "value": "Albania (Muriqan) 25 min"
     }
    ],
    "faq": [
     {
      "q": "Czy muszę rezerwować miejsce parkingowe?",
      "a": "Nie — garaż jest wliczony w cenę i jest miejsce dla każdego pokoju. W rzadkim przypadku, gdy będzie pełny, dostępny jest bezpłatny parking obok hotelu."
     },
     {
      "q": "Czy mogę naładować samochód elektryczny?",
      "a": "Tak, na życzenie w recepcji (standardowe gniazdko); szybkie ładowarki są dostępne w mieście Ulcinj."
     },
     {
      "q": "Czy droga z Dubrownika jest łatwa?",
      "a": "Około 3 h 30 wzdłuż wybrzeża przez Budvę i Bar; w lipcu i sierpniu zaplanuj dodatkowy czas na granicy z Chorwacją."
     }
    ]
   },
   {
    "slug": "hotels-in-ulcinj",
    "filter": "all",
    "title": "Hotele w Ulcinju: którą okolicę wybrać",
    "metaTitle": "Hotele w Ulcinju — Gdzie się zatrzymać i ceny | La Rosa Negra",
    "metaDescription": "Hotele w Ulcinju, Czarnogóra: Stare Miasto vs Velika Plaža vs Ada Bojana, ile kosztują pokoje w sezonie i rodzinny hotel 2 minuty od Long Beach.",
    "intro": [
     "Ulcinj (Ulqin) ma trzy zupełnie różne miejsca na nocleg. Stare Miasto i Mala Plaža są tętniące życiem i historyczne, z restauracjami na murach, ale też ze schodami, ruchem ulicznym i prawie brakiem parkingu w lipcu i sierpniu. Velika Plaža (Long Beach) i równina Štoj za nią są płaskie, spokojne i przyjazne rodzinom, z 13 km płytkiej, piaszczystej plaży i większością nowszych hoteli w mieście. Ada Bojana, na samym końcu plaży, to odległa rzeczna wyspa dla kitesurferów i naturystów.",
     "Hotel La Rosa Negra znajduje się po stronie Velika Plaža: to rodzinny hotel 3-gwiazdkowy, około 2 minuty pieszo od piasku i 5 km od Starego Miasta. Cena obejmuje dwa posiłki dziennie (śniadanie i kolację w formie bufetu), odkryty basen, WiFi oraz prywatny garaż na 60 miejsc. Pokoje kosztują €40–150 za noc w zależności od sezonu i widoku, a przy rezerwacji bezpośredniej jest 10% taniej niż na Booking.com."
    ],
    "facts": [
     {
      "label": "Okolice",
      "value": "Stare Miasto · Velika Plaža / Štoj · Ada Bojana"
     },
     {
      "label": "Typowe ceny",
      "value": "Pokoje w hotelach 3-gwiazdkowych €40–150 za noc, dwa posiłki dziennie"
     },
     {
      "label": "Nasza lokalizacja",
      "value": "2 min do piasku, 5 km do Starego Miasta"
     },
     {
      "label": "Dojazd",
      "value": "Lotnisko Podgorica lub Tivat ≈ 90 min, Tirana 2 h"
     }
    ],
    "faq": [
     {
      "q": "Która część Ulcinja jest najlepsza na wakacje plażowe?",
      "a": "Velika Plaža. Piasek jest drobny, a woda płytka przez dziesiątki metrów, plażowe restauracje wynajmują leżaki, a okolica jest płaska i wygodna dla rodzin z dziećmi lub osób podróżujących samochodem. Stare Miasto jest lepsze na city break: więcej restauracji i życia nocnego, ale plaże są tam małe i kamieniste, a parking trudno znaleźć."
     },
     {
      "q": "Ile kosztuje hotel w Ulcinju?",
      "a": "W lipcu i sierpniu pokój dwuosobowy w hotelu 3-gwiazdkowym kosztuje zwykle €90–150 za noc; w czerwcu i wrześniu €60–100; wiosną i jesienią od około €40. Nasze ceny obejmują śniadanie i kolację, basen oraz parking, więc porównuj całkowity koszt, a nie tylko cenę samego pokoju."
     },
     {
      "q": "Jak dostać się z lotniska do hotelu na Velika Plaža?",
      "a": "Lotniska Podgorica (TGD) i Tivat (TIV) są oddalone o około 80 km / 90 minut; Tirana (TIA) o 130 km / 2 godziny przez przejście graniczne Muriqan. Organizujemy prywatny transfer za €80 w jedną stronę, albo można dojechać autobusem do Ulcinja i wziąć taksówkę (około €10) na ostatnie 4 km."
     }
    ]
   },
   {
    "slug": "velika-plaza-hotels",
    "filter": "all",
    "title": "Hotele przy Velika Plaža (Long Beach), Ulcinj",
    "metaTitle": "Hotele Velika Plaža — Long Beach Ulcinj | La Rosa Negra",
    "metaDescription": "Hotele przy Velika Plaža, Ulcinj: 13 km płytkiej piaszczystej plaży, jak blisko hoteli naprawdę jest do wody, ceny według miesięcy i rodzinny hotel 2 minuty od plaży.",
    "intro": [
     "Velika Plaža — Long Beach, Plazhi i Madh — ciągnie się przez około 13 km od Port Milena do rzeki Bojana. To najdłuższa plaża na wschodnim wybrzeżu Adriatyku i jedna z najpłytszych: woda pozostaje do kolan przez dziesiątki metrów, dlatego wybierają ją rodziny z małymi dziećmi. Sama plaża jest chroniona i w dużej mierze niezabudowana, więc hotele stoją za nadmorską drogą w Štoj i Donji Štoj, w krótkim spacerze od piasku.",
     "Hotel La Rosa Negra jest jednym z nich: około 2 minuty pieszo od wody, z odkrytym basenem, dwoma posiłkami dziennie w cenie każdego pobytu, bezpłatnym WiFi i prywatnym garażem na 60 miejsc. Wiele pokoi ma balkon z widokiem na morze. Stare Miasto, restauracje Ulcinja i dworzec autobusowy są oddalone o 4–5 km — 10 minut jazdy samochodem lub letnim autobusem plażowym."
    ],
    "facts": [
     {
      "label": "Plaża",
      "value": "≈13 km drobnego szarego piasku, bardzo płytko, ratownicy lip–sie"
     },
     {
      "label": "Odległość do piasku",
      "value": "Około 2 minuty pieszo od hotelu"
     },
     {
      "label": "Temperatura morza",
      "value": "22–26 °C od czerwca do września"
     },
     {
      "label": "Atrakcje",
      "value": "Kitesurfing przy końcu Ada Bojana, plażowe restauracje, ścieżka rowerowa"
     }
    ],
    "faq": [
     {
      "q": "Czy przy Velika Plaža są hotele bezpośrednio na piasku?",
      "a": "Nie. Plaża jest chronioną strefą przyrodniczą, więc hotele i apartamenty stoją za nadmorską drogą w Štoj i Donji Štoj. Najbliższe, w tym Hotel La Rosa Negra, są oddalone o około 150 m — 2 minuty pieszo — od wody."
     },
     {
      "q": "Jak daleko jest z Velika Plaža do Starego Miasta w Ulcinju?",
      "a": "Plaża zaczyna się około 1.5 km na południowy wschód od miasta; nasza część znajduje się 5 km od Starego Miasta — około 10 minut samochodem lub taksówką (około €10). W lipcu i sierpniu wzdłuż nadmorskiej drogi kursuje autobus plażowy."
     },
     {
      "q": "Kiedy najlepiej zatrzymać się przy Velika Plaža?",
      "a": "Czerwiec i wrzesień to ciepłe morze (23–25 °C), spokojniejsze plaże i ceny o 30–40% niższe niż w sierpniu. Lipiec i sierpień są najgorętsze i najbardziej zatłoczone. Od października do maja plaża jest prawie pusta i wiele plażowych restauracji jest zamkniętych; hotel pozostaje otwarty z cenami zimowymi."
     }
    ]
   },
   {
    "slug": "sea-view-hotel-ulcinj",
    "filter": "couples",
    "title": "Pokoje hotelowe z widokiem na morze w Ulcinju",
    "metaTitle": "Hotel z widokiem na morze Ulcinj — Pokoje z balkonem | La Rosa Negra",
    "metaDescription": "Pokoje z balkonem i widokiem na morze w Ulcinju, 2 minuty od Velika Plaža: które pokoje wychodzą na wodę, ceny według sezonu, dwa posiłki dziennie w cenie. Rezerwuj bezpośrednio i oszczędź 10%.",
    "intro": [
     "Hotel stoi na płaskiej równinie Štoj za Velika Plaža, więc widok na morze to tutaj otwarty Adriatyk ponad wydmami i plażowymi restauracjami, a nie panorama z klifu. Pokoje oznaczone jako „widok na morze” są skierowane na południowy zachód, w stronę wody, i mają widok na zachód słońca; pokoje po drugiej stronie wychodzą na basen i góry Rumija. Każdy balkon ma stolik i dwa krzesła.",
     "Pokoje dwuosobowe z widokiem na morze są najbardziej poszukiwane w lipcu i sierpniu, więc warto rezerwować wcześnie. Wszystkie ceny obejmują dwa posiłki dziennie, odkryty basen, WiFi i parking w garażu; przy rezerwacji bezpośredniej jest 10% taniej niż na Booking.com, a rezerwację można zmienić lub anulować zgodnie z wybraną taryfą."
    ],
    "facts": [
     {
      "label": "Widok",
      "value": "Adriatyk ponad wydmami, strona zachodu słońca"
     },
     {
      "label": "Balkon",
      "value": "Prywatny, ze stolikiem i dwoma krzesłami"
     },
     {
      "label": "Plaża",
      "value": "Około 2 minuty pieszo"
     },
     {
      "label": "Różnica w cenie",
      "value": "Zwykle €10–20 za noc więcej niż pokój od strony basenu"
     }
    ],
    "faq": [
     {
      "q": "Czy z pokoju widać morze?",
      "a": "Z pokoi z widokiem na morze tak — otwarty Adriatyk za wydmami i plażowymi restauracjami, około 150 m dalej. Pokoje na parterze widzą mniej; z wyższych pięter widok jest najpełniejszy. Jeśli widok jest dla Ciebie ważny, napisz o tym w komentarzu do rezerwacji, a przydzielimy najlepszy dostępny pokój."
     },
     {
      "q": "Które pokoje mają widok na morze?",
      "a": "Pokoje dwuosobowe z balkonem i widokiem na morze oraz część pokoi rodzinnych; nazwy pokoi na tej stronie zawierają określenie „widok na morze”, gdy są skierowane w stronę wody. Pokoje z widokiem na basen są trochę tańsze i wieczorem cichsze."
     },
     {
      "q": "Czy pokój z widokiem na morze jest wart dopłaty w Ulcinju?",
      "a": "Na letnie wakacje większość par mówi, że tak — zachód słońca z balkonu to najpiękniejszy moment dnia. Jeśli spędzasz w pokoju mało czasu, pokój z widokiem na basen pozwala zaoszczędzić €10–20 za noc przy tej samej plaży i posiłkach."
     }
    ]
   },
   {
    "slug": "hotel-ulqin",
    "filter": "family",
    "title": "Hotel w Ulqin dla gości z Kosowa i Albanii",
    "metaTitle": "Hotel Ulqin — Ceny na Bajram i tygodnie letnie | La Rosa Negra",
    "metaDescription": "Rodzinny hotel w Ulqin, 2 minuty od Plazhi i Madh: aktualne ceny na Fitër i Kurban Bajram, Dita e Verës oraz letnie tygodnie diaspory. Obsługa mówi po albańsku, parking w garażu, wyżywienie HB.",
    "intro": [
     "Ulqin to najbliższe morze dla Prisztiny i Tirany: około 5 godzin z Prisztiny przez Rrugę e Kombit i Shkodër, 2 godziny z Tirany i 1 godzina ze Shkodër przez przejście graniczne Muriqan–Sukobin. Hotel La Rosa Negra znajduje się po stronie Plazhi i Madh (Velika Plaža), około 2 minuty pieszo od plaży — w recepcji mówi się po albańsku, a garaż na 60 miejsc sprawia, że samochód jest bezpieczny przez cały pobyt.",
     "Każda stawka obejmuje wyżywienie HB (śniadanie i kolacja w formie bufetu), odkryty basen z częścią dla dzieci, WiFi i parking. Pokoje rodzinne mieszczą 3–5 osób. Poniżej widzisz aktualną cenę bezpośrednią na tygodnie, w których podróżuje większość naszych gości z Kosowa i Albanii: Fitër i Kurban Bajram, Dita e Verës, 17 lutego oraz tygodnie diaspory pod koniec lipca i w sierpniu — rezerwacja bezpośrednia jest o 10% tańsza niż nasza cena na Booking.com."
    ],
    "facts": [
     {
      "label": "Z Prisztiny",
      "value": "≈ 330 km · około 5 h samochodem przez Shkodër"
     },
     {
      "label": "Z Tirany / Shkodër",
      "value": "130 km · 2 h / 45 km · 1 h"
     },
     {
      "label": "Język i waluta",
      "value": "Mówimy po albańsku · euro, gotówka i karta"
     },
     {
      "label": "W cenie",
      "value": "Wyżywienie HB, basen, WiFi, parking w garażu"
     }
    ],
    "faq": [
     {
      "q": "Jak dojechać z Kosowa do Ulqin?",
      "a": "Samochodem: Prisztina → Rruga e Kombit → Kukës → Shkodër → granica Muriqan → Ulqin, około 5 godzin; granicę zwykle przekracza się szybko poza szczytem w piątkowe i niedzielne wieczory w sierpniu. Latem autobusy kursują codziennie z Prisztiny i Tirany do Ulqin; taksówka z dworca autobusowego w Ulqin do hotelu kosztuje około €10."
     },
     {
      "q": "Czy macie pokoje na święta Bajram?",
      "a": "Tak, gdy hotel jest otwarty w sezonie — Kurban Bajram w maju się w nim mieści, Fitër Bajram w marcu zależy od roku. Tabela na tej stronie pokazuje aktualną cenę dla każdego święta; jeśli widzisz „na zapytanie”, napisz do nas na WhatsApp, a potwierdzimy w ciągu kilku godzin."
     },
     {
      "q": "Czy dzieci mogą jeść z nami kolację i czy jedzenie jest halal?",
      "a": "Wyżywienie HB obejmuje wszystkich w pokoju, również dzieci. Kolacja jest w formie bufetu z rybą, grillowanym mięsem, warzywami i sałatkami. Jak większość hoteli w Ulcinju gotujemy bez wieprzowiny, a hotel jest bezalkoholowy — spokojny wybór, który docenia wiele rodzin z Kosowa, Albanii i diaspory."
     }
    ]
   },
   {
    "slug": "plazhi-i-madh-ulqin",
    "filter": "all",
    "title": "Plazhi i Madh, Ulqin — hotel 2 minuty od piasku",
    "metaTitle": "Plazhi i Madh Ulqin — Hotel 2 min od plaży | La Rosa Negra",
    "metaDescription": "Plazhi i Madh (Velika Plaža), Ulqin: 13 km płytkiej piaszczystej plaży dla rodzin, ceny na letnie tygodnie z Kosowa i Albanii oraz rodzinny hotel 2 minuty od plaży z wyżywieniem HB i basenem.",
    "intro": [
     "Plazhi i Madh — Velika Plaža, Long Beach — to 13 km drobnego, płytkiego piasku od Port Milena do rzeki Buna. Woda przez dziesiątki metrów pozostaje do kolan, dlatego rodziny z Kosowa i Albanii przyjeżdżają tu od pokoleń. Bary plażowe wynajmują leżaki (około €10–15 za komplet w sezonie), ratownicy pracują w lipcu i sierpniu, a przy końcu Ada Bojana znajduje się spot do kitesurfingu.",
     "Hotel La Rosa Negra znajduje się około 2 minuty pieszo od plaży, oferuje balkony z widokiem na morze, odkryty basen, wyżywienie HB w każdej stawce oraz prywatny garaż. Stare Miasto w Ulqin z restauracjami jest oddalone o 5 km. Ceny poniżej są aktualne dla tygodni, w których podróżuje większość naszych albańskojęzycznych gości; rezerwuj bezpośrednio i zapłać o 10% mniej niż na Booking.com."
    ],
    "facts": [
     {
      "label": "Plaża",
      "value": "13 km płytkiego piasku · ratownicy lip–sie"
     },
     {
      "label": "Odległość od hotelu",
      "value": "Około 2 minuty pieszo"
     },
     {
      "label": "Morze",
      "value": "23–26 °C od czerwca do września"
     },
     {
      "label": "Stare Miasto",
      "value": "5 km · taksówka około €10 · letni autobus plażowy"
     }
    ],
    "faq": [
     {
      "q": "Czy Plazhi i Madh nadaje się dla małych dzieci?",
      "a": "To najpłytsza plaża na tym wybrzeżu — piasek opada bardzo łagodnie, więc dzieci mogą bawić się w wodzie do kolan daleko od brzegu. Na południe warto zabrać cień; hotel ma też część basenu dla dzieci."
     },
     {
      "q": "Jak tłoczno jest w sierpniu?",
      "a": "Tygodnie diaspory (od końca lipca do połowy sierpnia) są najbardziej oblegane w całym roku — rezerwuj wcześnie, przyjdź na plażę przed 10:00, jeśli chcesz zająć pierwszy rząd leżaków, i spodziewaj się kolejek na granicy w Muriqan w piątkowe i niedzielne wieczory. Koniec sierpnia i wrzesień są znacznie spokojniejsze, przy tak samo ciepłym morzu."
     },
     {
      "q": "Gdzie parkujemy?",
      "a": "W naszym prywatnym garażu na 60 miejsc, wliczonym w cenę. Na samej drodze przy plaży parking jest płatny i latem trudno o miejsce, dlatego większość gości zostawia samochód w hotelu i chodzi pieszo."
     }
    ]
   },
   {
    "slug": "halal-friendly-family-hotel-ulcinj",
    "filter": "family",
    "title": "Hotel rodzinny bez alkoholu w Ulcinju, 2 minuty od Velika Plaža",
    "metaTitle": "Hotel rodzinny bez alkoholu w Ulcinju (Ulqin) blisko Velika Plaža | La Rosa Negra",
    "metaDescription": "Spokojny hotel rodzinny w Ulcinju / Ulqinie, 2 minuty od Velika Plaža (Plazhi i Madh): śniadanie i obiadokolacja, basen z częścią dla dzieci, bezpłatny garaż, obsługa mówi po albańsku, alkoholu się nie podaje. Aktualne ceny na Bajram i letnie tygodnie diaspory.",
    "intro": [
     "Hotel La Rosa Negra to rodzinny, trzygwiazdkowy hotel po stronie Velika Plaža (Plazhi i Madh) w Ulcinju, około 2 minuty pieszo od plaży. To spokojne miejsce: bez barowego zgiełku, bez podawanego alkoholu, dzieci biegają między basenem a plażą, rodzice siedzą na tarasie z kawą. Rodziny z Kosowa, Albanii, Macedonii Północnej oraz diaspora z Niemiec, Szwajcarii i Austrii wracają tu rok po roku — wiele z nich na te same dwa tygodnie każdego lata.",
     "Śniadanie i obiadokolacja są wliczone w każdą cenę — śniadanie w formie bufetu i kolacja bufetowa z rybami, grillowanym mięsem, warzywami, sałatkami i deserami, przygotowanymi tak, jak gotuje się w kuchniach Ulcinja; do kolacji podawane są soki, napoje bezalkoholowe, woda, kawa i herbata. Pokoje rodzinne mieszczą 3–5 osób, odkryty basen ma część dla dzieci, garaż na 60 miejsc jest bezpłatny, a w recepcji mówi się po albańsku, czarnogórsku, angielsku i niemiecku. Poniżej widzisz aktualną cenę bezpośrednią na tygodnie, w których nasi goście podróżują najczęściej — Fitër i Kurban Bajram, Dita e Verës oraz tygodnie diaspory pod koniec lipca i w sierpniu — zawsze 10% poniżej naszej ceny na Booking.com."
    ],
    "facts": [
     {
      "label": "Rodziny",
      "value": "Pokoje dla 3–5 osób · basen dla dzieci · 2 min do plaży"
     },
     {
      "label": "Atmosfera",
      "value": "Cichy hotel bez alkoholu · kawiarnia na tarasie"
     },
     {
      "label": "W cenie",
      "value": "Śniadanie i obiadokolacja, basen, WiFi, parking w garażu"
     },
     {
      "label": "Języki",
      "value": "Albański, czarnogórski, angielski, niemiecki"
     }
    ],
    "faq": [
     {
      "q": "Czy jedzenie jest odpowiednie dla rodzin muzułmańskich?",
      "a": "Tak — jak w większości hoteli w Ulcinju, w naszej kuchni nie używa się wieprzowiny, a alkohol nie jest używany w kuchni ani serwowany w hotelu. Nie posiadamy formalnego certyfikatu halal; jeśli to ma dla Państwa znaczenie, prosimy napisać do nas przed rezerwacją, a uczciwie wyjaśnimy, skąd pochodzi mięso."
     },
     {
      "q": "Czy naprawdę nie ma alkoholu, nawet w lodówce w pokoju albo na tarasie?",
      "a": "Tak — hotel jest bezalkoholowy. Lodówki w pokojach są puste i przeznaczone na własne napoje, kawiarnia serwuje kawę, herbatę, świeże soki i napoje bezalkoholowe, a podczas kolacji ani na tarasie nie sprzedaje się nic alkoholowego. Goście, którzy chcą wypić kieliszek wina, znajdą go w restauracjach przy plaży oddalonych o 150 m."
     },
     {
      "q": "Czy możemy przyjechać na Bajram albo wakacje letnie z dużą rodziną?",
      "a": "Tak. Pokoje rodzinne mieszczą do 5 osób, a jeśli podróżują Państwo większą grupą, prosimy dać nam znać, a postaramy się ulokować Państwa w sąsiednich pokojach. Tabela na tej stronie pokazuje aktualną cenę na Kurban Bajram, Fitër Bajram i tygodnie diaspory — jeśli przy danym wierszu widnieje 'na zapytanie', prosimy wysłać nam wiadomość na WhatsApp, a potwierdzimy w ciągu kilku godzin."
     }
    ]
   }
  ]
 },
 "hu": {
  "nav": "Népszerű szállások",
  "intro": "Találja meg az Önnek megfelelő szállást — minden oldalon az adott tartózkodáshoz illő szobák láthatók aktuális közvetlen árakkal.",
  "roomsHeading": "Az ehhez a tartózkodáshoz illő szobák",
  "faqHeading": "Jó tudni",
  "otherHeading": "Egyéb népszerű keresések",
  "from": "ettől az ártól",
  "perNight": "éjszakánként",
  "book": "Elérhetőség ellenőrzése",
  "topics": [
   {
    "slug": "family-hotel-velika-plaza",
    "filter": "family",
    "title": "Családi hotel Velika Plažán, Ulcinjban",
    "metaTitle": "Családi hotel Velika Plažán, Ulcinjban — La Rosa Negra",
    "metaDescription": "3–5 fős családi szobák, gyerekmedence, pár lépésre a sekély homokos strand, félpanzió és ingyenes parkolás. Családi hotel Velika Plažán, Ulcinjban — legjobb ár közvetlenül.",
    "intro": [
     "Velika Plaža 13 km finom, sekély homokos part — Montenegró legbiztonságosabb strandja kisgyermekek számára, a Hotel La Rosa Negra pedig közvetlenül mellette áll. Családi szobáink és két hálószobás apartmanunk 3–5 fő elszállásolására alkalmasak, kanapéágyakkal, teakonyhával és teraszokkal, ahol a gyerekek játszhatnak, amíg Ön megissza a kávéját.",
     "A félpanzió benne van az árban (svédasztalos reggeli és vacsora), a medencében sekély gyerekrész és napozóágyak vannak, a 60 férőhelyes privát garázs pedig azt jelenti, hogy egy Ada Bojana-i vagy óvárosi kirándulás után nem kell parkolóhelyet keresni."
    ],
    "facts": [
     {
      "label": "Családi szobák",
      "value": "3–5 vendég, kanapéágyak és teakonyha"
     },
     {
      "label": "Strand",
      "value": "Sekély homok, 2 perc gyalog"
     },
     {
      "label": "Étkezés",
      "value": "Félpanzió az árban"
     },
     {
      "label": "Extrák",
      "value": "Babaágy és pótágy kérésre"
     }
    ],
    "faq": [
     {
      "q": "A gyerekek ingyenesen szállhatnak meg?",
      "a": "A 2 év alatti gyermekek babaágyban ingyenesen szállhatnak meg. Nagyobb gyerekek esetén családi szobát vagy a két hálószobás apartmant ajánljuk — a megjelenített ár már tartalmazza a megadott vendégszámot."
     },
     {
      "q": "Biztonságos a strand kisgyermekek számára?",
      "a": "Igen — Velika Plaža nagyon enyhén mélyül, így a víz több tíz méteren át sekély marad. Júliusban és augusztusban vízimentők teljesítenek szolgálatot."
     },
     {
      "q": "Kaphatunk babaágyat vagy etetőszéket?",
      "a": "Mindkettő ingyenesen elérhető — kérje foglaláskor vagy a recepción."
     }
    ]
   },
   {
    "slug": "hotel-with-pool-ulcinj",
    "filter": "pool",
    "title": "Hotel medencével Ulcinjban",
    "metaTitle": "Hotel medencével Ulcinjban, a strand mellett — La Rosa Negra",
    "metaDescription": "Kültéri medence napozóágyakkal, gyerekrésszel és medence melletti szobákkal, 2 percre Velika Plažától. Hotel medencével Ulcinjban — félpanzióval és parkolással az árban.",
    "intro": [
     "Tenger reggel, medence délután: a Hotel La Rosa Negra szabadtéri medencével várja vendégeit ingyenes napozóágyakkal és sekély gyerekrésszel, pálmák és a hotel terasza között. A medencehasználat minden vendég számára benne van az árban.",
     "Válasszon medence melletti kétágyas szobát, hogy közvetlenül az ajtóból a medencetérre léphessen, vagy egy emeleti, tengerre néző szobát, és figyelje a medencét és az Adriát is az erkélyéről."
    ],
    "facts": [
     {
      "label": "Medence",
      "value": "Kültéri, ingyenes napozóágyak, gyerekrész"
     },
     {
      "label": "Szezon",
      "value": "május – október"
     },
     {
      "label": "Medence melletti szobák",
      "value": "Medence melletti kétágyas szoba"
     },
     {
      "label": "Továbbá",
      "value": "Strand 2 perc, félpanzió az árban"
     }
    ],
    "faq": [
     {
      "q": "Fűtött a medence?",
      "a": "Nem — ez egy szabadtéri, friss vízzel töltött medence, amely a évi 2 500 napsütéses órának köszönhetően késő májustól október elejéig kellemes."
     },
     {
      "q": "Ingyenesek a törölközők és a napozóágyak?",
      "a": "A napozóágyak a szállóvendégek számára ingyenesek; medencetörölközők a recepción kérhetők."
     },
     {
      "q": "Használhatják a gyerekek a medencét?",
      "a": "Igen, van sekély gyerekrész. A gyermekeket felnőttnek kell kísérnie."
     }
    ]
   },
   {
    "slug": "half-board-hotel-ulcinj",
    "filter": "all",
    "title": "Félpanziós hotel Ulcinjban",
    "metaTitle": "Félpanziós hotel Ulcinjban — reggelivel és vacsorával | La Rosa Negra",
    "metaDescription": "Minden ár tartalmazza a svédasztalos reggelit és a vacsorát. Félpanziós hotel Velika Plažán, Ulcinjban medencével, parkolással és tengerre néző szobákkal — közvetlenül már €40 / éjszaka ártól.",
    "intro": [
     "A Hotel La Rosa Negra minden szobaára tartalmazza a félpanziót: svédasztalos reggelit és háromfogásos vacsorát éttermünkben, montenegrói és mediterrán fogásokkal, Ulcinjból származó friss hallal és minden nap vegetáriánus opciókkal.",
     "A félpanzió leveszi a tervezés terhét egy tengerparti nyaralásról — visszatér a strandról, lezuhanyozik, és a vacsora már készen is van. Ebédelni a hotel előtt közvetlenül található strandéttermekban lehet."
    ],
    "facts": [
     {
      "label": "Tartalmazza",
      "value": "Svédasztalos reggeli + 3 fogásos vacsora"
     },
     {
      "label": "Konyha",
      "value": "Montenegrói és mediterrán, friss hal"
     },
     {
      "label": "Étrend",
      "value": "Naponta vegetáriánus, allergiák kérésre"
     },
     {
      "label": "Árak",
      "value": "Szobák €40 / éjszaka ártól"
     }
    ],
    "faq": [
     {
      "q": "Mikor van a vacsora?",
      "a": "A vacsorát 19:00 és 21:30 között szolgáljuk fel; a reggelit 07:30 és 10:00 között (az időpontok szezon szerint kissé változhatnak)."
     },
     {
      "q": "Foglalhatok csak szobát?",
      "a": "Minden közvetlen árunk félpanziót tartalmaz — ez a legjobb ár-érték arány. Különleges igények esetén vegye fel a kapcsolatot a recepcióval."
     },
     {
      "q": "Az italok benne vannak az árban?",
      "a": "A víz benne van a vacsorában; egyéb italok az étterem bárjában elérhetők."
     }
    ]
   },
   {
    "slug": "hotel-near-podgorica-airport",
    "filter": "all",
    "title": "Tengerparti hotel Podgorica és Tivat repülőtere közelében",
    "metaTitle": "Tengerparti hotel 90 percre Podgorica és Tivat repülőterétől — La Rosa Negra, Ulcinj",
    "metaDescription": "Repüljön Podgoricába (TGD) vagy Tivatba (TIV), és nagyjából 90 perc alatt Velika Plažán lehet. Reptéri transzfer €80 egy útra, ingyenes parkolás, félpanzió. Foglaljon közvetlenül.",
    "intro": [
     "Ulcinjt két montenegrói repülőtér szolgálja ki — Podgorica (TGD, kb. 85 km) és Tivat (TIV, kb. 95 km) — mindkettő körülbelül 90 perc autóútra van a Hotel La Rosa Negrától. Harmadik lehetőség az albániai Tirana repülőtere (TIA), nagyjából 2 órára a Muriqan határátkelőn keresztül.",
     "€80 áron szervezünk privát transzfert egy útra (legfeljebb 4 vendég részére), amely az érkezési csarnokban várja Önt; ha autót bérel, 60 férőhelyes privát garázsunk a vendégek számára ingyenes."
    ],
    "facts": [
     {
      "label": "Podgorica (TGD)",
      "value": "≈ 85 km · 1 óra 30 perc"
     },
     {
      "label": "Tivat (TIV)",
      "value": "≈ 95 km · 1 óra 35 perc"
     },
     {
      "label": "Tirana (TIA)",
      "value": "≈ 130 km · 2 óra"
     },
     {
      "label": "Transzfer",
      "value": "€80 egy útra, legfeljebb 4 vendég"
     }
    ],
    "faq": [
     {
      "q": "Hogyan foglalhatok reptéri transzfert?",
      "a": "Adja hozzá az online check-in során, vagy írja meg nekünk e-mailben a járatszámát — a sofőr névtáblával várja az érkezésnél."
     },
     {
      "q": "Van busz a repülőtérről?",
      "a": "Közvetlen busz nincs. Menjen taxival vagy busszal Podgorica vagy Bar buszpályaudvarára, onnan pedig távolsági busszal Ulcinjba (nyáron óránként indul), majd taxival a hotelhez."
     },
     {
      "q": "Melyik repülőtér a jobb?",
      "a": "Podgoricába általában több járat és kedvezőbb árak érhetők el; Tivat látványosabb útvonalat kínál. Az autóút a hotelig szinte ugyanannyi idő."
     }
    ]
   },
   {
    "slug": "romantic-hotel-ulcinj",
    "filter": "couples",
    "title": "Romantikus, tengerre néző hotel pároknak Ulcinjban",
    "metaTitle": "Romantikus, tengerre néző hotel pároknak Ulcinjban — La Rosa Negra",
    "metaDescription": "Tengerre néző erkélyes szobák, naplementék Velika Plaža felett, vacsora az árban és romantikus bekészítés kérésre. Pároknak szóló hotel Ulcinjban, Montenegróban — foglaljon közvetlenül.",
    "intro": [
     "A nap közvetlenül az Adria fölött nyugszik le a Hotel La Rosa Negra előtt — nézze saját, tengerre néző erkélyéről egy pohár montenegrói Vranac mellett. Tengerre néző erkélyes kétágyas szobáink és a közös tengeri terasszal rendelkező twin szobák két főre készültek.",
     "Az online check-in során kérje a romantikus bekészítést (virág, gyümölcs és édesség a szobában), vacsorázzon a teraszon a félpanzió keretében, majd tegyen egy 20 perces autóutat Ada Bojanára egy folyóparti halas vacsoráért."
    ],
    "facts": [
     {
      "label": "Szobák",
      "value": "Tengerre néző erkélyes kétágyasok"
     },
     {
      "label": "Naplemente",
      "value": "Közvetlenül a tenger felett, nyugati fekvés"
     },
     {
      "label": "Romantikus bekészítés",
      "value": "€35 — bor, gyümölcs, virág"
     },
     {
      "label": "Kirándulások",
      "value": "Ada Bojana, Óváros, Valdanos-öböl"
     }
    ],
    "faq": [
     {
      "q": "Tudnak meglepetést készíteni évfordulóra?",
      "a": "Igen — válassza a romantikus bekészítést az online check-in során, vagy írjon nekünk; a szobát az érkezése előtt feldíszítjük."
     },
     {
      "q": "Csendes a hotel?",
      "a": "A hotel Velika Plaža tengerparti útján található, távol az óváros éjszakai életétől; a felső emeleti, tengerre néző szobák a legcsendesebbek."
     },
     {
      "q": "Lehetséges a késői kijelentkezés?",
      "a": "A késői kijelentkezés 14:00 óráig €20, elérhetőségtől függően — az online check-in során foglalható."
     }
    ]
   },
   {
    "slug": "long-stay-workation-ulcinj",
    "filter": "longstay",
    "title": "Hosszú tartózkodás és workation Ulcinjban",
    "metaTitle": "Hosszú tartózkodás és workation hotel Ulcinjban, Montenegróban — La Rosa Negra",
    "metaDescription": "Töltsön egy hetet vagy egy hónapot Velika Plažán: apartmanok teakonyhával, ingyenes WiFi, félpanzió, parkolás. Hosszú tartózkodásra és workationre ideális hotel Ulcinjban — kérjen havi árat.",
    "intro": [
     "Montenegró digitális nomád vízuma és évi 300 napsütéses napja miatt Ulcinj könnyű hely a távmunkára. A Hotel La Rosa Negra teakonyhával és nappalival rendelkező apartmanokat, az egész épületben ingyenes WiFit, csendes teraszt és egy strandot kínál az ebédszünethez.",
     "7 vagy több éjszakás tartózkodás esetén kedvezményes árakat kínálunk, egy hónapra vagy hosszabb időre pedig személyre szabott árat heti takarítással — írjon nekünk a dátumokkal."
    ],
    "facts": [
     {
      "label": "Apartmanok",
      "value": "Teakonyha, nappali, erkély"
     },
     {
      "label": "WiFi",
      "value": "Ingyenes, optikai internet minden szobában és a teraszon"
     },
     {
      "label": "Hosszú tartózkodás árai",
      "value": "7+ éjszaka kedvezménnyel, havi ár kérésre"
     },
     {
      "label": "Továbbá",
      "value": "Félpanzió, medence, ingyenes garázs"
     }
    ],
    "faq": [
     {
      "q": "Elég jó a WiFi videóhívásokhoz?",
      "a": "Igen — optikai internetkapcsolat WiFivel minden szobában és a teraszon; a recepció csendes helyet is tud ajánlani hívásokhoz."
     },
     {
      "q": "Tudok főzni a szobában?",
      "a": "Az apartmanok teakonyhával rendelkeznek főzőlappal, hűtővel és vízforralóval. Ha inkább nem főzne, a félpanzió akkor is benne van az árban."
     },
     {
      "q": "Hogyan kaphatok havi árat?",
      "a": "Írjon a larosaulcinj@gmail.com címre a dátumaival és a kívánt szobatípussal — 24 órán belül személyre szabott ajánlattal válaszolunk."
     }
    ]
   },
   {
    "slug": "cheap-hotel-ulcinj",
    "filter": "budget",
    "title": "Olcsó hotel Ulcinjban a tengerparton — már €40-tól",
    "metaTitle": "Olcsó tengerparti hotel Ulcinjban €40-tól — La Rosa Negra, Velika Plaža",
    "metaDescription": "Kedvező árú szobák már €40 / éjszaka ártól félpanzióval, medencével és ingyenes parkolással — 2 percre Velika Plažától. Az őszintén olcsó hotel Ulcinjban: foglaljon közvetlenül, spóroljon 15 %-ot.",
    "intro": [
     "Az olcsó nem kell, hogy a strandtól távolit jelentsen. Economy kétágyas szobáink és egyágyas szobáink már €40 / éjszaka ártól elérhetők, és továbbra is tartalmazzák a svédasztalos reggelit, a vacsorát, a medencét és a garázst — ugyanaz a strand, ugyanazok a naplementék, mint a tengerre néző szobák esetében.",
     "A közvetlen foglalás ezen az oldalon mindig legalább 15 %-kal olcsóbb, mint a Booking.com-on, a júniusi és szeptemberi early bird kódokkal pedig további 10 % kedvezmény jár."
    ],
    "facts": [
     {
      "label": "Ettől az ártól",
      "value": "€40 / éjszaka, félpanzióval"
     },
     {
      "label": "Közvetlen megtakarítás",
      "value": "≥ 15 % a Booking.com-hoz képest"
     },
     {
      "label": "Early bird",
      "value": "−10 % júniusi és szeptemberi kódokkal"
     },
     {
      "label": "Tartalmazza",
      "value": "Medence, parkolás, WiFi, vacsora"
     }
    ],
    "faq": [
     {
      "q": "Melyik a legolcsóbb szoba?",
      "a": "A kis egyágyas szoba €40-tól és az Economy kétágyas szoba erkéllyel (kilátás nélkül) €60-tól — mindkettő félpanzióval."
     },
     {
      "q": "Miért olcsóbb a közvetlen foglalás?",
      "a": "A közvetlen foglalások után nem fizetünk jutalékot, és a megtakarítást Önnek adjuk tovább; emellett ingyenes lemondást is kap érkezés előtt 24 óráig."
     },
     {
      "q": "Mikor a legolcsóbb Ulcinj?",
      "a": "Májusban, júniusban, szeptemberben és októberben — remek időjárás, meleg tenger és akár 40 %-kal alacsonyabb árak, mint júliusban és augusztusban."
     }
    ]
   },
   {
    "slug": "hotel-with-parking-ulcinj",
    "filter": "all",
    "title": "Hotel ingyenes parkolással Ulcinjban",
    "metaTitle": "Hotel ingyenes parkolással Ulcinjban — 60 férőhelyes garázs | La Rosa Negra",
    "metaDescription": "Privát, 60 férőhelyes garázs minden árban benne van, 2 percre Velika Plažától. Hotel ingyenes parkolással Ulcinjban — ideális montenegrói és albániai autós utakhoz.",
    "intro": [
     "Dubrovnikból, Podgoricából vagy Tiranából érkezik autóval? A Hotel La Rosa Negrának saját, 60 férőhelyes garázsa van, amely minden vendég számára ingyenes — főszezonban nincs utcai parkolási stressz, és az autó árnyékban marad.",
     "A hoteltől 5 km az Óváros, 20 perc Ada Bojana, 45 perc a Šasko-tó, és egy óra Bar és a Skadari-tó — Velika Plaža tökéletes bázis egy montenegrói autós körutazáshoz."
    ],
    "facts": [
     {
      "label": "Parkolás",
      "value": "60 férőhelyes privát garázs, ingyenes"
     },
     {
      "label": "EV",
      "value": "Töltés kérésre"
     },
     {
      "label": "Távolságok",
      "value": "Óváros 5 km · Ada Bojana 15 km · Bar 30 km"
     },
     {
      "label": "Határ",
      "value": "Albánia (Muriqan) 25 perc"
     }
    ],
    "faq": [
     {
      "q": "Kell parkolóhelyet foglalnom?",
      "a": "Nem — a garázs benne van az árban, és minden szobához jut hely. Abban a ritka esetben, ha megtelne, a hotel mellett ingyenes parkolás áll rendelkezésre."
     },
     {
      "q": "Tölthetem az elektromos autót?",
      "a": "Igen, kérésre a recepción (normál csatlakozóval); gyorstöltők Ulcinj városában érhetők el."
     },
     {
      "q": "Könnyű az út Dubrovnikból?",
      "a": "Kb. 3 óra 30 perc a tengerpart mentén Budva és Bar érintésével; júliusban és augusztusban a horvát határnál számoljon plusz idővel."
     }
    ]
   },
   {
    "slug": "hotels-in-ulcinj",
    "filter": "all",
    "title": "Szállodák Ulcinjban: melyik környéket válasszuk",
    "metaTitle": "Szállodák Ulcinjban — Hol érdemes megszállni és milyen árakon | La Rosa Negra",
    "metaDescription": "Szállodák Ulcinjban, Montenegróban: Óváros vs Velika Plaža vs Ada Bojana, mennyibe kerülnek a szobák szezonban, és egy családi üzemeltetésű hotel 2 percre a Long Beach-től.",
    "intro": [
     "Ulcinj (Ulqin) három egészen különböző szálláshelyi körzetet kínál. Az Óváros és Mala Plaža élénk és történelmi hangulatú, a várfalakon éttermekkel, de sok lépcsővel, forgalommal és júliusban, augusztusban szinte semennyi parkolóhellyel. Velika Plaža (Long Beach) és a mögötte fekvő Štoj-síkság lapos, nyugodt és családbarát, 13 km sekély homokos partszakasszal és a város újabb szállodáinak többségével. Ada Bojana, a strand legtávolabbi végén, egy eldugott folyami sziget kiteszörfösöknek és naturistáknak.",
     "A Hotel La Rosa Negra a Velika Plaža oldalán található: egy családi üzemeltetésű 3 csillagos hotel, kb. 2 perc sétára a homoktól, 5 km-re az Óvárostól. Az ár félpanziót tartalmaz (svédasztalos reggeli és vacsora), szabadtéri medencét, WiFit és egy 60 férőhelyes privát garázst. A szobák ára €40–150 éjszakánként szezontól és kilátástól függően, és közvetlen foglalás esetén 10%-kal alacsonyabb, mint a Booking.com-os árunk."
    ],
    "facts": [
     {
      "label": "Környékek",
      "value": "Óváros · Velika Plaža / Štoj · Ada Bojana"
     },
     {
      "label": "Jellemző árak",
      "value": "3 csillagos hotelszobák €40–150 / éjszaka, félpanzióval"
     },
     {
      "label": "Elhelyezkedésünk",
      "value": "2 perc a homokig, 5 km az Óvárosig"
     },
     {
      "label": "Megközelítés",
      "value": "Podgorica vagy Tivat repülőtér ≈ 90 perc, Tirana 2 óra"
     }
    ],
    "faq": [
     {
      "q": "Ulcinj melyik része a legjobb tengerparti nyaraláshoz?",
      "a": "Velika Plaža. A homok finom, a víz több tíz méteren át sekély, a strandéttermek napágyakat adnak bérbe, a környék pedig sík és könnyen bejárható gyerekekkel vagy autóval. Az Óváros inkább városnéző pihenéshez jobb: több az étterem és az éjszakai élet, de a strandok ott kicsik és kavicsosak, a parkolás pedig nehéz."
     },
     {
      "q": "Mennyibe kerül egy hotel Ulcinjban?",
      "a": "Júliusban és augusztusban egy kétágyas szoba egy 3 csillagos hotelben általában €90–150 / éjszaka; júniusban és szeptemberben €60–100; tavasszal és ősszel kb. €40-tól. Az áraink tartalmazzák a reggelit és vacsorát, a medencét és a parkolást, ezért az összköltséget érdemes összehasonlítani, nem csak a szobaárat."
     },
     {
      "q": "Hogyan jutok el a repülőtérről egy Velika Plažán lévő hotelbe?",
      "a": "Podgorica (TGD) és Tivat (TIV) repülőtere kb. 80 km-re / 90 percre van; Tirana (TIA) 130 km / 2 óra a Muriqan határátkelőn át. Szervezünk privát transzfert €80 egy útra, vagy busszal is eljuthat Ulcinjba, majd taxival (kb. €10) az utolsó 4 km-re."
     }
    ]
   },
   {
    "slug": "velika-plaza-hotels",
    "filter": "all",
    "title": "Hotelek Velika Plažán (Long Beach), Ulcinj",
    "metaTitle": "Velika Plaža hotelek — Long Beach Ulcinj | La Rosa Negra",
    "metaDescription": "Hotelek Velika Plažán, Ulcinjban: 13 km sekély homokos part, milyen közel vannak valójában a hotelek a vízhez, havi árak, és egy családi üzemeltetésű hotel 2 percre a strandtól.",
    "intro": [
     "Velika Plaža — Long Beach, Plazhi i Madh — kb. 13 km hosszan húzódik Port Milenától a Bojana folyóig. Ez az Adria keleti partvidékének leghosszabb strandja, és az egyik legsekélyebb is: a víz több tíz méteren át térdig ér, ezért választják a kisgyerekes családok. Maga a strand védett és nagyrészt beépítetlen, ezért a hotelek a parti út mögött, Štojban és Donji Štojban állnak, rövid sétára a homoktól.",
     "A Hotel La Rosa Negra is ezek közé tartozik: kb. 2 perc sétára a víztől, szabadtéri medencével, minden árban benne foglalt félpanzióval, ingyenes WiFivel és egy 60 férőhelyes privát garázzsal. Sok szobához tengerre néző erkély tartozik. Az Óváros, Ulcinj éttermei és a buszpályaudvar 4–5 km-re vannak — 10 perc autóval vagy a nyári strandbusszal."
    ],
    "facts": [
     {
      "label": "A strand",
      "value": "≈13 km finom szürke homok, nagyon sekély, vízimentők júl.–aug."
     },
     {
      "label": "Távolság a homokig",
      "value": "Kb. 2 perc séta a hoteltől"
     },
     {
      "label": "Tenger hőmérséklete",
      "value": "22–26 °C júniustól szeptemberig"
     },
     {
      "label": "Programok",
      "value": "Kiteszörfözés az Ada Bojana felőli részen, strandéttermek, kerékpárút"
     }
    ],
    "faq": [
     {
      "q": "Vannak hotelek közvetlenül Velika Plaža homokján?",
      "a": "Nincsenek. A strand védett természeti övezet, ezért a hotelek és apartmanok a parti út mögött, Štojban és Donji Štojban találhatók. A legközelebbiek, köztük a Hotel La Rosa Negra, kb. 150 m-re — 2 perc sétára — vannak a víztől."
     },
     {
      "q": "Milyen messze van Velika Plaža Ulcinj Óvárosától?",
      "a": "A strand kb. 1,5 km-rel a várostól délkeletre kezdődik; a mi szakaszunk 5 km-re van az Óvárostól — nagyjából 10 perc autóval vagy taxival (kb. €10). Júliusban és augusztusban strandbusz jár a parti úton."
     },
     {
      "q": "Mikor a legjobb Velika Plažán megszállni?",
      "a": "Júniusban és szeptemberben meleg a tenger (23–25 °C), nyugodtabbak a strandok, és az árak 30–40%-kal alacsonyabbak, mint augusztusban. Július és augusztus a legmelegebb és a legforgalmasabb. Októbertől májusig a strand szinte üres, és sok strandétterem bezár; a hotel téli árakkal nyitva marad."
     }
    ]
   },
   {
    "slug": "sea-view-hotel-ulcinj",
    "filter": "couples",
    "title": "Tengerre néző hotelszobák Ulcinjban",
    "metaTitle": "Tengerre néző hotel Ulcinjban — Erkélyes szobák | La Rosa Negra",
    "metaDescription": "Tengerre néző, erkélyes szobák Ulcinjban, 2 percre Velika Plažától: mely szobák néznek a vízre, árak szezon szerint, félpanzióval. Foglaljon közvetlenül és spóroljon 10%-ot.",
    "intro": [
     "A hotel a sík Štoj-síkságon áll Velika Plaža mögött, így az itteni tengeri kilátás a nyílt Adriára nyílik a dűnék és strandéttermek fölött, nem pedig egy sziklatetői panoráma. A „sea view” jelölésű szobák délnyugat felé, a víz irányába néznek, és innen látható a naplemente; a másik oldali szobák a medencére és a Rumija-hegységre néznek. Minden erkélyen van egy asztal és két szék.",
     "A tengerre néző kétágyas szobák a legkeresettebbek júliusban és augusztusban, ezért érdemes korán foglalni. Minden ár tartalmazza a félpanziót, a szabadtéri medencét, a WiFit és a garázsparkolást; a közvetlen foglalások 10%-kal olcsóbbak, mint a Booking.com-os árunk, és a választott díjszabás szerint módosíthatók vagy lemondhatók."
    ],
    "facts": [
     {
      "label": "Kilátás",
      "value": "Adria a dűnék fölött, naplementés oldal"
     },
     {
      "label": "Erkély",
      "value": "Privát, asztallal és két székkel"
     },
     {
      "label": "Strand",
      "value": "Kb. 2 perc séta"
     },
     {
      "label": "Árkülönbség",
      "value": "Jellemzően €10–20 / éjszaka a medencére néző szobákhoz képest"
     }
    ],
    "faq": [
     {
      "q": "Látszik a tenger a szobából?",
      "a": "A tengerre néző szobákból igen — a nyílt Adria látható a dűnéken és a strandéttermeken túl, kb. 150 m-re. A földszinti szobákból kevesebb látszik; a felsőbb szintekről a legtisztább a kilátás. Ha fontos Önnek a kilátás, írja be a foglalási megjegyzésbe, és a legjobb elérhető szobát adjuk."
     },
     {
      "q": "Mely szobákból van tengeri kilátás?",
      "a": "Az erkélyes, tengerre néző kétágyas szobákból és néhány családi szobából; az ezen az oldalon szereplő szobanevekben szerepel a „sea view” jelölés, ha a szoba a víz felé néz. A medencére néző szobák kicsit olcsóbbak és este csendesebbek."
     },
     {
      "q": "Megéri tengerre néző szobát foglalni Ulcinjban?",
      "a": "Nyári nyaraláshoz a legtöbb pár szerint igen — az erkélyről nézett naplemente a nap fénypontja. Ha kevés időt tölt a szobában, egy medencére néző szobával €10–20 / éjszaka összeget takaríthat meg ugyanazzal a stranddal és ellátással."
     }
    ]
   },
   {
    "slug": "hotel-ulqin",
    "filter": "family",
    "title": "Hotel Ulqinban koszovói és albániai vendégek számára",
    "metaTitle": "Hotel Ulqin — árak Bajramra és a nyári hetekre | La Rosa Negra",
    "metaDescription": "Családi vezetésű hotel Ulqinban, 2 percre a Plazhi i Madh-tól: aktuális árak Fitër és Kurban Bajramra, Dita e Verësre és a diaszpóra nyári heteire. Albán nyelv a recepción, garázsos parkolás, félpanzió.",
    "intro": [
     "Ulqin Prishtinához és Tiranához a legközelebbi tengerpart: Prishtinából kb. 5 óra a Rruga e Kombit és Shkodër felől, Tiranából 2 óra, Shkodërből pedig 1 óra a Muriqan–Sukobin határátkelőn át. A Hotel La Rosa Negra a város Plazhi i Madh (Velika Plaža) felőli oldalán áll, kb. 2 perc sétára a homoktól — a recepción albánul is beszélnek, a 60 férőhelyes garázs pedig azt jelenti, hogy autója az egész tartózkodás alatt biztonságban van.",
     "Minden ár félpanziót tartalmaz (svédasztalos reggeli és vacsora), kültéri medencét gyermekrésszel, WiFit és parkolást. A családi szobák 3–5 fősek. Lent láthatja az aktuális közvetlen árakat azokra a hetekre, amikor a legtöbb koszovói és albán vendégünk utazik: Fitër és Kurban Bajram, Dita e Verës, február 17. és a július végi, augusztusi diaszpóra-hetek — a közvetlen foglalás 10%-kal olcsóbb, mint a Booking.com-os árunk."
    ],
    "facts": [
     {
      "label": "Prishtinából",
      "value": "≈ 330 km · kb. 5 óra autóval Shkodër felől"
     },
     {
      "label": "Tiranából / Shkodërből",
      "value": "130 km · 2 óra / 45 km · 1 óra"
     },
     {
      "label": "Nyelv és pénznem",
      "value": "Albánul is beszélünk · euró, készpénz és kártya"
     },
     {
      "label": "Tartalmazza",
      "value": "Félpanzió, medence, WiFi, garázsos parkolás"
     }
    ],
    "faq": [
     {
      "q": "Hogyan jutunk el Kosovóból Ulqinba?",
      "a": "Autóval: Prishtina → Rruga e Kombit → Kukës → Shkodër → Muriqan határ → Ulqin, kb. 5 óra; a határ általában gyorsan járható, ha elkerülik az augusztusi péntek és vasárnap esti csúcsidőt. Nyáron naponta indulnak buszok Prishtinából és Tiranából Ulqinba; taxi az ulqini buszpályaudvarról a hotelhez kb. €10."
     },
     {
      "q": "Vannak szobáik a Bajram ünnepekre?",
      "a": "Igen, amikor a hotel nyitva van a szezonban — a májusi Kurban Bajram beleesik, a márciusi Fitër Bajram pedig az adott évtől függ. Az oldalon lévő táblázat minden ünnepre az aktuális árat mutatja; ha azt látja, hogy 'kérésre', írjon nekünk WhatsAppon, és néhány órán belül visszaigazoljuk."
     },
     {
      "q": "A gyerekek is velünk vacsorázhatnak, és halal az étel?",
      "a": "A félpanzió a szobában lakó minden vendégre vonatkozik, a gyerekeket is beleértve. A vacsora svédasztalos, hallal, grillezett hússal, zöldségekkel és salátákkal. Mint a legtöbb ulcinji szálloda, mi is sertéshús nélkül főzünk, és a szálloda alkoholmentes — nyugodt választás, amelyet sok koszovói, albániai és diaszpórában élő család értékel."
     }
    ]
   },
   {
    "slug": "plazhi-i-madh-ulqin",
    "filter": "all",
    "title": "Plazhi i Madh, Ulqin — hotel 2 percre a homoktól",
    "metaTitle": "Plazhi i Madh Ulqin — hotel 2 percre a strandtól | La Rosa Negra",
    "metaDescription": "Plazhi i Madh (Velika Plaža), Ulqin: 13 km sekély homokos part családoknak, árak a Koszovóból és Albániából érkező nyári hetekre, valamint egy családi vezetésű hotel 2 percre a strandtól félpanzióval és medencével.",
    "intro": [
     "A Plazhi i Madh — Velika Plaža, a Hosszú part — 13 km finom, sekély homok Port Milenától a Buna folyóig. A víz több tíz méteren át térdig ér, ezért a koszovói és albán családok generációk óta ide járnak. A strandéttermek napágyakat adnak bérbe (szezonban kb. €10–15 egy szett), júliusban és augusztusban vízimentők dolgoznak, az Ada Bojana felőli vég pedig a kiteszörfösök helye.",
     "A Hotel La Rosa Negra kb. 2 perc sétára van a homoktól, tengerre néző erkélyekkel, kültéri medencével, minden árban benne lévő félpanzióval és saját garázzsal. Ulqin óvárosa az éttermeivel 5 km-re található. Az alábbi árak élőben frissülnek azokra a hetekre, amikor a legtöbb albánul beszélő vendégünk utazik; foglaljon közvetlenül, és 10%-kal kevesebbet fizet, mint a Booking.com-on."
    ],
    "facts": [
     {
      "label": "A strand",
      "value": "13 km sekély homok · vízimentők júl.–aug."
     },
     {
      "label": "Távolság a hoteltől",
      "value": "Kb. 2 perc gyalog"
     },
     {
      "label": "Tenger",
      "value": "23–26 °C júniustól szeptemberig"
     },
     {
      "label": "Óváros",
      "value": "5 km · taxi kb. €10 · nyári strandbusz"
     }
    ],
    "faq": [
     {
      "q": "Jó a Plazhi i Madh kisgyerekeknek?",
      "a": "Ez ennek a partszakasznak a legsekélyebb strandja — a homok nagyon enyhén mélyül, így a gyerekek a parttól messze is térdig érő vízben játszhatnak. Déltájban vigyenek árnyékolót; a hotelben gyermekmedence-rész is van."
     },
     {
      "q": "Mennyire zsúfolt augusztusban?",
      "a": "A diaszpóra-hetek (július vége–augusztus közepe) az év legforgalmasabb időszakai — foglaljon korán, menjen ki a strandra 10:00 előtt az első soros napágyakért, és számítson sorokra a Muriqan határon péntek és vasárnap este. Augusztus vége és szeptember sokkal nyugodtabb, ugyanazzal a meleg tengerrel."
     },
     {
      "q": "Hol parkolunk?",
      "a": "A 60 férőhelyes saját garázsunkban, ami benne van az árban. Magán a strandhoz vezető úton a parkolás fizetős és nyáron kevés a hely, ezért a legtöbb vendég a hotelnél hagyja az autót és gyalog megy."
     }
    ]
   },
   {
    "slug": "halal-friendly-family-hotel-ulcinj",
    "filter": "family",
    "title": "Alkoholmentes családi hotel Ulcinjban, 2 percre Velika Plažától",
    "metaTitle": "Alkoholmentes családi hotel Ulcinjban (Ulqin), Velika Plaža közelében | La Rosa Negra",
    "metaDescription": "Nyugodt családi hotel Ulcinj / Ulqinban, 2 percre Velika Plažától (Plazhi i Madh): félpanzió, medence gyermekrésszel, ingyenes garázs, albán nyelven is beszélünk, alkoholt nem szolgálunk fel. Élő árak Bajram idejére és a diaszpóra nyári heteire.",
    "intro": [
     "A Hotel La Rosa Negra egy családi vezetésű, háromcsillagos hotel Ulcinj Velika Plaža (Plazhi i Madh) felőli oldalán, körülbelül 2 perc sétára a homoktól. Nyugodt hely: nincs bárhangulat, nem szolgálunk fel alkoholt, a gyerekek a medence és a strand között szaladgálnak, a szülők pedig a teraszon kávéznak. Kosovóból, Albániából, Észak-Macedóniából, valamint a németországi, svájci és ausztriai diaszpórából érkező családok évről évre visszatérnek — közülük sokan minden nyáron ugyanarra a két hétre.",
     "A félpanzió minden árban benne van — svédasztalos reggeli és svédasztalos vacsora hallal, grillezett hússal, zöldségekkel, salátákkal és édességekkel, úgy elkészítve, ahogy Ulcinj konyháiban szokás; a vacsoránál az italok gyümölcslevek, üdítők, víz, kávé és tea. A családi szobák 3–5 fősek, a szabadtéri medencének van gyermekrésze, a 60 férőhelyes garázs ingyenes, a recepción pedig albánul, montenegróiul, angolul és németül beszélünk. Alább láthatja az élő közvetlen árakat azokra a hetekre, amikor vendégeink a leggyakrabban utaznak — Fitër és Kurban Bajram, Dita e Verës, valamint a július végi és augusztusi diaszpóra-hetek idejére — mindig 10%-kal a Booking.com-os árunk alatt."
    ],
    "facts": [
     {
      "label": "Családok",
      "value": "3–5 fős szobák · gyermekmedence · 2 perc a strandig"
     },
     {
      "label": "Hangulat",
      "value": "Csendes, alkoholmentes hotel · teraszkávézó"
     },
     {
      "label": "Benne van",
      "value": "Félpanzió, medence, WiFi, parkolás a garázsban"
     },
     {
      "label": "Nyelvek",
      "value": "Albán, montenegrói, angol, német"
     }
    ],
    "faq": [
     {
      "q": "Megfelelő az étel muszlim családok számára?",
      "a": "Igen — mint Ulcinj legtöbb hoteljében, a mi konyhánkban sem főzünk sertéshússal, és sem a konyhában nem használunk alkoholt, sem a hotelben nem szolgálunk fel. Hivatalos halal tanúsítvánnyal nem rendelkezünk; ha ez fontos Önnek, foglalás előtt írjon nekünk, és őszintén elmondjuk, honnan szerezzük be a húst."
     },
     {
      "q": "Tényleg nincs alkohol, még a szobai hűtőben vagy a teraszon sem?",
      "a": "Így van — a hotel alkoholmentes. A szobai hűtők üresek, hogy saját italait tarthassa bennük, a kávézó kávét, teát, friss gyümölcsleveket és üdítőket kínál, vacsoránál és a teraszon pedig semmilyen alkoholos ital nem kapható. Azok a vendégek, akik szeretnének egy pohár bort, a 150 m-re lévő strandéttermekben megtalálják."
     },
     {
      "q": "Jöhetünk Bajram idején vagy a nyári szünetben nagy családdal?",
      "a": "Igen. A családi szobák legfeljebb 5 fő számára alkalmasak, és ha nagyobb csoporttal utaznak, jelezzék nekünk, és igyekszünk egymás melletti szobákban elhelyezni Önöket. Az oldalon található táblázat az élő árakat mutatja Kurban Bajram, Fitër Bajram és a diaszpóra-hetek idejére — ha egy sorban az szerepel, hogy 'kérésre', küldjön nekünk WhatsApp-üzenetet, és néhány órán belül visszaigazoljuk."
     }
    ]
   }
  ]
 }
};

export const TOPIC_SLUGS = topics.en.topics.map((t) => t.slug);
export const getTopics = (lang) => topics[lang] || topics.en;
export const getTopic = (lang, slug) => getTopics(lang).topics.find((t) => t.slug === slug) || topics.en.topics.find((t) => t.slug === slug);
// Which rooms belong to a topic page (room = /api/rooms item).
export const TOPIC_ROOM_FILTERS = {
  all: () => true,
  family: (r) => (r.guests || 0) >= 3,
  pool: (r) => /pool/i.test((r.name_en || r.name || '') + ' ' + (r.amenities || []).join(' ')) || (r.guests || 0) <= 2,
  couples: (r) => (r.guests || 0) === 2 && /sea|balcony|terrace/i.test((r.name_en || r.name || '') + ' ' + (r.amenities || []).join(' ')),
  longstay: (r) => /apartment|kitchen/i.test((r.name_en || r.name || '') + ' ' + (r.amenities || []).join(' ')),
  budget: (r) => (r.price || 0) <= 80,
};
export const topicRooms = (slug, rooms) => { const t = topics.en.topics.find((x) => x.slug === slug); const f = TOPIC_ROOM_FILTERS[(t && t.filter) || 'all'] || TOPIC_ROOM_FILTERS.all; const out = (rooms || []).filter(f); return (out.length ? out : rooms || []).slice().sort((a, b) => (a.price || 0) - (b.price || 0)); };
